import { ref } from 'vue'

export const translations = {
  /* ───────────── FRANÇAIS ───────────── */
  fr: {
    nav: {
      home: 'Accueil',
      scan: 'Scanner',
      tickets: 'Tickets',
      wallet: 'Portefeuille',
      alerts: 'Alertes',
      profile: 'Profil'
    },
    auth: {
      login: 'Connexion',
      create: 'Créer un compte',
      email: 'Email',
      password: 'Mot de passe',
      confirm_password: 'Confirmer le mot de passe',
      email_placeholder: 'votre@email.com',
      password_placeholder: '••••••••',
      signin: 'Se connecter',
      forgot_password: 'Mot de passe oublié ?',
      no_account: 'Pas de compte ? Créer un compte',
      have_account: 'Déjà un compte ? Se connecter',
      google: 'Continuer avec Google',
      apple: 'Continuer avec Apple',
      fill_all_fields: 'Veuillez remplir tous les champs',
      passwords_not_match: 'Les mots de passe ne correspondent pas',
      auth_error: 'Erreur lors de l\'authentification',
      login_success: 'Connexion réussie',
      account_created: 'Compte créé avec succès',
      enter_email_reset: 'Entrez votre email pour réinitialiser le mot de passe',
      reset_email_sent: 'Si ce compte existe, un email de réinitialisation a été envoyé.',
      google_dev: '🚧 Connexion Google en cours de développement',
      apple_dev: '🚧 Connexion Apple en cours de développement',
      or: 'ou',
      legal_text: 'En continuant, vous acceptez nos CGU et Politique de confidentialité.',
      cgu: 'CGU',
      privacy_policy: 'Politique de confidentialité',
      subtitle: 'Vos économies, simplifiées',
      register_tab: 'Inscription',
      display_name: 'Nom d\'affichage',
      display_name_placeholder: 'Votre nom',
      password_min_placeholder: 'Minimum 8 caractères',
      confirm_password_placeholder: 'Répétez le mot de passe',
      creating: 'Inscription...',
      signing_in: 'Connexion...',
      switch_to_register: 'Pas encore de compte ? Inscrivez-vous',
      switch_to_login: 'Déjà un compte ? Connectez-vous',
      create_my_account: 'Créer mon compte',
      continue_as_guest: 'Continuer en tant qu\'invité',
      password_min_error: 'Le mot de passe doit contenir au moins 8 caractères',
      login_error_msg: 'Erreur de connexion',
      email_not_confirmed: 'Veuillez confirmer votre email avant de vous connecter. Vérifiez vos spams.',
      register_error_msg: 'Erreur d\'inscription',
      social_dev_msg: '🚧 Connexion {provider} en cours de développement',
      show_password: 'Afficher le mot de passe',
      hide_password: 'Masquer le mot de passe',
      forgot_password_success: 'Email envoyé ! Vérifiez votre boîte mail.',
      country: 'Pays',
      country_placeholder: 'Sélectionnez votre pays',
      age_warning: 'Cette application est réservée aux personnes de 16 ans et plus.',
      age_consent: 'Je confirme avoir au moins 16 ans',
      terms_consent: 'J\'accepte les CGU et la Politique de confidentialité',
      consent_required: 'Vous devez confirmer votre âge et accepter les conditions pour vous inscrire',
      rgpd_consent: 'J\'accepte que mes données personnelles soient traitées conformément au RGPD / PIPEDA',
      email_confirm_title: 'Vérifiez votre email',
      email_confirm_sent: 'Un email de confirmation a été envoyé à :',
      email_confirm_spam: '⚠️ Vérifiez vos spams / courriers indésirables si vous ne le recevez pas dans 2 minutes.',
      email_confirm_hint: 'Cliquez le lien dans l\'email pour activer votre compte, puis connectez-vous ici.'
    },
    app: {
      offline_mode: 'Mode hors-ligne',
      offline_cached_data: 'Données en cache affichées',
      back_online: 'Connexion rétablie',
      cookie_msg: 'Nous utilisons des cookies essentiels au fonctionnement de l\'application. En continuant, vous acceptez notre politique de confidentialité.',
      cookie_accept: 'Accepter',
      cookie_decline: 'Refuser',
      download_data: 'Télécharger mes données',
      delete_account: 'Supprimer mon compte'
    },
    export: {
      title: 'Exporter mes données',
      period: 'Période',
      period_7d: '7 jours',
      period_30d: '30 jours',
      period_90d: '3 mois',
      period_all: 'Tout',
      format: 'Format',
      preview: 'Aperçu',
      col_date: 'Date',
      col_type: 'Type',
      col_amount: 'Montant',
      col_currency: 'Devise',
      col_status: 'Statut',
      col_desc: 'Description',
      transactions: 'transactions',
      total: 'Total',
      loading: 'Chargement...',
      error: 'Erreur de chargement',
      download: 'Télécharger'
    },
    budget: {
      title: 'Budget mensuel',
      monthly_budget: 'Budget mensuel',
      used: 'utilisé',
      remaining: 'Reste',
      alert: 'Budget presque atteint',
      vs_last_month: 'vs mois dernier',
      last_3_months: '3 derniers mois',
      details: 'Détails',
      tickets: 'Tickets',
      cashback: 'Cashback',
      edit_title: 'Modifier le budget',
      monthly_limit: 'Limite mensuelle',
    },
    onboarding: {
      guest: 'Invité',
      title: 'Recash',
      subtitle: 'Scannez. Protégez votre santé. Récupérez votre argent.',
      scan_instant: 'Scan Instantané et Scan Multi-Tickets',
      scan_description: 'Photo ticket ou code-barres, l\'IA extrait tout en 3s.',
      health_alerts: 'Alertes Santé Live',
      health_description: 'Allergènes cachés & rappels produits : soyez informé.',
      cashback: 'Cashback Automatique',
      cashback_description: 'Épicerie, pharmacie, électronique, vêtements... Tous types de magasins',
      start_button: 'Commencer à économiser',
      legal_text: 'En continuant, vous acceptez nos',
      terms: 'CGU',
      and: '&',
      privacy: 'Politique de confidentialité',
      slide1_title: 'Bienvenue sur Recash',
      slide1_desc: 'L’app qui scanne vos tickets, protège votre santé et vous fait gagner de l’argent à chaque achat.',
      slide2_title: 'Liste de Courses',
      slide2_desc: 'Permet d\'enregistrer votre liste de courses et de la gérer facilement.',
      slide3_title: 'Notifications Instantanées',
      slide3_desc: 'Recevez une alerte dès que votre cashback est crédité, quand votre budget approche la limite, ou lors d’un rappel produit.',
      slide4_title: 'Partagez Vos Listes',
      slide4_desc: 'Envoyez votre liste de courses à votre famille ou vos proches en un tap. Idéal pour les achats groupés.',
      slide5_title: 'Protection Double Prix & Spéciaux',
      slide5_desc: 'Recash détecte automatiquement un double prix sur votre Ticket.',
      skip: 'Passer',
      next: 'Suivant',
      get_started: 'C\'est parti !',
      or_guest: 'Continuer sans compte',
      all_stores: 'Tous types de magasins',
      referral_code_label: 'Code de parrainage (optionnel)',
      referral_code_placeholder: 'Entrez le code…',
      health_title: 'Santé',
      health_desc: 'Allergènes, additifs, rappels produits',
      regions: 'Recash en Amérique du nord, Amérique Latine, et Europe'
    },
    home: {
      greeting: 'Bonjour !',
      hero_title: 'Vos économies<br>en un scan',
      monthly_savings: 'Économisé ce mois',
      total_retrieved: 'Gains totaux',
      scan_ticket: 'Scanner<br>un ticket',
      scan_product: 'Scanner<br>un produit',
      my_wallet: 'Mon<br>portefeuille',
      guide: "Guide<br>d'utilisation",
      wallet_balance: 'Solde disponible',
      view_wallet: 'Voir le portefeuille',
      critical_alerts: 'Alertes critiques',
      recent_receipts: 'Tickets récents',
      no_alerts: 'Aucune alerte',
      no_tickets: 'Aucun ticket scanné',
      scan_first: 'Scannez votre premier ticket !',
      wallet_available: 'Portefeuille disponible',
      active_alerts: 'Alertes actives',
      cta_subtitle: 'Récupérez votre argent en secondes',
      recall_product: 'Rappel produit',
      warranty: 'Garantie',
      cashback: 'cashback',
      allergen: 'allergène',
      health_score_title: 'Score santé du mois',
      health_good: 'Bon',
      health_improve: 'À améliorer',
      critical: 'critique',
      product: 'produit',
      ultra_processed: 'ultra-transformé',
      see_all: 'Voir tout',
      details: 'Détails',
      health_score: 'Score Santé',
      out_of: 'sur 100',
      score_good: '👍 Bon',
      score_improve: '👎 À améliorer',
      allergens: 'Allergènes',
      ultra_processed_plural: 'Ultra-transformés',
      alerts: 'Alertes',
      recall: 'Rappel',
      warranty_label: 'Garantie',
      available_in: 'Disponible dans',
      store: 'Magasin',
      pending_cashbacks: 'Cashbacks en attente',
      no_pending: 'Aucun cashback en attente',
      recent_transactions: 'Transactions récentes',
      no_transactions: 'Aucune transaction',
      withdraw: 'Virer',
      add: 'Ajouter',
      scan: 'Scanner',
      tickets: 'Tickets',
      active: 'Actif',
      currency: 'Devise',
      total_earnings: 'Gains totaux',
      account_required: 'Compte requis',
      account_desc: 'Créez un compte gratuit pour accéder à votre wallet et suivre vos cashbacks.',
      create_account: 'Créer un compte',
      view_offers: 'Voir les offres',
      loading_wallet: 'Chargement de votre wallet...',
      error: 'Erreur',
      retry: 'Réessayer',
      profile_title: 'Profil',
      guest_message: 'Créez un compte gratuit pour personnaliser votre profil et accéder à toutes les fonctionnalités.',
      user: 'Utilisateur',
      stats_tickets: 'Tickets',
      stats_savings: 'Économies',
      stats_alerts: 'Alertes résolues',
      ethical_score: 'Score Éthique',
      savings: 'Économies',
      alerts_resolved: 'Alertes résolues',
      preferences: 'Préférences',
      notifications: 'Notifications',
      language: 'Langue',
      ethical_points: 'Points Éthiques',
      currency_label: 'Devise',
      allergens_title: 'Allergènes',
      allergens_desc: 'Déclarez vos allergènes ou ceux de votre famille pour recevoir des alertes lors du scan de produits.',
      save_allergens: 'Enregistrer mes allergènes',
      allergen_gluten: 'Gluten (blé, seigle, orge)',
      allergen_lactose: 'Lactose / Lait',
      allergen_eggs: 'Œufs',
      allergen_peanuts: 'Arachides',
      allergen_nuts: 'Fruits à coque (amandes, noix, noisettes)',
      allergen_soy: 'Soja',
      allergen_fish: 'Poisson',
      allergen_shellfish: 'Crustacés / Fruits de mer',
      allergen_sesame: 'Sésame',
      allergen_sulfites: 'Sulfites',
      allergen_mustard: 'Moutarde',
      allergen_celery: 'Céleri',
      allergen_lupin: 'Lupin',
      allergen_molluscs: 'Mollusques',
      subscription: 'Abonnement',
      free_plan: 'Accès aux fonctionnalités de base',
      premium_plan: 'Cashback illimité, alertes prioritaires',
      pro_plan: 'Tout Premium + API, support prioritaire',
      view_offers_btn: 'Voir les offres',
      manage: 'Gérer',
      actions: 'Actions',
      support: 'Support',
      legal: 'Mentions légales',
      delete_account: 'Supprimer mon compte',
      logout: 'Se déconnecter',
      logout_confirm: 'Êtes-vous sûr de vouloir vous déconnecter ?',
      cancel: 'Annuler',
      logout_btn: 'Se déconnecter',
      delete_confirm_title: '⚠️ Suppression du compte',
      delete_confirm_msg: 'Cette action est irréversible. Toutes vos données seront supprimées.',
      delete_btn: 'Supprimer',
      delete_error: 'Erreur lors de la suppression',
      upload_error: 'Erreur d\'upload',
      save_success: 'Allergènes enregistrés',
      save_error: 'Erreur lors de l\'enregistrement',
      family_members: 'Membres de la famille',
      family_desc: 'Ajoutez des membres de votre famille avec leurs allergènes.',
      add_member: 'Ajouter un membre',
      member_name: 'Prénom',
      member_age: 'Âge',
      member_allergens: 'Allergènes',
      remove_member: 'Supprimer',
      save_family: 'Enregistrer la famille'
    },
    scan: {
      title: 'Scanner',
      ticket_tab: 'Ticket',
      product_tab: 'Produit',
      take_photo: 'Prendre une photo',
      import_gallery: 'Importer depuis la galerie',
      upload_pdf: 'Téléverser un PDF',
      scan_barcode: 'Appuyez pour scanner un produit',
      scan_ticket: 'Scanner un ticket',
      scan_product: 'Scanner un produit',
      scan_btn: 'Scanner',
      processing: 'Traitement...',
      analyzing: 'Analyse...',
      success: 'Succès',
      error: 'Erreur',
      retry: 'Réessayer',
      capture_ticket: 'Capturez un ticket ou importez un fichier',
      searching_barcode: 'Recherche du code-barres...',
      scanning_hint: '🔍 Détection automatique… pointez vers le code-barres',
      stop_scanner: 'Arrêter',
      enter_barcode: 'Saisir le code-barres',
      uploading: 'Téléversement...',
      analyzing_ai: 'Analyse IA en cours...',
      searching_product: 'Recherche du produit...',
      products_detected: 'Produits détectés',
      validate_save: 'Valider et enregistrer',
      score_excellent: 'Excellent',
      score_good: 'Bon',
      score_average: 'Moyen',
      score_avoid: 'À éviter',
      camera_access_denied: 'Accès caméra refusé',
      analysis_failed: 'L\'analyse a échoué.',
      analysis_timeout: 'Analyse expirée, veuillez réessayer.',
      unknown_product: 'Produit inconnu',
      ticket_saved: 'Ticket enregistré',
      ticket_saved_desc: 'Votre ticket a été analysé et enregistré.',
      view_ticket: 'Voir le ticket',
      scan_another: 'Scanner un autre ticket',
      session_title: 'Session en cours',
      session_count: '{n} ticket(s) scanné(s)',
      view_all_tickets: 'Voir tous mes tickets',
      session_store: 'Magasin inconnu',
      end_session: 'Terminer la session',
      flipp_local_deals: 'Offres en épicerie',
      flipp_valid_until: 'Jusqu\'au',
      flipp_no_deals: 'Aucune offre trouvée près de vous',
      flipp_location_label: 'Offres locales à',
      upload_failed: 'Échec de l\'upload',
      permission_denied: 'Permission refusée',
      barcode_unavailable: 'Scan code-barres non disponible sur PC. Utilisez la saisie manuelle.',
      product_found: 'Produit trouvé',
      product_not_found: 'Impossible de trouver ce produit',
      location_banner: '📍 Pour vous offrir les meilleures offres de votre région, nous utilisons votre position GPS. Vos données restent sur votre appareil et ne sont jamais transmises à des tiers.',
      location_banner_dismiss: 'Compris'
    },
    tickets: {
      title: 'Mes tickets',
      no_tickets: 'Aucun ticket scanné',
      scan_first: 'Scannez votre premier ticket pour commencer',
      date: 'Date',
      store: 'Magasin',
      amount: 'Montant',
      status: 'Statut',
      cashback: 'Cashback',
      pending: 'En attente',
      approved: 'Approuvé',
      rejected: 'Refusé',
      unknown_store: 'Magasin inconnu',
      history: 'Historique',
      history_desc: 'Voir tous vos tickets scannés',
      filter_all: 'Tous',
      filter_active: 'Actifs',
      filter_refunded: 'Remboursés',
      filter_review: 'En révision',
      filter_alerts: 'Alertes',
      scan_ticket: 'Scanner un ticket',
      expires: 'Expire le',
      no_warranty: 'Pas de garantie',
      alert: 'alerte',
      alerts: 'alertes',
      status_processed: 'Traité',
      status_processing: 'En cours',
      status_failed: 'Échoué',
      status_pending: 'En attente',
      status_review: 'En révision',
      default_category: 'Alimentation',
      search_placeholder: 'Rechercher un produit...'
    },
    wallet: {
      title: 'Portefeuille',
      balance: 'Solde',
      available: 'Disponible',
      pending: 'En attente',
      withdrawn: 'Retiré',
      withdraw: 'Virer',
      withdraw_btn: 'Virer l\'argent',
      withdraw_success: 'Virement réussi',
      withdraw_error: 'Erreur lors du virement',
      no_transactions: 'Aucune transaction',
      payment_methods: 'Méthodes de paiement',
      add_payment: 'Ajouter une méthode',
      paypal: 'PayPal',
      bank_account: 'Compte bancaire',
      reserved: 'Réservé aux membres',
      guest_message: 'Portefeuille, virements et cashback sont réservés aux membres Recash. Créez un compte gratuit pour commencer.',
      guest_banner_title: 'Voir le cashback invité',
      guest_banner_desc: 'Inscrivez-vous pour retirer vos gains et accéder à toutes les fonctionnalités.',
      loading: 'Chargement...',
      error_title: 'Erreur',
      pending_cashbacks: 'Cashbacks en attente',
      no_cashback: 'Aucun cashback en attente',
      transactions: 'Transactions',
      withdraw_modal_title: 'Virer vers un compte bancaire',
      amount: 'Montant',
      transfer_method: 'Méthode de transfert',
      status_completed: 'Terminé',
      status_pending: 'En attente',
      status_failed: 'Échoué',
      type: 'Type',
      tickets: 'Tickets',
      add: 'Ajouter',
      scan: 'Scanner',
      no_pending: 'Aucun paiement en attente',
      recent_transactions: 'Transactions récentes',
      scan_ticket: 'Scanner un ticket',
      withdraw_title: 'Virement',
      max: 'Maximum',
      withdraw_method: 'Méthode de virement',
      bank_transfer: 'Virement bancaire',
      iban: 'IBAN',
      add_payment_title: 'Ajouter une méthode de paiement',
      paypal_email: 'Email PayPal',
      load_error: 'Impossible de charger les données du portefeuille',
      invalid_amount: 'Montant invalide',
      insufficient_balance: 'Solde insuffisant',
      fill_destination: 'Veuillez remplir le champ de destination',
      withdrawal_requested: 'Virement demandé avec succès',
      confirm_withdraw: 'Confirmer le virement',
      bank_card: 'Carte bancaire'
    },
    alerts: {
      title: 'Alertes',
      no_alerts: 'Aucune alerte',
      all_alerts: 'Toutes les alertes',
      critical: 'Critique',
      moderate: 'Modéré',
      mild: 'Léger',
      type: 'Type',
      date: 'Date',
      severity: 'Gravité',
      mark_read: 'Marquer comme lu',
      delete: 'Supprimer',
      recall: 'Rappel produit',
      allergen: 'Allergène',
      warranty: 'Garantie',
      filter_all: 'Tous',
      filter_recall: 'Rappels',
      filter_warranty: 'Garanties',
      filter_price: 'Prix',
      filter_cashback: 'Cashback',
      filter_ticket: 'Tickets',
      filter_budget: 'Budget',
      loading: 'Chargement...',
      view_ticket: 'Voir le ticket',
      type_recall: 'Rappel',
      type_warranty: 'Garantie',
      type_price: 'Prix',
      type_cashback: 'Cashback',
      type_ticket: 'Ticket scanné',
      type_cashback_credited: 'Cashback crédité',
      type_budget_warning: 'Alerte budget',
      type_budget_exceeded: 'Budget dépassé',
      severity_critical: 'Critique',
      severity_warning: 'Avertissement',
      severity_info: 'Info',
      product_label: 'Produit : ',
      less_than_hour: 'Il y a moins d\'une heure',
      hours_ago: 'Il y a {h}h',
      yesterday: 'Hier',
      days_ago: 'Il y a {d} jours',
      load_error: 'Impossible de charger les alertes'
    },
    referral: {
      title: 'Parrainage',
      hero_title: 'Invitez vos amis, gagnez des récompenses',
      hero_subtitle: 'Partagez votre code et recevez du cashback dès que votre ami scanne ses premiers tickets',
      you_earn: 'Vous recevez',
      friend_gets: 'Votre ami reçoit',
      trigger_note: 'Récompense déclenchée après {n} tickets scannés par votre filleul',
      your_code: 'Votre code de parrainage',
      copied: 'Code copié !',
      share: 'Partager mon code',
      share_msg: 'Rejoins Recash avec mon code {code} et profite de {days} jours Premium offerts ! Scanne tes tickets, gagne du cashback.',
      stats_title: 'Mes parrainages',
      total_referrals: 'Invités',
      credited: 'Validés',
      total_earned: 'Gagné',
      have_code: 'Vous avez un code ami ?',
      enter_code: 'Entrez le code…',
      apply: 'Appliquer',
      apply_success: '✅ Code appliqué ! {days} jours Premium offerts.',
      apply_error: 'Code invalide ou déjà utilisé',
      load_error: 'Impossible de charger les données de parrainage',
      retry: 'Réessayer'
    },
    shopping_list: {
      title: 'Liste de courses',
      add_placeholder: 'Ajouter un article...',
      add: 'Ajouter',
      empty_title: 'Votre liste est vide',
      empty_subtitle: 'Ajoutez des articles pour commencer',
      scan_to_add: 'Scanner un produit',
      import_from_ticket: 'Importer depuis un ticket',
      search_placeholder: 'Rechercher un produit...',
      clear_checked: 'Supprimer les cochés',
      share: 'Partager la liste',
      items_count: 'article(s)',
      checked_count: 'coché(s)',
      estimated_cashback: 'Cashback estimé',
      delete: 'Supprimer',
      item_added: 'Article ajouté',
      list_cleared: 'Liste nettoyée',
      imported: 'Articles importés depuis le dernier ticket',
      no_recent_ticket: 'Aucun ticket récent à importer',
      qty: 'Qté',
      summary_title: 'Résumé',
      total_items: 'Total articles',
      total_cashback: 'Cashback potentiel',
      quick_action: 'Ma liste 🛒',
      section_title: '🛒 Ma liste de courses',
      view_list: 'Voir la liste',
      pending_items: 'article(s) restant(s)',
      all_done: 'Tout coché !',
      confirm_clear: 'Effacer les articles cochés ?',
      confirm_clear_all: 'Effacer toute la liste ?',
      yes: 'Oui',
      no: 'Non',
      quantity_label: 'Quantité',
      search_products_title: 'Rechercher des produits',
      select_products: 'Sélectionner des produits',
      import_selected: 'Importer les produits sélectionnés',
      no_results: 'Aucun résultat',
      enter_search_terms: 'Entrez au moins 2 caractères'
    },
    profile: {
      title: 'Profil',
      guest_message: 'Créez un compte gratuit pour personnaliser votre profil et accéder à toutes les fonctionnalités.',
      user: 'Utilisateur',
      stats_tickets: 'Tickets',
      stats_savings: 'Économies',
      stats_alerts: 'Alertes résolues',
      my_info: 'Mes informations',
      first_name: 'Prénom',
      last_name: 'Nom',
      email: 'Email',
      email_readonly_note: 'L\'email ne peut pas être modifié',
      phone: 'Téléphone',
      phone_placeholder: '+1 514 555-1234',
      save_info: 'Enregistrer',
      preferences: 'Préférences',
      notifications: 'Notifications',
      language: 'Langue',
      ethical_points: 'Points Éthiques',
      monthly_budget: 'Budget mensuel',
      currency: 'Devise',
      allergens: 'Allergènes',
      allergens_desc: 'Déclarez vos allergènes ou ceux de votre famille pour recevoir des alertes lors du scan de produits.',
      manage_allergens: 'Gérer les allergènes',
      no_allergies_registered: 'Aucun allergène enregistré',
      member_allergens_of: 'Allergènes de',
      add_member: 'Ajouter un membre',
      modal_close: 'Fermer',
      save_allergens: 'Enregistrer les allergènes',
      subscription: 'Abonnement',
      plan_free: 'Gratuit',
      plan_premium: 'Premium',
      plan_pro: 'Pro',
      plan_business: 'Business',
      plan_free_desc: 'Accès aux fonctionnalités de base',
      plan_premium_desc: '50 tickets cashback / mois, alertes prioritaires',
      plan_pro_desc: 'Fonctionnalités avancées pour les professionnels',
      plan_business_desc: 'Tickets cashback illimités, solution complète pour les entreprises',
      view_offers: 'Voir les offres',
      manage: 'Gérer',
      ethical_score: 'Score Éthique',
      local_purchases: 'Achats locaux',
      eco_friendly: 'Écologique',
      fair_trade: 'Commerce équitable',
      actions: 'Actions',
      referral_badge: 'Nouveau',
      guide: 'Guide',
      support: 'Support',
      legal: 'Mentions légales',
      delete_account: 'Supprimer mon compte',
      logout: 'Se déconnecter',
      allergen_gluten: 'Gluten (blé, seigle, orge)',
      allergen_lactose: 'Lactose / Lait',
      allergen_eggs: 'Œufs',
      allergen_peanuts: 'Arachides',
      allergen_nuts: 'Fruits à coque (amandes, noix, noisettes)',
      allergen_soy: 'Soja',
      allergen_fish: 'Poisson',
      allergen_shellfish: 'Crustacés / Fruits de mer',
      allergen_sesame: 'Sésame',
      allergen_sulfites: 'Sulfites',
      allergen_mustard: 'Moutarde',
      allergen_celery: 'Céleri',
      allergen_lupin: 'Lupin',
      allergen_molluscs: 'Mollusques',
      allergens_saved: 'Allergènes enregistrés',
      allergens_error: 'Erreur lors de l\'enregistrement',
      member_added: 'Membre ajouté',
      member_add_error: 'Erreur lors de l\'ajout',
      profile_saved: 'Profil enregistré',
      save_error: 'Erreur lors de l\'enregistrement',
      notifications_enabled: 'Notifications activées ✅',
      notifications_disabled: 'Notifications désactivées',
      notifications_denied: 'Permission refusée. Activez les notifications dans les paramètres de votre navigateur.',
      logout_title: 'Se déconnecter',
      logout_confirm: 'Êtes-vous sûr de vouloir vous déconnecter ?',
      delete_title: 'Supprimer le compte',
      delete_confirm: 'Cette action est irréversible et supprimera toutes vos données.',
      delete_confirm_btn: 'Supprimer',
      delete_error: 'Erreur lors de la suppression',
      upload_error: 'Erreur lors du téléchargement'
    },
    ticket_detail: {
      ticket_of: 'Ticket du',
      loading: 'Chargement du ticket...',
      error: 'Erreur',
      retry: 'Réessayer',
      no_photo: 'Aucune photo disponible',
      total: 'Total',
      status: 'Statut',
      products: 'Produits',
      alerts_section: 'Alertes',
      request_refund: 'Demander un remboursement',
      ticket_photo: 'Photo du ticket',
      close: 'Fermer',
      id_missing: 'ID du ticket manquant',
      cannot_load: 'Impossible de charger le ticket',
      claim_sent: 'Demande envoyée',
      claim_error: 'Erreur lors de la demande',
      status_completed: 'Remboursé',
      status_processed: 'Traité',
      status_processing: 'En cours',
      status_failed: 'Échoué',
      status_pending: 'En attente',
      cashback_pending: 'En attente',
      cashback_approved: 'Approuvé',
      cashback_paid: 'Payé',
      allergen: 'Allergène',
      recall: 'Rappel'
    },
    health_dashboard: {
      title: 'Tableau de bord Santé',
      monthly_score: 'Score mensuel',
      base_score: 'Score de base',
      personalized_score: 'Score personnalisé',
      cumulative_stats: 'Statistiques cumulées',
      health_points: 'Points santé',
      co2_saved: 'CO2 économisé',
      water_saved: 'Eau économisée',
      products_scanned: 'Produits scannés',
      trends: 'Tendances',
      score_trend: 'Tendance du score',
      co2_trend: 'Tendance CO2',
      recent_products: 'Produits récents',
      no_products: 'Aucun produit scanné ce mois'
    },
    ethical: {
      title: 'Points Éthiques',
      ineligible_msg: 'Les points éthiques sont disponibles uniquement au Canada.',
      your_location: 'Votre position',
      unknown: 'Inconnu',
      this_month: 'Ce mois',
      points: 'Points',
      value: 'Valeur',
      choices: 'Choix',
      points_remaining: 'points restants / 100 max',
      total_cumulative: 'Total cumulé',
      earned: 'gagnés',
      double_bonus: 'Double bonus',
      points_per_choice: 'Points/choix',
      recent_activity: 'Activité récente',
      no_activity: 'Aucune activité récente',
      start_scanning: 'Scannez des produits pour accumuler des points éthiques !',
      monthly_history: 'Historique mensuel',
      alternative: 'Alternative'
    },
    common: {
      loading: 'Chargement...',
      error: 'Une erreur est survenue',
      retry: 'Réessayer',
      view_details: 'Voir les détails',
      see_all: 'Voir tout',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      save: 'Enregistrer',
      delete: 'Supprimer',
      close: 'Fermer',
      back: 'Retour',
      yes: 'Oui',
      no: 'Non',
      ok: 'OK',
      search: 'Rechercher',
      selected: 'Sélectionné',
      continue: 'Continuer',
      continue_with: 'Continuer avec {plan}'
    },
    pricing: {
      offers: 'Nos offres', choose_plan: 'Choisissez votre forfait',
      choose_plan_subtitle: 'Des formules adaptées à tous vos besoins',
      redirect_payment: 'Redirection vers le paiement...', free: 'Gratuit',
      per_month: '/ mois', per_year: '/ an', save_2_months: '2 mois offerts', ten_tickets_month: '10 tickets cashback / mois',
      product_scan: 'Scan de produits', basic_alerts: 'Alertes basiques',
      manufacturer_warranties: 'Garanties fabricants', unlimited_cashback: 'Cashback illimité',
      priority_support: 'Support prioritaire', start_free: 'Commencer gratuitement',
      popular: 'Populaire', premium: 'Premium', unlimited_tickets: 'Tickets illimités', tickets_cashback_month: 'tickets cashback / mois', unlimited_tickets_cashback: 'Tickets cashback illimités',
      advanced_alerts: 'Alertes avancées', extended_warranties: 'Garanties étendues',
      choose_premium: 'Choisir Premium', pro: 'Pro', choose_pro: 'Choisir Pro',
      faq_title: 'Questions fréquentes',
      faq_q1: 'Puis-je annuler à tout moment ?', faq_a1: 'Oui, sans engagement ni frais.',
      faq_q2: 'L\'inscription est-elle gratuite ?', faq_a2: 'Oui, l\'inscription est gratuite sur l\'abonnement gratuit et vous avez 10 cashbacks gratuits.',
      faq_q3: 'Comment fonctionne le cashback ?', faq_a3: 'Les remises sont créditées automatiquement dans votre portefeuille.',
      faq_q4: 'Mes données sont-elles sécurisées ?', faq_a4: 'Oui, vos données sont chiffrées et jamais revendues.',
      payment_url_missing: 'URL de paiement manquante', payment_error: 'Erreur lors du paiement',
      pay_with: 'Payer avec',
      pay_card: 'Carte bancaire',
      pay_interac: 'Interac e-Transfert',
      interac_title: 'Paiement par Interac e-Transfert',
      interac_subtitle: 'Envoyez un virement Interac depuis votre application bancaire',
      interac_step1: '1. Ouvrez votre application bancaire',
      interac_step2: '2. Envoyez le montant exact à l’adresse ci-dessous',
      interac_step3: '3. Inscrivez ce code dans le message',
      interac_step4: '4. Votre abonnement sera activé dans les 24 h ouvrables',
      interac_email_label: 'Adresse e-Transfert',
      interac_amount_label: 'Montant à envoyer',
      interac_code_label: 'Code de référence (obligatoire dans le message)',
      interac_expiry: 'Ce code expire dans 72 heures',
      interac_copy: 'Copier',
      interac_copied: 'Copié !',
      interac_confirm: 'J’ai envoyé le virement',
      interac_pending: 'En attente de confirmation',
      interac_pending_desc: 'Dès que nous aurons reçu votre paiement, votre abonnement sera activé automatiquement.',
      interac_error: 'Erreur lors de la création de la demande Interac',
      paypal_subtitle: 'Paiement sécurisé via votre compte PayPal',
      stripe_subtitle: 'Carte Visa, Mastercard, Amex — paiement sécurisé',
      pay_wire: 'Virement bancaire',
      wire_subtitle: 'Virement depuis votre banque — activation sous 24 h',
      wire_title: 'Paiement par virement bancaire',
      wire_bank: 'Banque',
      wire_holder: 'Titulaire du compte',
      wire_institution: 'Institution / Transit',
      wire_account: 'Numéro de compte',
      wire_step1: '1. Connectez-vous à votre banque en ligne',
      wire_step2: '2. Envoyez le montant exact avec ce code en référence',
      wire_step3: '3. Votre abonnement sera activé sous 24 h ouvrables',
      wire_error: 'Erreur lors de la création de la demande de virement'
    },
    anti_waste: {
      title: 'Anti-Gaspillage',
      subtitle: 'Réduisez votre impact environnemental',
      better_packaging: 'Meilleur emballage',
      less_plastic: 'Moins de plastique',
      better_eco_score: 'Meilleur Eco-Score',
      local_product: 'Produit local',
      seasonal_product: 'Produit de saison',
      no_suggestions: 'Aucune suggestion disponible pour ce produit',
      packaging_preferred: 'Emballage à privilégier',
      packaging_preferred_desc: 'Privilégiez les produits avec des emballages recyclables (carton, verre) quand c\'est possible.',
      less_plastic_alt: 'Alternative avec moins de plastique',
      less_plastic_desc: 'Ce produit contient du plastique. Voici une alternative avec un meilleur emballage.',
      better_eco_alt: 'Alternative avec un meilleur Eco-Score',
      better_eco_alt_desc: 'Essayez cette alternative avec un meilleur impact environnemental.',
      prefer_local: 'Privilégiez les produits locaux',
      prefer_local_desc: 'Ce produit vient de loin. Pour les fruits, légumes et produits frais, choisir local réduit l\'empreinte carbone et soutient l\'économie régionale.',
      seasonal_tip: 'Produit de saison',
      seasonal_tip_desc: 'Privilégiez les fruits et légumes de saison pour un meilleur impact environnemental et gustatif.',
      responsible_consumption: 'Consommation responsable',
      responsible_consumption_desc: 'Achetez uniquement ce dont vous avez besoin et privilégiez les produits avec un bon Nutri-Score et Eco-Score.'
    },
    scan_result: {
      price_paid: 'Prix payé :',
      nutri_score: 'Nutri-Score =',
      personalized_score: 'Score personnalisé',
      base_score: 'Score de base',
      personalized_score_label: 'Score personnalisé',
      nutrition_title: 'Valeurs nutritionnelles (pour 100g)',
      sugars: 'Sucres',
      saturated_fat: 'Graisses saturées',
      calories: 'Calories',
      fiber: 'Fibres',
      proteins: 'Protéines',
      sodium: 'Sodium',
      country: 'Pays',
      category: 'Catégorie',
      defects: 'Défauts',
      qualities: 'Qualités',
      additives: 'Additifs',
      palm_oil_detected: '⚠️ Huile de palme détectée',
      contains_additives: 'Ce produit contient {count} additifs',
      allergens: 'Allergènes',
      ingredients: 'Ingrédients',
      comparison_title: 'Comparaison de prix',
      no_market_data: '📊 Données marché insuffisantes pour ce produit.',
      avg_market: 'Moyenne marché',
      cheapest: 'Le moins cher',
      stores_compared: 'magasin(s) comparé(s)',
      where_cheaper: '📉 Où c\'est moins cher',
      best_price_market: '✅ Vous avez acheté ce produit au meilleur prix trouvé sur le marché !',
      same_product_cheaper: 'Même produit moins cher',
      savings: 'Économie :',
      healthier_alternatives: 'Alternatives plus saines',
      best_health_score: 'Meilleur score santé',
      eco_alternatives: 'Alternatives plus écologiques',
      less_co2_impact: 'Moins d\'impact CO2',
      ethical_points: 'Points éthiques',
      ethical_description: 'Gagnez des points éthiques pour vos choix sains et écologiques',
      ethical_value: '💰 100 points = 1 $ CAD',
      points_available: 'Points disponibles',
      grocery_offers: 'Offres en épicerie',
      offers_count: 'offre(s)',
      no_offers: 'Aucune offre',
      no_offers_for: 'Aucune offre trouvée pour',
      in_region: 'dans les circulaires de',
      no_promotion: 'Ce produit n\'est actuellement en promotion dans aucune épicerie locale.',
      compare_online: '🔍 Comparer les prix en ligne',
      cashback_available: 'Cashback disponible',
      disclaimer: 'Suggestions à titre informatif uniquement (Open Food Facts & partenaires). Aucune marque ne paie Recash. Prix et disponibilité peuvent varier.',
      score_excellent: 'Excellent',
      score_good: 'Bon',
      score_mediocre: 'Médiocre',
      score_avoid: 'À éviter',
      score_explanation: 'Score santé sur 100 : plus il est élevé, meilleur pour la santé.',
      defect_too_fat: 'Trop gras',
      defect_moderate_fat: 'Graisses modérées',
      defect_very_caloric: 'Très calorique',
      defect_moderate_caloric: 'Calories modérées',
      defect_too_salty: 'Trop salé',
      defect_too_sugary: 'Trop sucré',
      defect_moderate_sugars: 'Sucres modérés',
      quality_excellent_amount: 'Excellente quantité',
      quality_good_amount: 'Bonne quantité',
      quality_excellent_intake: 'Apport excellent',
      quality_correct_intake: 'Apport correct',
      quality_low_sodium: 'Peu salé',
      error_rate_limit: 'OpenFoodFacts limite les requêtes — veuillez patienter quelques secondes puis réessayez.'
    },
    product: {
      eco_score: 'Eco-Score',
      price_position_best: 'Meilleur prix',
      price_position_competitive: 'Prix compétitif',
      price_position_expensive: 'Prix élevé',
      price_position_overpriced: 'Prix excessif',
      price_position_unknown: 'Prix inconnu'
    },
    guide: {
      title: 'Guide d\'utilisation',
      complete_guide: 'Guide complet',
      subtitle: 'Tout ce que vous devez savoir pour utiliser Recash',
      section_scan_ticket_title: 'Scanner un ticket',
      section_scan_ticket_desc: 'Comment scanner vos tickets de caisse pour obtenir du cashback et suivre vos dépenses.',
      section_scan_product_title: 'Scanner un produit',
      section_scan_product_desc: 'Analysez chaque produit via son code-barres pour connaître sa composition et ses scores.',
      section_scores_title: 'Comprendre les scores',
      section_scores_desc: 'Nutri-Score, NOVA, Eco-Score… tout sur les indicateurs de qualité.',
      section_cashback_title: 'Cashback',
      section_cashback_desc: 'Fonctionnement du cashback, délais de traitement et retraits.',
      section_wallet_title: 'Portefeuille & Retraits',
      section_wallet_desc: 'Gérez votre solde et retirez votre argent via PayPal ou virement bancaire.',
      section_shopping_title: 'Liste de courses',
      section_shopping_desc: 'Créez, gérez et partagez votre liste de courses intelligente.',
      section_budget_title: 'Budget mensuel',
      section_budget_desc: 'Suivez vos dépenses par catégorie et définissez des limites budgétaires.',
      section_antiwaste_title: 'Anti-gaspillage',
      section_antiwaste_desc: 'Réduisez votre impact environnemental avec des suggestions d\'alternatives.',
      section_ethical_title: 'Points Éthiques',
      section_ethical_desc: 'Gagnez des points en choisissant des alternatives éco-responsables.',
      section_alerts_title: 'Alertes & Rappels',
      section_alerts_desc: 'Restez informé des rappels produits, garanties et alertes personnalisées.',
      section_faq_title: 'FAQ',
      section_faq_desc: 'Les questions les plus fréquentes sur Recash.',
      scan_ticket_step1_title: 'Prenez une photo',
      scan_ticket_step1_desc: 'Posez votre ticket à plat sur un fond uni. Assurez-vous que la photo est nette, bien éclairée et sans reflets.',
      scan_ticket_step2_title: 'Importez l\'image',
      scan_ticket_step2_desc: 'Prenez une photo directement depuis l\'app ou importez une image de votre galerie. Les PDFs sont également acceptés.',
      scan_ticket_step3_title: 'Analyse automatique',
      scan_ticket_step3_desc: 'Notre IA analyse votre ticket en quelques secondes : magasin, date, montant total et chaque article avec son prix.',
      scan_ticket_step4_title: 'Découvrez vos gains',
      scan_ticket_step4_desc: 'Recash recherche automatiquement les offres de cashback disponibles pour vos achats. Vous voyez immédiatement le montant récupérable.',
      scan_ticket_step5_title: 'Confirmez et suivez',
      scan_ticket_step5_desc: 'Confirmez les informations et suivez l\'évolution de vos cashbacks dans votre portefeuille. Les fonds sont crédités sous 48h.',
      scan_product_step1_title: 'Scannez le code-barres',
      scan_product_step1_desc: 'Utilisez la caméra de votre téléphone pour scanner le code-barres d\'un produit. Vous pouvez aussi saisir le code manuellement.',
      scan_product_step2_title: 'Analyse instantanée',
      scan_product_step2_desc: 'Recash consulte la base Open Food Facts et affiche : Nutri-Score, NOVA, Eco-Score, ingrédients, allergènes, additifs.',
      scan_product_step3_title: 'Vérifiez les alertes',
      scan_product_step3_desc: 'Si le produit contient un allergène déclaré dans votre profil, une alerte rouge apparaît immédiatement.',
      scan_product_step4_title: 'Comparez les alternatives',
      scan_product_step4_desc: 'Découvrez des produits alternatifs mieux notés, moins chers ou plus sains disponibles dans votre région.',
      score_nutri_name: 'Nutri-Score',
      score_nutri_desc: 'Évalue la qualité nutritionnelle globale d\'un produit de A (meilleur) à E (pire). Basé sur les nutriments et aliments à favoriser/limiter.',
      score_nova_name: 'NOVA',
      score_nova_desc: 'Classe les aliments selon leur degré de transformation : 1 (brut) à 4 (ultra-transformé). Privilégiez les scores 1 et 2.',
      score_eco_name: 'Eco-Score',
      score_eco_desc: 'Évalue l\'impact environnemental du produit de A (très faible impact) à E (très fort impact). Tient compte de l\'emballage, du transport, de la production.',
      score_health_name: 'Score Santé',
      score_health_desc: 'Notre score personnalisé qui combine Nutri-Score, NOVA, Eco-Score et vos préférences santé/allergies pour vous donner une note sur 100.',
      cashback_how_title: 'Comment ça fonctionne ?',
      cashback_how_desc: 'Lorsque vous scannez un ticket, Recash identifie les produits éligibles au cashback — alimentation, électronique, vêtements, pharmacie, maison et plus — parmi nos marques partenaires. La demande est soumise automatiquement.',
      cashback_delays_title: 'Délais de traitement',
      cashback_delays_desc: 'Les cashbacks sont généralement crédités dans les 48h suivant la validation du ticket. Les délais peuvent varier selon les partenaires.',
      cashback_commission_title: 'Commission Recash',
      cashback_commission_desc: 'Recash prend une commission (configurable par l\'administrateur, actuellement 20%) pour couvrir les coûts de développement, APIs et support. Vous recevez toujours la majorité du montant.',
      cashback_withdrawal_title: 'Retrait des fonds',
      cashback_withdrawal_desc: 'Vous pouvez retirer votre argent à tout moment via virement bancaire, PayPal ou Stripe. Le montant minimum de retrait est de 5€/5$/5£.',
      cashback_tracking_title: 'Suivi en temps réel',
      cashback_tracking_desc: 'Consultez votre historique de cashback, les montants en attente et les gains totaux depuis la page Portefeuille.',
      wallet_balance_title: 'Votre solde',
      wallet_balance_desc: 'Votre solde disponible correspond aux cashbacks validés. Les montants "en attente" seront crédités dès validation par nos partenaires.',
      wallet_paypal_title: 'Retrait via PayPal',
      wallet_paypal_desc: 'Entrez votre email PayPal et le montant souhaité. Le virement est automatique et arrive sous 24h sur votre compte PayPal.',
      wallet_bank_title: 'Virement bancaire',
      wallet_bank_desc: 'Fournissez votre IBAN pour un virement direct sur votre compte bancaire. Délai : 1 à 3 jours ouvrés.',
      wallet_delay_title: 'Délais de retrait',
      wallet_delay_desc: 'PayPal : sous 24h. Virement bancaire : 1 à 3 jours ouvrés. Montant minimum : 5€/5$/5£.',
      wallet_tracking_title: 'Historique complet',
      wallet_tracking_desc: 'Consultez toutes vos transactions (cashbacks reçus, retraits effectués) avec leur statut en temps réel.',
      shopping_step1_title: 'Créez votre liste',
      shopping_step1_desc: 'Ajoutez des articles manuellement en tapant leur nom, ou importez les produits de votre dernier ticket scanné en un tap.',
      shopping_step2_title: 'Scannez pour ajouter',
      shopping_step2_desc: 'Scannez le code-barres d\'un produit en magasin pour l\'ajouter directement à votre liste avec ses informations nutritionnelles.',
      shopping_step3_title: 'Gérez en cours de route',
      shopping_step3_desc: 'Cochez les articles au fur et à mesure de vos achats. Ajustez les quantités, supprimez les articles indésirables.',
      shopping_step4_title: 'Partagez votre liste',
      shopping_step4_desc: 'Envoyez votre liste de courses à votre famille ou vos proches en un tap. Idéal pour les courses partagées.',
      budget_set_title: 'Définir votre budget',
      budget_set_desc: 'Fixez un budget mensuel global dans Profil → Budget. Recash calcule automatiquement vos dépenses à partir des tickets scannés.',
      budget_categories_title: 'Catégories',
      budget_categories_desc: 'Vos dépenses sont automatiquement classées par catégorie (alimentation, pharmacie, électronique…) pour un suivi précis.',
      budget_alert_title: 'Alertes budget',
      budget_alert_desc: 'Recevez une notification lorsque vous approchez de votre limite mensuelle. Vous gardez ainsi le contrôle sur vos dépenses.',
      budget_monthly_title: 'Bilan mensuel',
      budget_monthly_desc: 'Consultez votre bilan mensuel avec comparatif par rapport au mois précédent et visualisation graphique de vos dépenses.',
      antiwaste_packaging_title: 'Emballage responsable',
      antiwaste_packaging_desc: 'Recash suggère des alternatives avec un meilleur emballage (carton, verre, sans emballage) pour réduire vos déchets plastiques.',
      antiwaste_local_title: 'Préférer le local',
      antiwaste_local_desc: 'Pour les fruits, légumes et produits frais, choisir local réduit l\'empreinte carbone et soutient l\'économie régionale.',
      antiwaste_seasonal_title: 'Produits de saison',
      antiwaste_seasonal_desc: 'Recash identifie les produits hors saison et suggère des alternatives de saison, meilleures pour l\'environnement et le goût.',
      antiwaste_alternatives_title: 'Alternatives éco',
      antiwaste_alternatives_desc: 'Découvrez des produits similaires avec un meilleur Eco-Score ou un impact environnemental réduit dans votre région.',
      ethical_what_title: 'Que sont les Points Éthiques ?',
      ethical_what_desc: 'Les Points Éthiques récompensent vos choix de consommation responsable. Lorsque vous scannez un produit et qu\'une alternative plus écologique existe, vous gagnez des points.',
      ethical_how_title: 'Comment les gagner ?',
      ethical_how_desc: 'Scannez des produits et choisissez les alternatives recommandées. Plus l\'alternative est vertueuse (bio, local, sans emballage, commerce équitable), plus vous gagnez de points.',
      ethical_value_title: 'Valeur des points',
      ethical_value_desc: 'Chaque point éthique a une valeur monétaire. Vous pouvez les accumuler et les convertir. Le maximum est de 100 points par mois.',
      ethical_availability_title: 'Disponibilité',
      ethical_availability_desc: 'Les Points Éthiques sont actuellement disponibles uniquement au Canada. Nous travaillons à étendre ce programme à d\'autres pays.',
      coming_next_version: 'Disponible dans la prochaine version',
      ethical_coming_soon_desc: 'Les Points Éthiques seront introduits dans la prochaine mise à jour de Recash. Restez connectés !',
      alert_recalls_title: 'Rappels produits',
      alert_recalls_desc: 'Recevez une notification immédiate si un produit que vous avez acheté fait l\'objet d\'un rappel sanitaire (listéria, salmonelle, corps étranger, etc.).',
      alert_warranty_title: 'Garanties',
      alert_warranty_desc: 'Suivez les dates de garantie de vos achats. Recevez une alerte avant expiration pour ne pas perdre vos droits.',
      alert_allergens_title: 'Allergènes',
      alert_allergens_desc: 'Déclarez vos allergies dans votre profil. Recash vous avertit automatiquement si un produit scanné contient un allergène dangereux pour vous ou votre famille.',
      alert_price_title: 'Anomalies de prix',
      alert_price_desc: 'Si le prix scanné sur votre ticket diffère significativement du prix habituel ou du prix affiché en magasin, une alerte est générée.',
      guide_faq_q1: 'Le scan de produit est-il gratuit ?',
      guide_faq_a1: 'Oui, complètement gratuit et illimité. Vous pouvez scanner tous les produits en magasin pour vérifier leur qualité sans abonnement.',
      guide_faq_q2: 'Combien de tickets puis-je scanner gratuitement ?',
      guide_faq_a2: '10 tickets cashback par mois avec le plan Gratuit. 50 tickets cashback par mois avec le plan Premium.',
      guide_faq_q3: 'Comment les allergènes sont-ils détectés ?',
      guide_faq_a3: 'Recash compare la composition du produit (via Open Food Facts) avec votre profil santé et celui de votre famille. En cas de correspondance, une alerte rouge apparaît immédiatement.',
      guide_faq_q4: 'Puis-je utiliser Recash sans compte ?',
      guide_faq_a4: 'Oui, uniquement pour le scan de produit. Pour enregistrer vos tickets, recevoir des cashbacks et utiliser le portefeuille, un compte est nécessaire (gratuit).',
      guide_faq_q5: 'Comment changer mon plan d\'abonnement ?',
      guide_faq_a5: 'Allez dans Profil → Abonnement → Changer de plan. La mise à niveau est immédiate. L\'annulation prend effet à la fin de la période de facturation.',
      guide_faq_q6: 'Mon ticket n\'est pas reconnu correctement',
      guide_faq_a6: 'Vérifiez que l\'image est nette, bien éclairée et que le ticket est à plat. Évitez les reflets. Essayez de recadrer manuellement ou de relancer le scan.',
      guide_faq_q7: 'L\'app ne détecte pas mon allergène',
      guide_faq_a7: 'Vérifiez que l\'allergène est déclaré dans votre profil (Profil → Allergènes). Si le produit n\'est pas dans Open Food Facts, il ne peut pas être analysé.',
      cta_title: 'Prêt à commencer ?',
      cta_desc: 'Scannez maintenant votre premier ticket ou produit',
      cta_scan_ticket: 'Scanner un ticket',
      cta_scan_product: 'Scanner un produit'
    },
    payment: {
      success_title: 'Paiement réussi !',
      success_msg: 'Merci pour votre abonnement. Votre compte a été mis à jour.',
      success_detail: 'Vous pouvez maintenant profiter de toutes les fonctionnalités.',
      back_home: 'Retour à l\'accueil',
      cancel_title: 'Paiement annulé',
      cancel_msg: 'Vous avez annulé le processus de paiement.',
      cancel_detail: 'Aucun montant n\'a été débité. Vous pouvez réessayer à tout moment.',
      retry: 'Réessayer',
      paypal_processing: 'Traitement du paiement PayPal…',
      paypal_wait: 'Veuillez patienter pendant que nous confirmons votre paiement.',
      paypal_error_title: 'Erreur PayPal',
      paypal_error_generic: 'Une erreur est survenue lors du traitement du paiement PayPal.',
      paypal_cancelled_title: 'Paiement annulé',
      paypal_cancelled_msg: 'Vous avez annulé le paiement PayPal. Aucun montant n\'a été débité.',
      try_again: 'Réessayer'
    },
    support: {
      nav_title: 'Comment naviguer dans l\'application',
      nav_step_1_title: 'Barre de navigation (en bas)',
      nav_step_1_desc: 'Utilisez la barre d\'onglets en bas de l\'écran pour naviguer entre les sections principales :',
      nav_home: 'Accueil : Vue d\'ensemble de vos économies et alertes',
      nav_scan: 'Scanner : Scanner des tickets ou des produits',
      nav_tickets: 'Tickets : Historique de vos tickets scannés',
      nav_wallet: 'Portefeuille : Solde et transactions cashback',
      nav_alerts: 'Alertes : Rappels de produits et allergènes',
      nav_profile: 'Profil : Paramètres et abonnement',
      nav_step_2_title: 'Flux d\'utilisation typique',
      nav_step_2_1: 'Scannez un ticket via l\'onglet Scanner',
      nav_step_2_2: 'Visualisez le résultat et les produits détectés',
      nav_step_2_3: 'Confirmez pour enregistrer dans Tickets',
      nav_step_2_4: 'Les cashbacks sont ajoutés automatiquement à votre portefeuille',
      nav_step_2_5: 'Les alertes apparaissent dans Alertes',
      nav_step_3_title: 'Accès à l\'aide',
      nav_step_3_desc: 'Vous pouvez accéder à cette page d\'aide depuis :',
      nav_step_3_1: 'L\'écran d\'accueil (Onboarding)',
      nav_step_3_2: 'La page "À propos" dans le Profil',
      page_title: 'Aide & Support',
      hero_title: 'Comment pouvons-nous vous aider ?',
      faq_label: 'Questions fréquentes',
      contact_label: 'Contact direct',
      email_support: 'Support par email',
      response_time: 'Réponse sous 48h (jours ouvrés)',
      premium_priority: 'Abonnés Premium/Business : réponse prioritaire',
      send_msg_label: 'Envoyer un message',
      your_email: 'Votre email',
      subject: 'Sujet',
      message_label: 'Message',
      send_msg: 'Envoyer le message',
      useful_links: 'Liens utiles',
      documentation: 'Documentation',
      legal_cgu_link: 'Mentions légales & CGU',
      fill_required: 'Veuillez remplir l\'email et le message.',
      msg_sent: 'Message envoyé ! Nous répondrons sous 48h.'
    },
    faq: {
      category_scan_product: 'Scan de produit',
      category_scan_ticket: 'Scan de ticket',
      category_accounts: 'Comptes & Abonnements',
      category_technical: 'Problèmes techniques',
      scan_product_q1: 'Le scan de produit est-il gratuit ?',
      scan_product_a1: 'Oui, complètement gratuit et illimité. Vous pouvez scanner tous les produits en magasin pour vérifier leur qualité (allergènes, additifs, Nutri-Score, NOVA) sans abonnement.',
      scan_product_q2: 'Comment les allergènes sont-ils détectés ?',
      scan_product_a2: 'Recash compare la composition du produit (via Open Food Facts et étiquettes) avec votre profil santé et celui de votre famille. En cas de correspondance, une alerte rouge apparaît immédiatement.',
      scan_ticket_q1: 'Combien de tickets puis-je scanner gratuitement ?',
      scan_ticket_a1: '10 tickets cashback par mois avec le plan Gratuit. 50 tickets cashback par mois avec le plan Premium.',
      scan_ticket_q2: 'Comment fonctionne le cashback ?',
      scan_ticket_a2: 'Recash scanne votre ticket, recherche les offres actives chez les marques partenaires (Pampers, Danone, etc.) et envoie la demande automatiquement. Vous recevez l\'argent dans votre portefeuille Recash sous 48h.',
      scan_ticket_q3: 'Pourquoi y a-t-il une commission sur le cashback ?',
      scan_ticket_a3: 'Recash prend une commission (configurable par l\'administrateur, actuellement 20%) pour : développement et maintenance de l\'application, paiement des APIs tierces (Open Food Facts, Google Vision, etc.) et support rapide. Vous recevez toujours la majorité du cashback (généralement 80%).',
      accounts_q1: 'Puis-je utiliser Recash sans compte ?',
      accounts_a1: 'Oui, uniquement pour le scan de produit. Pour enregistrer vos tickets, recevoir des cashbacks et utiliser le portefeuille, un compte est nécessaire (gratuit).',
      accounts_q2: 'Comment changer mon plan d\'abonnement ?',
      accounts_a2: 'Allez dans Profil → Abonnement → Changer de plan. La mise à niveau est immédiate. L\'annulation prend effet à la fin de la période de facturation.',
      technical_q1: 'Mon ticket n\'est pas reconnu correctement',
      technical_a1: 'Vérifiez que l\'image est nette, bien éclairée et que le ticket est à plat. Évitez les reflets. Essayez de recadrer manuellement ou de relancer le scan. Si le problème persiste, contactez le support avec une capture d\'écran.',
      technical_q2: 'L\'app ne détecte pas mon allergène',
      technical_a2: 'Vérifiez que l\'allergène est déclaré dans votre profil (Profil → Allergènes). Si le produit n\'est pas dans Open Food Facts, il ne peut pas être analysé. Vous pouvez signaler le produit via l\'app pour enrichir la base de données.'
    },
    legal: {
      title: 'Informations légales',
      cgu: 'CGU',
      privacy: 'Politique de confidentialité',
      mentions: 'Mentions légales',
      cgu_title: 'Conditions Générales d\'Utilisation',
      privacy_title: 'Politique de confidentialité',
      mentions_title: 'Mentions légales',
      cgu_article1_title: 'Article 1 – Objet',
      cgu_article1_text: 'Recash est une application mobile qui permet de scanner des tickets et des produits pour :',
      cgu_article1_item1: 'Détecter les allergènes, additifs, Nutri-Score, NOVA',
      cgu_article1_item2: 'Obtenir des cashbacks automatiques',
      cgu_article1_item3: 'Être alerté en cas de rappel de produit ou de garantie expirante',
      cgu_article1_item4: 'Comparer les prix avec d\'autres magasins',
      cgu_article2_title: 'Article 2 – Accès à l\'application',
      cgu_article2_text: 'L\'accès au service nécessite la création d\'un compte. L\'utilisation est gratuite avec des limites (10 tickets/mois). Les fonctionnalités avancées nécessitent un abonnement payant.',
      cgu_article2_item1: 'Âge minimum : 13 ans (ou 16 ans selon le pays)',
      cgu_article2_item2: 'Compte requis pour le cashback et le wallet',
      cgu_article3_title: 'Article 3 – Scan de produit',
      cgu_article3_text: 'Le scan de produit est gratuit et illimité, même sans abonnement. Les données sont comparées avec Open Food Facts et les bases gouvernementales (Santé Canada, FDA, DGCCRF).',
      cgu_article4_title: 'Article 4 – Commission Recash',
      cgu_article4_text: 'Recash remet aux utilisateurs une partie du cashback généré par les marques partenaires. Une commission est prélevée par Recash pour financer l\'application, les frais de plateforme et les intégrations techniques.',
      cgu_article4_item1: 'Taux de commission : Le taux de commission actuel est de 20% (configurable par l\'administrateur)',
      cgu_article4_item2: 'Transparence : Le montant brut, la commission et le montant net sont affichés dans l\'interface de l\'application pour chaque cashback',
      cgu_article4_item3: 'Calcul : Montant net = Montant brut - (Montant brut × Taux de commission)',
      cgu_article4_item4: 'Modification : Ce taux est visible et modifiable par l\'administrateur. Toute modification sera communiquée par email ou notification dans l\'application',
      cgu_article4_item5: 'Retraits : Les retraits sont possibles vers un compte bancaire ou PayPal (montant minimum applicable)',
      cgu_article4_item6: 'Expiration : Les cashbacks non réclamés après 12 mois d\'inactivité sont annulés',
      cgu_article5_title: 'Article 5 – Responsabilités',
      cgu_article5_text: 'Recash fournit des informations à titre indicatif uniquement. Les informations nutritionnelles et de santé ne constituent pas un avis médical. En cas de rappel de produit, Recash n\'est pas responsable de la contamination ni des dommages résultants.',
      cgu_article6_title: 'Article 6 – Modification des CGU',
      cgu_article6_text: 'Recash se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés par email ou notification push. La poursuite de l\'utilisation après notification constitue l\'acceptation des nouvelles CGU.',
      cgu_article7_title: 'Article 7 – Résiliation',
      cgu_article7_text: 'L\'utilisateur peut supprimer son compte à tout moment via Profil → Zone de danger. Les données sont supprimées dans les 30 jours. Recash peut suspendre tout compte en cas de fraude ou de violation des CGU.',
      cgu_article8_title: 'Article 8 – Droit applicable',
      cgu_article8_text: 'Les présentes CGU sont régies par le droit canadien (province du Québec). Tout litige sera soumis aux tribunaux compétents de Montréal, Canada.',
      cgu_updated: 'Dernière mise à jour : 1 janvier 2025',
      privacy_updated: 'Dernière mise à jour : 1 janvier 2025',
      privacy_section1_title: '1. Données collectées',
      privacy_section1_item1: 'Tickets scannés : produits, prix, dates, magasins (conservés 3 ans)',
      privacy_section1_item2: 'Profil de santé : allergies, régimes (stockés de manière chiffrée)',
      privacy_section1_item3: 'Géolocalisation : pour détecter le pays et les magasins proches (optionnel)',
      privacy_section1_item4: 'Données de paiement : Stripe (non stockées par Recash)',
      privacy_section1_item5: 'Données de navigation : logs d\'utilisation anonymisés',
      privacy_section2_title: '2. Finalités du traitement',
      privacy_section2_item1: 'Optimisation des cashbacks et matching avec les offres partenaires',
      privacy_section2_item2: 'Détection des allergènes et rappels de produits personnalisés',
      privacy_section2_item3: 'Amélioration des algorithmes IA de l\'application',
      privacy_section2_item4: 'Envoi de notifications et alertes de sécurité',
      privacy_section3_title: '3. Vos droits (RGPD / PIPEDA)',
      privacy_section3_text: 'Conformément au RGPD (UE) et PIPEDA (Canada), vous avez :',
      privacy_section3_item1: 'Droit d\'accès à vos données',
      privacy_section3_item2: 'Droit de rectification',
      privacy_section3_item3: 'Droit à l\'effacement (« droit à l\'oubli »)',
      privacy_section3_item4: 'Droit à la portabilité (export JSON)',
      privacy_section3_item5: 'Droit d\'opposition au traitement',
      privacy_section3_contact: 'Contact : support@recash.shop',
      privacy_section4_title: '4. Stockage des données',
      privacy_section4_text: 'Données conservées maximum 3 ans après votre dernière connexion. Suppression définitive dans les 30 jours suivant la demande. Données comptables conservées 7 ans (obligation légale).',
      privacy_section5_title: '5. Cookies et APIs tierces',
      privacy_section5_item1: 'Open Food Facts (base de données produits, licence ODbL)',
      privacy_section5_item2: 'SerpApi (comparaison de prix)',
      privacy_section5_item3: 'APIs gouvernementales : Santé Canada, FDA, DGCCRF',
      privacy_section5_item4: 'OpenAI (OCR et analyse IA – données anonymisées)',
      privacy_section5_item5: 'Stripe (paiements – PCI-DSS Level 1)',
      privacy_section6_title: '6. Sécurité',
      privacy_section6_text: 'Données chiffrées pendant le transfert (TLS 1.3) et au repos (AES-256). Accès restreint au personnel autorisé. Audits de sécurité réguliers. Aucune vente de données personnelles à des tiers.',
      mentions_editor_title: 'Éditeur de l\'application',
      mentions_editor_name: 'Recash, 1522 Rue Ottawa #B701, Montréal, Québec, Email: support@recash.shop',
      mentions_hosting_title: 'Hébergement',
      mentions_hosting_item1: 'Base de données : Supabase (supabase.io) – AWS us-east-1',
      mentions_hosting_item2: 'Frontend : Vercel (vercel.com)',
      mentions_hosting_item3: 'API Backend : Railway.app',
      mentions_hosting_item4: 'Stockage de fichiers : Supabase Storage (AWS S3)',
      mentions_payment_title: 'Prestataire de paiement',
      mentions_payment_text: 'Stripe Inc. – 510 Townsend Street, San Francisco, CA 94103, USA - Certifié PCI-DSS Level 1. Recash ne stocke pas les données de carte bancaire.',
      mentions_ip_title: 'Propriété intellectuelle',
      mentions_ip_text: 'L\'application Recash, son logo, ses textes et ses fonctionnalités sont la propriété exclusive de Recash Inc. Toute reproduction sans autorisation écrite préalable est interdite.'
    }
  },

  /* ─────────────────── ENGLISH ─────────────────── */
  en: {
    nav: {
      home: 'Home',
      scan: 'Scan',
      tickets: 'Receipts',
      wallet: 'Wallet',
      alerts: 'Alerts',
      profile: 'Profile'
    },
    auth: {
      login: 'Sign in',
      create: 'Create account',
      email: 'Email',
      password: 'Password',
      confirm_password: 'Confirm password',
      email_placeholder: 'your@email.com',
      password_placeholder: '••••••••',
      signin: 'Sign in',
      forgot_password: 'Forgot password?',
      no_account: 'No account? Create one',
      have_account: 'Already have an account? Sign in',
      google: 'Continue with Google',
      apple: 'Continue with Apple',
      fill_all_fields: 'Please fill in all fields',
      passwords_not_match: 'Passwords do not match',
      auth_error: 'Authentication error',
      login_success: 'Login successful',
      account_created: 'Account created successfully',
      enter_email_reset: 'Enter your email to reset your password',
      reset_email_sent: 'If this account exists, a reset email has been sent.',
      google_dev: '🚧 Google login is under development',
      apple_dev: '🚧 Apple login is under development',
      or: 'or',
      legal_text: 'By continuing, you agree to our Terms and Privacy Policy.',
      cgu: 'Terms',
      privacy_policy: 'Privacy Policy',
      subtitle: 'Your savings, simplified',
      register_tab: 'Register',
      display_name: 'Display name',
      display_name_placeholder: 'Your name',
      password_min_placeholder: 'Minimum 8 characters',
      confirm_password_placeholder: 'Repeat password',
      creating: 'Creating...',
      signing_in: 'Signing in...',
      switch_to_register: 'No account yet? Sign up',
      switch_to_login: 'Already have an account? Sign in',
      create_my_account: 'Create my account',
      continue_as_guest: 'Continue as guest',
      password_min_error: 'Password must be at least 8 characters',
      login_error_msg: 'Login error',
      email_not_confirmed: 'Please confirm your email before logging in. Check your spam folder.',
      register_error_msg: 'Registration error',
      social_dev_msg: '🚧 {provider} login is under development',
      show_password: 'Show password',
      hide_password: 'Hide password',
      forgot_password_success: 'Email sent! Check your inbox.',
      country: 'Country',
      country_placeholder: 'Select your country',
      age_warning: 'This application is reserved for people aged 16 and over.',
      age_consent: 'I confirm that I am at least 16 years old',
      terms_consent: 'I accept the Terms of Service and Privacy Policy',
      consent_required: 'You must confirm your age and accept the terms to register',
      rgpd_consent: 'I agree that my personal data is processed in accordance with GDPR / PIPEDA',
      email_confirm_title: 'Check your email',
      email_confirm_sent: 'A confirmation email has been sent to:',
      email_confirm_spam: '⚠️ Check your spam / junk folder if you don\'t receive it within 2 minutes.',
      email_confirm_hint: 'Click the link in the email to activate your account, then sign in here.'
    },
    export: {
      title: 'Export my data',
      period: 'Period',
      period_7d: '7 days',
      period_30d: '30 days',
      period_90d: '3 months',
      period_all: 'All',
      format: 'Format',
      preview: 'Preview',
      col_date: 'Date',
      col_type: 'Type',
      col_amount: 'Amount',
      col_currency: 'Currency',
      col_status: 'Status',
      col_desc: 'Description',
      transactions: 'transactions',
      total: 'Total',
      loading: 'Loading...',
      error: 'Loading error',
      download: 'Download'
    },
    budget: {
      title: 'Monthly budget',
      monthly_budget: 'Monthly budget',
      used: 'used',
      remaining: 'Remaining',
      alert: 'Budget almost reached',
      vs_last_month: 'vs last month',
      last_3_months: 'Last 3 months',
      details: 'Details',
      tickets: 'Receipts',
      cashback: 'Cashback',
      edit_title: 'Edit budget',
      monthly_limit: 'Monthly limit',
    },
    onboarding: {
      guest: 'Guest',
      title: 'Recash',
      subtitle: 'Scan. Protect your health. Get your money back.',
      scan_instant: 'Instant Scan & Multi-Receipt Scan',
      scan_description: 'Receipt photo or barcode, AI extracts everything in 3s.',
      health_alerts: 'Live Health Alerts',
      health_description: 'Hidden allergens & product recalls: stay informed.',
      cashback: 'Automatic Cashback',
      cashback_description: 'Grocery, pharmacy, electronics, clothing... All store types',
      start_button: 'Start saving',
      legal_text: 'By continuing, you agree to our',
      terms: 'Terms',
      and: '&',
      privacy: 'Privacy Policy',
      slide1_title: 'Welcome to Recash',
      slide1_desc: 'The app that scans your receipts, protects your health and earns you money on every purchase.',
      slide2_title: 'Shopping List',
      slide2_desc: 'Save and manage your shopping list easily.',
      slide3_title: 'Instant Notifications',
      slide3_desc: 'Get an alert as soon as your cashback is credited, when your budget is near the limit, or during a product recall.',
      slide4_title: 'Share Your Lists',
      slide4_desc: 'Send your shopping list to your family or friends in one tap. Perfect for group shopping.',
      slide5_title: 'Double Price & Special Protection',
      slide5_desc: 'Recash automatically detects a double charge on your receipt.',
      skip: 'Skip',
      next: 'Next',
      get_started: 'Get started!',
      or_guest: 'Continue without account',
      all_stores: 'All store types',
      referral_code_label: 'Referral code (optional)',
      referral_code_placeholder: 'Enter code…',
      health_title: 'Health',
      health_desc: 'Allergens, additives, product recalls',
      regions: 'Recash in North America, Latin America, and Europe'
    },
    home: {
      greeting: 'Hello !',
      hero_title: 'Your savings<br>in one scan',
      monthly_savings: 'Saved this month',
      total_retrieved: 'Total earnings',
      scan_ticket: 'Scan<br>a receipt',
      scan_product: 'Scan<br>a product',
      my_wallet: 'My<br>wallet',
      guide: "User<br>guide",
      wallet_balance: 'Available balance',
      view_wallet: 'View wallet',
      critical_alerts: 'Critical alerts',
      recent_receipts: 'Recent receipts',
      no_alerts: 'No alerts',
      no_tickets: 'No scanned receipts',
      scan_first: 'Scan your first receipt!',
      wallet_available: 'Available wallet',
      active_alerts: 'Active alerts',
      cta_subtitle: 'Get your money back in seconds',
      recall_product: 'Product recall',
      warranty: 'Warranty',
      cashback: 'cashback',
      allergen: 'allergen',
      health_score_title: 'Health score of the month',
      health_good: 'Good',
      health_improve: 'To improve',
      critical: 'critical',
      product: 'product',
      ultra_processed: 'ultra-processed',
      see_all: 'See all',
      details: 'Details',
      health_score: 'Health Score',
      out_of: 'Out of 100',
      score_good: '👍 Good',
      score_improve: '👎 To improve',
      allergens: 'Allergens',
      ultra_processed_plural: 'Ultra-processed',
      alerts: 'Alerts',
      recall: 'Recall',
      warranty_label: 'Warranty',
      available_in: 'Available in',
      store: 'Store',
      pending_cashbacks: 'Pending cashbacks',
      no_pending: 'No pending cashbacks',
      recent_transactions: 'Recent transactions',
      no_transactions: 'No transactions',
      withdraw: 'Withdraw',
      add: 'Add',
      scan: 'Scan',
      tickets: 'Tickets',
      active: 'Active',
      currency: 'Currency',
      total_earnings: 'Total earnings',
      account_required: 'Account required',
      account_desc: 'Create a free account to access your wallet and track your cashbacks.',
      create_account: 'Create account',
      view_offers: 'View offers',
      loading_wallet: 'Loading your wallet...',
      error: 'Error',
      retry: 'Retry',
      profile_title: 'Profile',
      guest_message: 'Create a free account to customize your profile and access all features.',
      user: 'User',
      stats_tickets: 'Receipts',
      stats_savings: 'Savings',
      stats_alerts: 'Alerts resolved',
      ethical_score: 'Ethical score',
      savings: 'Savings',
      alerts_resolved: 'Alerts resolved',
      preferences: 'Preferences',
      notifications: 'Notifications',
      language: 'Language',
      ethical_points: 'Ethical Points',
      currency_label: 'Currency',
      allergens_title: 'Allergens',
      allergens_desc: 'Declare your allergens or your family\'s to receive alerts when scanning products.',
      save_allergens: 'Save my allergens',
      allergen_gluten: 'Gluten (wheat, rye, barley)',
      allergen_lactose: 'Lactose / Milk',
      allergen_eggs: 'Eggs',
      allergen_peanuts: 'Peanuts',
      allergen_nuts: 'Tree nuts (almonds, walnuts, hazelnuts)',
      allergen_soy: 'Soy',
      allergen_fish: 'Fish',
      allergen_shellfish: 'Crustaceans / Shellfish',
      allergen_sesame: 'Sesame',
      allergen_sulfites: 'Sulfites',
      allergen_mustard: 'Mustard',
      allergen_celery: 'Celery',
      allergen_lupin: 'Lupin',
      allergen_molluscs: 'Mollusks',
      subscription: 'Subscription',
      free_plan: 'Access to basic features',
      premium_plan: 'Unlimited cashback, priority alerts',
      pro_plan: 'All Premium + API, priority support',
      view_offers_btn: 'View offers',
      manage: 'Manage',
      actions: 'Actions',
      support: 'Support',
      legal: 'Legal notices',
      delete_account: 'Delete my account',
      logout: 'Log out',
      logout_confirm: 'Are you sure you want to log out?',
      cancel: 'Cancel',
      logout_btn: 'Log out',
      delete_confirm_title: '⚠️ Account deletion',
      delete_confirm_msg: 'This action is irreversible. All your data will be deleted.',
      delete_btn: 'Delete',
      delete_error: 'Error during deletion',
      upload_error: 'Upload failed',
      save_success: 'Allergens saved',
      save_error: 'Error saving',
      family_members: 'Family members',
      family_desc: 'Add family members with their allergens.',
      add_member: 'Add member',
      member_name: 'First name',
      member_age: 'Age',
      member_allergens: 'Allergens',
      remove_member: 'Remove',
      save_family: 'Save family',
      all_stores: 'All store types'
    },
    scan: {
      title: 'Scan',
      ticket_tab: 'Receipt',
      product_tab: 'Product',
      take_photo: 'Take a photo',
      import_gallery: 'Import from gallery',
      upload_pdf: 'Upload PDF',
      scan_barcode: 'Tap to scan a product',
      scan_ticket: 'Scan a receipt',
      scan_product: 'Scan a product',
      scan_btn: 'Scan',
      processing: 'Processing...',
      analyzing: 'Analyzing...',
      success: 'Success',
      error: 'Error',
      retry: 'Retry',
      capture_ticket: 'Capture a receipt or import a file',
      searching_barcode: 'Searching barcode...',
      scanning_hint: '🔍 Auto-detecting… point camera at barcode',
      stop_scanner: 'Stop',
      enter_barcode: 'Enter barcode',
      uploading: 'Uploading...',
      analyzing_ai: 'AI analysis in progress...',
      searching_product: 'Searching product...',
      products_detected: 'Products detected',
      validate_save: 'Validate and save',
      score_excellent: 'Excellent',
      score_good: 'Good',
      score_average: 'Average',
      score_avoid: 'Avoid',
      camera_access_denied: 'Camera access denied',
      analysis_failed: 'Analysis failed.',
      analysis_timeout: 'Analysis timed out, please try again.',
      unknown_product: 'Unknown product',
      ticket_saved: 'Receipt saved',
      ticket_saved_desc: 'Your receipt has been analysed and saved.',
      view_ticket: 'View receipt',
      scan_another: 'Scan another receipt',
      session_title: 'Current session',
      session_count: '{n} receipt(s) scanned',
      view_all_tickets: 'View all my receipts',
      session_store: 'Unknown store',
      end_session: 'End session',
      flipp_local_deals: 'Grocery deals',
      flipp_valid_until: 'Until',
      flipp_no_deals: 'No deals found near you',
      flipp_location_label: 'Local deals in',
      upload_failed: 'Upload failed',
      permission_denied: 'Permission denied',
      barcode_unavailable: 'Barcode scan not available on PC. Use manual input.',
      product_found: 'Product found',
      product_not_found: 'Unable to find this product',
      all_stores: 'All store types',
      location_banner: '📍 To offer you the best local deals in your area, we use your GPS location. Your data stays on your device and is never shared with third parties.',
      location_banner_dismiss: 'Got it'
    },
    tickets: {
      title: 'My receipts',
      no_tickets: 'No scanned receipts',
      scan_first: 'Scan your first receipt to get started',
      date: 'Date',
      store: 'Store',
      amount: 'Amount',
      status: 'Status',
      cashback: 'Cashback',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      unknown_store: 'Unknown store',
      history: 'History',
      history_desc: 'View all your scanned receipts',
      filter_all: 'All',
      filter_active: 'Active',
      filter_refunded: 'Refunded',
      filter_review: 'Review',
      filter_alerts: 'Alerts',
      scan_ticket: 'Scan a receipt',
      expires: 'Expires',
      no_warranty: 'No warranty',
      alert: 'alert',
      alerts: 'alerts',
      status_processed: 'Processed',
      status_processing: 'Processing',
      status_failed: 'Failed',
      status_pending: 'Pending',
      status_review: 'Review',
      default_category: 'Groceries',
      search_placeholder: 'Search for a product...'
    },
    referral: {
      title: 'Referral',
      hero_title: 'Invite friends, earn rewards',
      hero_subtitle: 'Share your code and get cashback as soon as your friend scans their first receipts',
      you_earn: 'You earn',
      friend_gets: 'Friend gets',
      trigger_note: 'Reward triggered after your friend scans {n} receipts',
      your_code: 'Your referral code',
      copied: 'Code copied!',
      share: 'Share my code',
      share_msg: 'Join Recash with my code {code} and get {days} days Premium for free! Scan receipts, earn cashback.',
      stats_title: 'My referrals',
      total_referrals: 'Invited',
      credited: 'Validated',
      total_earned: 'Earned',
      have_code: 'Have a friend code?',
      enter_code: 'Enter code…',
      apply: 'Apply',
      apply_success: '✅ Code applied! {days} days Premium unlocked.',
      apply_error: 'Invalid or already used code',
      load_error: 'Unable to load referral data',
      retry: 'Try again'
    },
    shopping_list: {
      title: 'Shopping List',
      add_placeholder: 'Add an item...',
      add: 'Add',
      empty_title: 'Your list is empty',
      empty_subtitle: 'Start adding items',
      scan_to_add: 'Scan a product',
      import_from_ticket: 'Import from receipt',
      search_placeholder: 'Search for a product...',
      clear_checked: 'Remove checked items',
      share: 'Share list',
      items_count: 'item(s)',
      checked_count: 'checked',
      estimated_cashback: 'Estimated cashback',
      delete: 'Delete',
      item_added: 'Item added',
      list_cleared: 'List cleared',
      imported: 'Items imported from last receipt',
      no_recent_ticket: 'No recent receipt to import',
      qty: 'Qty',
      summary_title: 'Summary',
      total_items: 'Total items',
      total_cashback: 'Potential cashback',
      quick_action: 'My list 🛒',
      section_title: '🛒 My shopping list',
      view_list: 'View list',
      pending_items: 'item(s) remaining',
      all_done: 'All done!',
      confirm_clear: 'Remove all checked items?',
      confirm_clear_all: 'Clear the entire list?',
      yes: 'Yes',
      no: 'No',
      quantity_label: 'Quantity',
      search_products_title: 'Search products',
      select_products: 'Select products',
      import_selected: 'Import selected products',
      no_results: 'No results',
      enter_search_terms: 'Enter at least 2 characters'
    },
    profile: {
      title: 'Profile',
      guest_message: 'Create a free account to customize your profile and access all features.',
      user: 'User',
      stats_tickets: 'Receipts',
      stats_savings: 'Savings',
      stats_alerts: 'Alerts Resolved',
      my_info: 'My Information',
      first_name: 'First Name',
      last_name: 'Last Name',
      email: 'Email',
      email_readonly_note: 'Email cannot be modified',
      phone: 'Phone',
      phone_placeholder: '+1 514 555-1234',
      save_info: 'Save',
      preferences: 'Preferences',
      notifications: 'Notifications',
      language: 'Language',
      ethical_points: 'Ethical Points',
      monthly_budget: 'Monthly Budget',
      currency: 'Currency',
      allergens: 'Allergens',
      allergens_desc: 'Declare your allergens or those of your family to receive alerts when scanning products.',
      manage_allergens: 'Manage Allergens',
      no_allergies_registered: 'No allergens registered',
      member_allergens_of: 'Allergens of',
      add_member: 'Add Member',
      modal_close: 'Close',
      save_allergens: 'Save Allergens',
      subscription: 'Subscription',
      plan_free: 'Free',
      plan_premium: 'Premium',
      plan_pro: 'Pro',
      plan_business: 'Business',
      plan_free_desc: 'Access to basic features',
      plan_premium_desc: '50 cashback tickets / month, priority alerts',
      plan_pro_desc: 'Advanced features for professionals',
      plan_business_desc: 'Unlimited cashback tickets, complete solution for businesses',
      view_offers: 'View Offers',
      manage: 'Manage',
      ethical_score: 'Ethical Score',
      local_purchases: 'Local Purchases',
      eco_friendly: 'Eco-Friendly',
      fair_trade: 'Fair Trade',
      actions: 'Actions',
      referral_badge: 'New',
      guide: 'Guide',
      support: 'Support',
      legal: 'Legal',
      delete_account: 'Delete Account',
      logout: 'Logout',
      allergen_gluten: 'Gluten (wheat, rye, barley)',
      allergen_lactose: 'Lactose / Milk',
      allergen_eggs: 'Eggs',
      allergen_peanuts: 'Peanuts',
      allergen_nuts: 'Tree Nuts (almonds, walnuts, hazelnuts)',
      allergen_soy: 'Soy',
      allergen_fish: 'Fish',
      allergen_shellfish: 'Shellfish / Seafood',
      allergen_sesame: 'Sesame',
      allergen_sulfites: 'Sulfites',
      allergen_mustard: 'Mustard',
      allergen_celery: 'Celery',
      allergen_lupin: 'Lupin',
      allergen_molluscs: 'Molluscs',
      allergens_saved: 'Allergens saved',
      allergens_error: 'Error saving allergens',
      member_added: 'Member added',
      member_add_error: 'Error adding member',
      profile_saved: 'Profile saved',
      save_error: 'Error saving',
      notifications_enabled: 'Notifications enabled ✅',
      notifications_disabled: 'Notifications disabled',
      notifications_denied: 'Permission denied. Enable notifications in your browser settings.',
      logout_title: 'Logout',
      logout_confirm: 'Are you sure you want to logout?',
      delete_title: 'Delete Account',
      delete_confirm: 'This action is irreversible and will delete all your data.',
      delete_confirm_btn: 'Delete',
      delete_error: 'Error deleting account',
      upload_error: 'Upload error'
    },
    ticket_detail: {
      ticket_of: 'Receipt of',
      loading: 'Loading receipt...',
      error: 'Error',
      retry: 'Retry',
      no_photo: 'No photo available',
      total: 'Total',
      status: 'Status',
      products: 'Products',
      alerts_section: 'Alerts',
      request_refund: 'Request Refund',
      ticket_photo: 'Receipt Photo',
      close: 'Close',
      id_missing: 'Receipt ID missing',
      cannot_load: 'Cannot load receipt',
      claim_sent: 'Claim sent',
      claim_error: 'Error sending claim',
      status_completed: 'Refunded',
      status_processed: 'Processed',
      status_processing: 'Processing',
      status_failed: 'Failed',
      status_pending: 'Pending',
      cashback_pending: 'Pending',
      cashback_approved: 'Approved',
      cashback_paid: 'Paid',
      allergen: 'Allergen',
      recall: 'Recall'
    },
    wallet: {
      title: 'Wallet',
      balance: 'Balance',
      available: 'Available',
      pending: 'Pending',
      withdrawn: 'Withdrawn',
      withdraw: 'Withdraw',
      withdraw_btn: 'Withdraw money',
      withdraw_success: 'Withdrawal successful',
      withdraw_error: 'Error during withdrawal',
      no_transactions: 'No transactions',
      payment_methods: 'Payment methods',
      add_payment: 'Add payment method',
      paypal: 'PayPal',
      bank_account: 'Bank account',
      reserved: 'Reserved for members',
      guest_message: 'Wallet, withdrawals and cashback are reserved for Recash members. Create a free account to get started.',
      guest_banner_title: 'View guest cashback',
      guest_banner_desc: 'Sign up to withdraw your earnings and access all features.',
      loading: 'Loading...',
      error_title: 'Error',
      pending_cashbacks: 'Pending cashbacks',
      no_cashback: 'No pending cashback',
      transactions: 'Transactions',
      withdraw_modal_title: 'Withdraw to bank account',
      amount: 'Amount',
      transfer_method: 'Transfer method',
      status_completed: 'Completed',
      status_pending: 'Pending',
      status_failed: 'Failed',
      type: 'Type',
      tickets: 'Tickets',
      add: 'Add',
      scan: 'Scan',
      no_pending: 'No pending payments',
      recent_transactions: 'Recent transactions',
      scan_ticket: 'Scan a receipt',
      withdraw_title: 'Withdraw',
      max: 'Maximum',
      withdraw_method: 'Withdrawal method',
      bank_transfer: 'Bank transfer',
      iban: 'IBAN',
      add_payment_title: 'Add payment method',
      paypal_email: 'PayPal email',
      load_error: 'Unable to load wallet data',
      invalid_amount: 'Invalid amount',
      insufficient_balance: 'Insufficient balance',
      fill_destination: 'Please fill the destination field',
      withdrawal_requested: 'Withdrawal requested successfully',
      confirm_withdraw: 'Confirm withdrawal',
      bank_card: 'Bank card'
    },
    health_dashboard: {
      title: 'Health Dashboard',
      monthly_score: 'Monthly score',
      base_score: 'Base score',
      personalized_score: 'Personalized score',
      cumulative_stats: 'Cumulative stats',
      health_points: 'Health points',
      co2_saved: 'CO2 saved',
      water_saved: 'Water saved',
      products_scanned: 'Products scanned',
      trends: 'Trends',
      score_trend: 'Score trend',
      co2_trend: 'CO2 trend',
      recent_products: 'Recent products',
      no_products: 'No products scanned this month'
    },
    ethical: {
      title: 'Ethical Points',
      ineligible_msg: 'Ethical points are only available in Canada.',
      your_location: 'Your location',
      unknown: 'Unknown',
      this_month: 'This month',
      points: 'Points',
      value: 'Value',
      choices: 'Choices',
      points_remaining: 'points remaining / 100 max',
      total_cumulative: 'Total cumulative',
      earned: 'earned',
      double_bonus: 'Double bonus',
      points_per_choice: 'Points/choice',
      recent_activity: 'Recent activity',
      no_activity: 'No recent activity',
      start_scanning: 'Scan products to accumulate ethical points!',
      monthly_history: 'Monthly history',
      alternative: 'Alternative'
    },
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      retry: 'Retry',
      view_details: 'View details',
      see_all: 'See all',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      close: 'Close',
      back: 'Back',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      search: 'Search',
      selected: 'Selected',
      continue: 'Continue',
      continue_with: 'Continue with {plan}'
    },
    pricing: {
      offers: 'Our offers', choose_plan: 'Choose your plan',
      choose_plan_subtitle: 'Plans for every need',
      redirect_payment: 'Redirecting...', free: 'Free', per_month: '/ month', per_year: '/ year', save_2_months: '2 months free',
      ten_tickets_month: '10 cashback tickets / month', product_scan: 'Product scan',
      basic_alerts: 'Basic alerts', manufacturer_warranties: 'Warranties',
      unlimited_cashback: 'Unlimited cashback', priority_support: 'Priority support',
      start_free: 'Start free', popular: 'Popular', premium: 'Premium',
      unlimited_tickets: 'Unlimited receipts', tickets_cashback_month: 'cashback tickets / month', unlimited_tickets_cashback: 'Unlimited cashback tickets', advanced_alerts: 'Advanced alerts',
      extended_warranties: 'Extended warranties', choose_premium: 'Choose Premium',
      pro: 'Pro', choose_pro: 'Choose Pro', faq_title: 'FAQ',
      faq_q1: 'Cancel anytime?', faq_a1: 'Yes, no commitment.',
      faq_q2: 'Is registration free?', faq_a2: 'Yes, registration is free on the free plan and you get 10 free cashbacks.',
      faq_q3: 'How cashback works?', faq_a3: 'Auto-credited to wallet.',
      faq_q4: 'Data secure?', faq_a4: 'Encrypted, never sold.',
      payment_url_missing: 'Payment URL missing', payment_error: 'Payment error',
      pay_with: 'Pay with',
      pay_card: 'Credit / Debit card',
      pay_interac: 'Interac e-Transfer',
      interac_title: 'Pay by Interac e-Transfer',
      interac_subtitle: 'Send an Interac e-Transfer from your online banking app',
      interac_step1: '1. Open your banking app',
      interac_step2: '2. Send the exact amount to the address below',
      interac_step3: '3. Write this code in the message field',
      interac_step4: '4. Your subscription will be activated within 24 business hours',
      interac_email_label: 'e-Transfer address',
      interac_amount_label: 'Amount to send',
      interac_code_label: 'Reference code (required in message)',
      interac_expiry: 'This code expires in 72 hours',
      interac_copy: 'Copy',
      interac_copied: 'Copied!',
      interac_confirm: 'I have sent the transfer',
      interac_pending: 'Awaiting confirmation',
      interac_pending_desc: 'Once we receive your payment, your subscription will be activated automatically.',
      interac_error: 'Error creating Interac request',
      paypal_subtitle: 'Secure payment via your PayPal account',
      stripe_subtitle: 'Visa, Mastercard, Amex — secure payment',
      pay_wire: 'Bank wire transfer',
      wire_subtitle: 'Wire from your bank — activated within 24 h',
      wire_title: 'Bank wire transfer payment',
      wire_bank: 'Bank',
      wire_holder: 'Account holder',
      wire_institution: 'Institution / Transit',
      wire_account: 'Account number',
      wire_step1: '1. Log in to your online banking',
      wire_step2: '2. Send the exact amount with this code as the reference',
      wire_step3: '3. Your subscription will be activated within 24 business hours',
      wire_error: 'Error creating wire transfer request'
    },
    anti_waste: {
      title: 'Anti-Waste',
      subtitle: 'Reduce your environmental impact',
      better_packaging: 'Better packaging',
      less_plastic: 'Less plastic',
      better_eco_score: 'Better Eco-Score',
      local_product: 'Local product',
      seasonal_product: 'Seasonal product',
      no_suggestions: 'No suggestions available for this product',
      packaging_preferred: 'Preferred packaging',
      packaging_preferred_desc: 'Choose products with recyclable packaging (cardboard, glass) when possible.',
      less_plastic_alt: 'Alternative with less plastic',
      less_plastic_desc: 'This product contains plastic. Here is an alternative with better packaging.',
      better_eco_alt: 'Alternative with a better Eco-Score',
      better_eco_alt_desc: 'Try this alternative with a better environmental impact.',
      prefer_local: 'Prefer local products',
      prefer_local_desc: 'This product comes from far away. For fruits, vegetables and fresh products, choosing local reduces the carbon footprint and supports the regional economy.',
      seasonal_tip: 'Seasonal product',
      seasonal_tip_desc: 'Prefer seasonal fruits and vegetables for a better environmental and taste impact.',
      responsible_consumption: 'Responsible consumption',
      responsible_consumption_desc: 'Buy only what you need and prefer products with a good Nutri-Score and Eco-Score.'
    },
    scan_result: {
      price_paid: 'Price paid:',
      nutri_score: 'Nutri-Score =',
      personalized_score: 'Personalized score',
      base_score: 'Base score',
      personalized_score_label: 'Personalized score',
      nutrition_title: 'Nutrition facts (per 100g)',
      sugars: 'Sugars',
      saturated_fat: 'Saturated fat',
      calories: 'Calories',
      fiber: 'Fiber',
      proteins: 'Proteins',
      sodium: 'Sodium',
      country: 'Country',
      category: 'Category',
      defects: 'Defects',
      qualities: 'Qualities',
      additives: 'Additives',
      palm_oil_detected: '⚠️ Palm oil detected',
      contains_additives: 'This product contains {count} additives',
      allergens: 'Allergens',
      ingredients: 'Ingredients',
      comparison_title: 'Price comparison',
      no_market_data: '📊 Insufficient market data for this product.',
      avg_market: 'Market average',
      cheapest: 'Cheapest',
      stores_compared: 'store(s) compared',
      where_cheaper: '📉 Where it\'s cheaper',
      best_price_market: '✅ You bought this product at the best price found on the market!',
      same_product_cheaper: 'Same product cheaper',
      savings: 'Savings:',
      healthier_alternatives: 'Healthier alternatives',
      best_health_score: 'Best health score',
      eco_alternatives: 'More eco-friendly alternatives',
      less_co2_impact: 'Less CO2 impact',
      ethical_points: 'Ethical points',
      ethical_description: 'Earn ethical points for your healthy and eco-friendly choices',
      ethical_value: '💰 100 points = $1 CAD',
      points_available: 'Points available',
      grocery_offers: 'Grocery offers',
      offers_count: 'offer(s)',
      no_offers: 'No offers',
      no_offers_for: 'No offers found for',
      in_region: 'in flyers from',
      no_promotion: 'This product is currently not on sale in any local grocery store.',
      compare_online: '🔍 Compare prices online',
      cashback_available: 'Cashback available',
      disclaimer: 'Suggestions for informational purposes only (Open Food Facts & partners). No brand pays Recash. Prices and availability may vary.',
      score_excellent: 'Excellent',
      score_good: 'Good',
      score_mediocre: 'Mediocre',
      score_avoid: 'To avoid',
      score_explanation: 'Health score out of 100: the higher, the better for your health.',
      defect_too_fat: 'Too fatty',
      defect_moderate_fat: 'Moderate fat',
      defect_very_caloric: 'Very caloric',
      defect_moderate_caloric: 'Moderate calories',
      defect_too_salty: 'Too salty',
      defect_too_sugary: 'Too sugary',
      defect_moderate_sugars: 'Moderate sugars',
      quality_excellent_amount: 'Excellent amount',
      quality_good_amount: 'Good amount',
      quality_excellent_intake: 'Excellent intake',
      quality_correct_intake: 'Adequate intake',
      quality_low_sodium: 'Low sodium',
      error_rate_limit: 'OpenFoodFacts is rate-limiting requests — please wait a few seconds and try again.'
    },
    product: {
      eco_score: 'Eco-Score',
      price_position_best: 'Best price',
      price_position_competitive: 'Competitive price',
      price_position_expensive: 'High price',
      price_position_overpriced: 'Overpriced',
      price_position_unknown: 'Unknown price'
    },
    guide: {
      title: 'User Guide',
      complete_guide: 'Complete Guide',
      subtitle: 'Everything you need to know to use Recash',
      section_scan_ticket_title: 'Scan a Receipt',
      section_scan_ticket_desc: 'How to scan your receipts to get cashback and track your spending.',
      section_scan_product_title: 'Scan a Product',
      section_scan_product_desc: 'Analyse any product via its barcode to know its composition and scores.',
      section_scores_title: 'Understanding Scores',
      section_scores_desc: 'Nutri-Score, NOVA, Eco-Score… all about quality indicators.',
      section_cashback_title: 'Cashback',
      section_cashback_desc: 'How cashback works, processing times and withdrawals.',
      section_wallet_title: 'Wallet & Withdrawals',
      section_wallet_desc: 'Manage your balance and withdraw money via PayPal or bank transfer.',
      section_shopping_title: 'Shopping List',
      section_shopping_desc: 'Create, manage and share your smart shopping list.',
      section_budget_title: 'Monthly Budget',
      section_budget_desc: 'Track your spending by category and set budget limits.',
      section_antiwaste_title: 'Anti-Waste',
      section_antiwaste_desc: 'Reduce your environmental impact with alternative suggestions.',
      section_ethical_title: 'Ethical Points',
      section_ethical_desc: 'Earn points by choosing eco-responsible alternatives.',
      section_alerts_title: 'Alerts & Recalls',
      section_alerts_desc: 'Stay informed about product recalls, warranties and personalised alerts.',
      section_faq_title: 'FAQ',
      section_faq_desc: 'The most frequently asked questions about Recash.',
      scan_ticket_step1_title: 'Take a photo',
      scan_ticket_step1_desc: 'Lay your receipt flat on a plain background. Make sure the photo is sharp, well lit and free of reflections.',
      scan_ticket_step2_title: 'Import the image',
      scan_ticket_step2_desc: 'Take a photo directly from the app or import an image from your gallery. PDFs are also accepted.',
      scan_ticket_step3_title: 'Automatic analysis',
      scan_ticket_step3_desc: 'Our AI analyses your receipt in seconds: store, date, total amount and every item with its price.',
      scan_ticket_step4_title: 'Discover your earnings',
      scan_ticket_step4_desc: 'Recash automatically searches for available cashback offers on your purchases. You instantly see the amount you can recover.',
      scan_ticket_step5_title: 'Confirm and track',
      scan_ticket_step5_desc: 'Confirm the details and track your cashbacks in your wallet. Funds are credited within 48h.',
      scan_product_step1_title: 'Scan the barcode',
      scan_product_step1_desc: 'Use your phone camera to scan a product\'s barcode. You can also enter the code manually.',
      scan_product_step2_title: 'Instant analysis',
      scan_product_step2_desc: 'Recash queries the Open Food Facts database and displays: Nutri-Score, NOVA, Eco-Score, ingredients, allergens, additives.',
      scan_product_step3_title: 'Check alerts',
      scan_product_step3_desc: 'If the product contains an allergen declared in your profile, a red alert appears immediately.',
      scan_product_step4_title: 'Compare alternatives',
      scan_product_step4_desc: 'Discover better-rated, cheaper or healthier alternative products available in your region.',
      score_nutri_name: 'Nutri-Score',
      score_nutri_desc: 'Rates the overall nutritional quality of a product from A (best) to E (worst). Based on nutrients and foods to favour/limit.',
      score_nova_name: 'NOVA',
      score_nova_desc: 'Classifies foods by their degree of processing: 1 (raw) to 4 (ultra-processed). Prefer scores 1 and 2.',
      score_eco_name: 'Eco-Score',
      score_eco_desc: 'Rates the environmental impact of a product from A (very low impact) to E (very high impact). Considers packaging, transport, production.',
      score_health_name: 'Health Score',
      score_health_desc: 'Our personalised score combining Nutri-Score, NOVA, Eco-Score and your health/allergy preferences to give you a score out of 100.',
      cashback_how_title: 'How does it work?',
      cashback_how_desc: 'When you scan a receipt, Recash identifies cashback-eligible products — food, electronics, clothing, pharmacy, home and more — from our partner brands. The request is submitted automatically.',
      cashback_delays_title: 'Processing times',
      cashback_delays_desc: 'Cashbacks are generally credited within 48h after receipt validation. Times may vary depending on partners.',
      cashback_commission_title: 'Recash commission',
      cashback_commission_desc: 'Recash takes a commission (configurable by the administrator, currently 20%) to cover development costs, APIs and support. You always receive the majority of the amount.',
      cashback_withdrawal_title: 'Withdrawing funds',
      cashback_withdrawal_desc: 'You can withdraw your money at any time via bank transfer, PayPal or Stripe. The minimum withdrawal amount is €5/$5/£5.',
      cashback_tracking_title: 'Real-time tracking',
      cashback_tracking_desc: 'View your cashback history, pending amounts and total earnings from the Wallet page.',
      wallet_balance_title: 'Your balance',
      wallet_balance_desc: 'Your available balance corresponds to validated cashbacks. "Pending" amounts will be credited once validated by our partners.',
      wallet_paypal_title: 'Withdraw via PayPal',
      wallet_paypal_desc: 'Enter your PayPal email and desired amount. The transfer is automatic and arrives within 24h on your PayPal account.',
      wallet_bank_title: 'Bank transfer',
      wallet_bank_desc: 'Provide your IBAN for a direct transfer to your bank account. Delay: 1 to 3 business days.',
      wallet_delay_title: 'Withdrawal delays',
      wallet_delay_desc: 'PayPal: within 24h. Bank transfer: 1 to 3 business days. Minimum amount: €5/$5/£5.',
      wallet_tracking_title: 'Full history',
      wallet_tracking_desc: 'View all your transactions (cashbacks received, withdrawals made) with their real-time status.',
      shopping_step1_title: 'Create your list',
      shopping_step1_desc: 'Add items manually by typing their name, or import products from your last scanned receipt in one tap.',
      shopping_step2_title: 'Scan to add',
      shopping_step2_desc: 'Scan a product\'s barcode in the store to add it directly to your list with its nutritional information.',
      shopping_step3_title: 'Manage on the go',
      shopping_step3_desc: 'Tick items as you shop. Adjust quantities, remove unwanted items.',
      shopping_step4_title: 'Share your list',
      shopping_step4_desc: 'Send your shopping list to your family or friends in one tap. Perfect for shared shopping.',
      budget_set_title: 'Set your budget',
      budget_set_desc: 'Set a global monthly budget in Profile → Budget. Recash automatically calculates your spending from scanned receipts.',
      budget_categories_title: 'Categories',
      budget_categories_desc: 'Your spending is automatically categorised (food, pharmacy, electronics…) for precise tracking.',
      budget_alert_title: 'Budget alerts',
      budget_alert_desc: 'Receive a notification when you are approaching your monthly limit, keeping you in control of your spending.',
      budget_monthly_title: 'Monthly summary',
      budget_monthly_desc: 'View your monthly summary with a comparison to the previous month and a graphical view of your spending.',
      antiwaste_packaging_title: 'Responsible packaging',
      antiwaste_packaging_desc: 'Recash suggests alternatives with better packaging (cardboard, glass, unpackaged) to reduce your plastic waste.',
      antiwaste_local_title: 'Prefer local',
      antiwaste_local_desc: 'For fruit, vegetables and fresh produce, choosing local reduces your carbon footprint and supports the regional economy.',
      antiwaste_seasonal_title: 'Seasonal products',
      antiwaste_seasonal_desc: 'Recash identifies out-of-season products and suggests seasonal alternatives, better for the environment and taste.',
      antiwaste_alternatives_title: 'Eco alternatives',
      antiwaste_alternatives_desc: 'Discover similar products with a better Eco-Score or reduced environmental impact in your region.',
      ethical_what_title: 'What are Ethical Points?',
      ethical_what_desc: 'Ethical Points reward your responsible consumer choices. When you scan a product and a more eco-friendly alternative exists, you earn points.',
      ethical_how_title: 'How to earn them?',
      ethical_how_desc: 'Scan products and choose recommended alternatives. The more virtuous the alternative (organic, local, unpackaged, fair trade), the more points you earn.',
      ethical_value_title: 'Point value',
      ethical_value_desc: 'Each ethical point has a monetary value. You can accumulate and convert them. The maximum is 100 points per month.',
      ethical_availability_title: 'Availability',
      ethical_availability_desc: 'Ethical Points are currently only available in Canada. We are working to extend this programme to other countries.',
      coming_next_version: 'Available in the next version',
      ethical_coming_soon_desc: 'Ethical Points will be introduced in the next Recash update. Stay tuned!',
      alert_recalls_title: 'Product recalls',
      alert_recalls_desc: 'Receive an immediate notification if a product you have purchased is subject to a health recall (listeria, salmonella, foreign body, etc.).',
      alert_warranty_title: 'Warranties',
      alert_warranty_desc: 'Track the warranty dates of your purchases. Receive an alert before expiry so you don\'t lose your rights.',
      alert_allergens_title: 'Allergens',
      alert_allergens_desc: 'Declare your allergies in your profile. Recash automatically alerts you if a scanned product contains a dangerous allergen for you or your family.',
      alert_price_title: 'Price anomalies',
      alert_price_desc: 'If the price scanned on your receipt differs significantly from the usual price or the price displayed in the store, an alert is generated.',
      guide_faq_q1: 'Is product scanning free?',
      guide_faq_a1: 'Yes, completely free and unlimited. You can scan all products in the store to check their quality without a subscription.',
      guide_faq_q2: 'How many receipts can I scan for free?',
      guide_faq_a2: '10 cashback receipts per month with the Free plan. 50 cashback receipts per month with the Premium plan.',
      guide_faq_q3: 'How are allergens detected?',
      guide_faq_a3: 'Recash compares the product composition (via Open Food Facts) with your health profile and your family\'s. If there is a match, a red alert appears immediately.',
      guide_faq_q4: 'Can I use Recash without an account?',
      guide_faq_a4: 'Yes, but only for product scanning. To save receipts, receive cashbacks and use the wallet, an account is required (free).',
      guide_faq_q5: 'How do I change my subscription plan?',
      guide_faq_a5: 'Go to Profile → Subscription → Change plan. The upgrade takes effect immediately. Cancellation takes effect at the end of the billing period.',
      guide_faq_q6: 'My receipt is not recognised correctly',
      guide_faq_a6: 'Check that the image is sharp, well lit and the receipt is flat. Avoid reflections. Try cropping manually or rescanning.',
      guide_faq_q7: 'The app does not detect my allergen',
      guide_faq_a7: 'Check that the allergen is declared in your profile (Profile → Allergens). If the product is not in Open Food Facts, it cannot be analysed.',
      cta_title: 'Ready to start?',
      cta_desc: 'Scan your first receipt or product now',
      cta_scan_ticket: 'Scan a receipt',
      cta_scan_product: 'Scan a product'
    },
    app: {
      offline_mode: 'Offline mode',
      offline_cached_data: 'Displaying cached data',
      back_online: 'Connection restored',
      cookie_msg: 'We use essential cookies for the application to work. By continuing, you accept our privacy policy.',
      cookie_accept: 'Accept',
      cookie_decline: 'Decline',
      download_data: 'Download my data',
      delete_account: 'Delete my account'
    },
    payment: {
      success_title: 'Payment successful!',
      success_msg: 'Thank you for your subscription. Your account has been updated.',
      success_detail: 'You can now enjoy all features.',
      back_home: 'Back to home',
      cancel_title: 'Payment cancelled',
      cancel_msg: 'You have cancelled the payment process.',
      cancel_detail: 'No amount was charged. You can try again at any time.',
      retry: 'Try again',
      paypal_processing: 'Processing PayPal payment…',
      paypal_wait: 'Please wait while we confirm your payment.',
      paypal_error_title: 'PayPal error',
      paypal_error_generic: 'An error occurred while processing your PayPal payment.',
      paypal_cancelled_title: 'Payment cancelled',
      paypal_cancelled_msg: 'You cancelled the PayPal payment. No amount was charged.',
      try_again: 'Try again'
    },
    support: {
      nav_title: 'How to navigate the app',
      nav_step_1_title: 'Navigation bar (bottom)',
      nav_step_1_desc: 'Use the tab bar at the bottom of the screen to navigate between main sections:',
      nav_home: 'Home: Overview of your savings and alerts',
      nav_scan: 'Scan: Scan receipts or products',
      nav_tickets: 'Receipts: History of your scanned receipts',
      nav_wallet: 'Wallet: Balance and cashback transactions',
      nav_alerts: 'Alerts: Product recalls and allergens',
      nav_profile: 'Profile: Settings and subscription',
      nav_step_2_title: 'Typical usage flow',
      nav_step_2_1: 'Scan a receipt via the Scan tab',
      nav_step_2_2: 'View the result and detected products',
      nav_step_2_3: 'Confirm to save in Receipts',
      nav_step_2_4: 'Cashbacks are automatically added to your wallet',
      nav_step_2_5: 'Alerts appear in Alerts',
      nav_step_3_title: 'Access to help',
      nav_step_3_desc: 'You can access this help page from:',
      nav_step_3_1: 'The home screen (Onboarding)',
      nav_step_3_2: 'The "About" page in Profile',
      page_title: 'Help & Support',
      hero_title: 'How can we help you?',
      faq_label: 'Frequently asked questions',
      contact_label: 'Direct contact',
      email_support: 'Email support',
      response_time: 'Response within 48h (business days)',
      premium_priority: 'Premium/Business subscribers: priority response',
      send_msg_label: 'Send a message',
      your_email: 'Your email',
      subject: 'Subject',
      message_label: 'Message',
      send_msg: 'Send message',
      useful_links: 'Useful links',
      documentation: 'Documentation',
      legal_cgu_link: 'Legal & Terms',
      fill_required: 'Please fill in email and message.',
      msg_sent: 'Message sent! We will respond within 48h.'
    },
    faq: {
      category_scan_product: 'Product scan',
      category_scan_ticket: 'Receipt scan',
      category_accounts: 'Accounts & Subscriptions',
      category_technical: 'Technical issues',
      scan_product_q1: 'Is product scanning free?',
      scan_product_a1: 'Yes, completely free and unlimited. You can scan all products in the store to check their quality (allergens, additives, Nutri-Score, NOVA) without a subscription.',
      scan_product_q2: 'How are allergens detected?',
      scan_product_a2: 'Recash compares the product composition (via Open Food Facts and labels) with your health profile and your family\'s. If there is a match, a red alert appears immediately.',
      scan_ticket_q1: 'How many receipts can I scan for free?',
      scan_ticket_a1: '10 cashback receipts per month with the Free plan. 50 cashback receipts per month with the Premium plan.',
      scan_ticket_q2: 'How does cashback work?',
      scan_ticket_a2: 'Recash scans your receipt, searches for active offers from partner brands (Pampers, Danone, etc.) and sends the request automatically. You receive the money in your Recash wallet within 48h.',
      scan_ticket_q3: 'Why is there a commission on cashback?',
      scan_ticket_a3: 'Recash takes a commission (configurable by the administrator, currently 20%) for: app development and maintenance, third-party API payments (Open Food Facts, Google Vision, etc.) and fast support. You always receive the majority of the cashback (usually 80%).',
      accounts_q1: 'Can I use Recash without an account?',
      accounts_a1: 'Yes, only for product scanning. To save receipts, receive cashbacks and use the wallet, an account is required (free).',
      accounts_q2: 'How do I change my subscription plan?',
      accounts_a2: 'Go to Profile → Subscription → Change plan. The upgrade takes effect immediately. Cancellation takes effect at the end of the billing period.',
      technical_q1: 'My receipt is not recognised correctly',
      technical_a1: 'Check that the image is sharp, well lit and the receipt is flat. Avoid reflections. Try cropping manually or rescanning. If the problem persists, contact support with a screenshot.',
      technical_q2: 'The app does not detect my allergen',
      technical_a2: 'Check that the allergen is declared in your profile (Profile → Allergens). If the product is not in Open Food Facts, it cannot be analysed. You can report the product via the app to enrich the database.'
    },
    legal: {
      title: 'Legal Information',
      cgu: 'Terms',
      privacy: 'Privacy',
      mentions: 'Legal Notices',
      cgu_title: 'Terms of Service',
      privacy_title: 'Privacy Policy',
      mentions_title: 'Legal Notices',
      cgu_article1_title: 'Article 1 – Purpose',
      cgu_article1_text: 'Recash is a mobile application that allows scanning receipts and products to:',
      cgu_article1_item1: 'Detect allergens, additives, Nutri-Score, NOVA',
      cgu_article1_item2: 'Get automatic cashbacks',
      cgu_article1_item3: 'Be alerted in case of product recall or expiring warranty',
      cgu_article1_item4: 'Compare prices with other stores',
      cgu_article2_title: 'Article 2 – Access to the application',
      cgu_article2_text: 'Access to the service requires creating an account. Usage is free with limits (10 receipts/month). Advanced features require a paid subscription.',
      cgu_article2_item1: 'Minimum age: 13 years (or 16 years depending on country)',
      cgu_article2_item2: 'Account required for cashback and wallet',
      cgu_article3_title: 'Article 3 – Product scan',
      cgu_article3_text: 'Product scan is free and unlimited, even without subscription. Data is compared with Open Food Facts and government databases (Health Canada, FDA, DGCCRF).',
      cgu_article4_title: 'Article 4 – Recash commission',
      cgu_article4_text: 'Recash returns to users a portion of the cashback generated by partner brands. A commission is charged by Recash to fund the application, platform fees and technical integrations.',
      cgu_article4_item1: 'Commission rate: The current commission rate is 20% (configurable by administrator)',
      cgu_article4_item2: 'Transparency: The gross amount, commission and net amount are displayed in the application interface for each cashback',
      cgu_article4_item3: 'Calculation: Net amount = Gross amount - (Gross amount × Commission rate)',
      cgu_article4_item4: 'Modification: This rate is visible and modifiable by the administrator. Any change will be communicated by email or notification in the application',
      cgu_article4_item5: 'Withdrawals: Withdrawals are possible to bank account or PayPal (minimum amount applicable)',
      cgu_article4_item6: 'Expiration: Unclaimed cashbacks after 12 months of inactivity are cancelled',
      cgu_article5_title: 'Article 5 – Responsibilities',
      cgu_article5_text: 'Recash provides information for informational purposes only. Nutritional and health information does not constitute medical advice. In case of product recall, Recash is not responsible for contamination or resulting damages.',
      cgu_article6_title: 'Article 6 – Modification of Terms',
      cgu_article6_text: 'Recash reserves the right to modify these Terms at any time. Users will be informed by email or push notification. Continued use after notification constitutes acceptance of the new Terms.',
      cgu_article7_title: 'Article 7 – Termination',
      cgu_article7_text: 'The user can delete their account at any time via Profile → Danger Zone. Data is deleted within 30 days. Recash may suspend any account in case of fraud or violation of Terms.',
      cgu_article8_title: 'Article 8 – Applicable law',
      cgu_article8_text: 'These Terms are governed by Canadian law (province of Quebec). Any dispute will be submitted to the competent courts of Montreal, Canada.',
      cgu_updated: 'Last updated: January 1, 2025',
      privacy_updated: 'Last updated: January 1, 2025',
      privacy_section1_title: '1. Collected data',
      privacy_section1_item1: 'Scanned receipts: products, prices, dates, stores (stored 3 years)',
      privacy_section1_item2: 'Health profile: allergies, diets (stored encrypted)',
      privacy_section1_item3: 'Geolocation: to detect country and nearby stores (optional)',
      privacy_section1_item4: 'Payment data: Stripe (not stored by Recash)',
      privacy_section1_item5: 'Navigation data: anonymized usage logs',
      privacy_section2_title: '2. Processing purposes',
      privacy_section2_item1: 'Optimization of cashbacks and matching with partner offers',
      privacy_section2_item2: 'Detection of allergens and personalized product recalls',
      privacy_section2_item3: 'Improvement of application AI algorithms',
      privacy_section2_item4: 'Sending notifications and security alerts',
      privacy_section3_title: '3. Your rights (GDPR / PIPEDA)',
      privacy_section3_text: 'Under GDPR (EU) and PIPEDA (Canada), you have:',
      privacy_section3_item1: 'Right to access your data',
      privacy_section3_item2: 'Right to rectification',
      privacy_section3_item3: 'Right to erasure (« right to be forgotten »)',
      privacy_section3_item4: 'Right to portability (JSON export)',
      privacy_section3_item5: 'Right to object to processing',
      privacy_section3_contact: 'Contact: support@recash.shop',
      privacy_section4_title: '4. Data storage',
      privacy_section4_text: 'Data stored maximum 3 years after your last login. Final deletion within 30 days following request. Accounting data stored 7 years (legal obligation).',
      privacy_section5_title: '5. Cookies and third-party APIs',
      privacy_section5_item1: 'Open Food Facts (product database, ODbL license)',
      privacy_section5_item2: 'SerpApi (price comparison)',
      privacy_section5_item3: 'Government APIs: Health Canada, FDA, DGCCRF',
      privacy_section5_item4: 'OpenAI (OCR and AI analysis – anonymized data)',
      privacy_section5_item5: 'Stripe (payments – PCI-DSS Level 1)',
      privacy_section6_title: '6. Security',
      privacy_section6_text: 'Data encrypted during transfer (TLS 1.3) and at rest (AES-256). Restricted access to authorized personnel. Regular security audits. No sale of personal data to third parties.',
      mentions_editor_title: 'Application publisher',
      mentions_editor_name: 'Recash, 1522 Rue Ottawa #B701, Montreal, Quebec, Email: support@recash.shop',
      mentions_hosting_title: 'Hosting',
      mentions_hosting_item1: 'Database: Supabase (supabase.io) – AWS us-east-1',
      mentions_hosting_item2: 'Frontend: Vercel (vercel.com)',
      mentions_hosting_item3: 'Backend API: Railway.app',
      mentions_hosting_item4: 'File storage: Supabase Storage (AWS S3)',
      mentions_payment_title: 'Payment provider',
      mentions_payment_text: 'Stripe Inc. – 510 Townsend Street, San Francisco, CA 94103, USA - Certified PCI-DSS Level 1. Recash does not store bank card data.',
      mentions_ip_title: 'Intellectual property',
      mentions_ip_text: 'The Recash application, its logo, texts and features are the exclusive property of Recash Inc. Any reproduction without prior written permission is prohibited.'
    }
  },

  /* ─────────────────── ESPAÑOL ─────────────────── */
  es: {
    nav: {
      home: 'Inicio',
      scan: 'Escanear',
      tickets: 'Tickets',
      wallet: 'Cartera',
      alerts: 'Alertas',
      profile: 'Perfil'
    },
    auth: {
      login: 'Iniciar sesión',
      create: 'Crear cuenta',
      email: 'Email',
      password: 'Contraseña',
      confirm_password: 'Confirmar contraseña',
      email_placeholder: 'tu@email.com',
      password_placeholder: '••••••••',
      signin: 'Iniciar sesión',
      forgot_password: '¿Olvidaste tu contraseña?',
      no_account: '¿Sin cuenta? Crear cuenta',
      have_account: '¿Ya tienes cuenta? Iniciar sesión',
      google: 'Continuar con Google',
      apple: 'Continuar con Apple',
      fill_all_fields: 'Por favor rellena todos los campos',
      passwords_not_match: 'Las contraseñas no coinciden',
      auth_error: 'Error de autenticación',
      login_success: 'Inicio de sesión exitoso',
      account_created: 'Cuenta creada con éxito',
      enter_email_reset: 'Ingresa tu email para restablecer la contraseña',
      reset_email_sent: 'Si esta cuenta existe, se ha enviado un email de restablecimiento.',
      google_dev: '🚧 Inicio con Google en desarrollo',
      apple_dev: '🚧 Inicio con Apple en desarrollo',
      or: 'o',
      legal_text: 'Al continuar, aceptas nuestros T&Cs y Política de privacidad.',
      cgu: 'T&Cs',
      privacy_policy: 'Política de privacidad',
      subtitle: 'Tus ahorros, simplificados',
      register_tab: 'Registro',
      display_name: 'Nombre',
      display_name_placeholder: 'Tu nombre',
      password_min_placeholder: 'Mínimo 8 caracteres',
      confirm_password_placeholder: 'Repite la contraseña',
      creating: 'Registrando...',
      signing_in: 'Conectando...',
      switch_to_register: '¿No tienes cuenta? Regístrate',
      switch_to_login: '¿Ya tienes cuenta? Inicia sesión',
      create_my_account: 'Crear mi cuenta',
      continue_as_guest: 'Continuar como invitado',
      password_min_error: 'La contraseña debe tener al menos 8 caracteres',
      login_error_msg: 'Error de conexión',
      email_not_confirmed: 'Confirma tu correo antes de iniciar sesión. Revisa tu carpeta de spam.',
      register_error_msg: 'Error de registro',
      social_dev_msg: '🚧 Inicio de sesión con {provider} en desarrollo',
      show_password: 'Mostrar contraseña',
      hide_password: 'Ocultar contraseña',
      forgot_password_success: '¡Email enviado! Revisa tu bandeja de entrada.',
      country: 'País',
      country_placeholder: 'Selecciona tu país',
      age_warning: 'Esta aplicación está reservada para personas mayores de 16 años.',
      age_consent: 'Confirmo que tengo al menos 16 años',
      terms_consent: 'Acepto los Términos de Servicio y la Política de privacidad',
      consent_required: 'Debes confirmar tu edad y aceptar los términos para registrarte',
      rgpd_consent: 'Acepto que mis datos personales sean tratados de acuerdo con el RGPD / PIPEDA',
      all_stores: 'Todos los tipos de tienda',
      email_confirm_title: 'Verifica tu correo',
      email_confirm_sent: 'Se ha enviado un correo de confirmación a:',
      email_confirm_spam: '⚠️ Revisa tu carpeta de spam si no lo recibes en 2 minutos.',
      email_confirm_hint: 'Haz clic en el enlace del correo para activar tu cuenta y luego inicia sesión.'
    },
    export: {
      title: 'Exportar mis datos',
      period: 'Período',
      period_7d: '7 días',
      period_30d: '30 días',
      period_90d: '3 meses',
      period_all: 'Todo',
      format: 'Formato',
      preview: 'Vista previa',
      col_date: 'Fecha',
      col_type: 'Tipo',
      col_amount: 'Importe',
      col_currency: 'Moneda',
      col_status: 'Estado',
      col_desc: 'Descripción',
      transactions: 'transacciones',
      total: 'Total',
      loading: 'Cargando...',
      error: 'Error de carga',
      download: 'Descargar'
    },
    budget: {
      title: 'Presupuesto mensual',
      monthly_budget: 'Presupuesto mensual',
      used: 'usado',
      remaining: 'Restante',
      alert: 'Presupuesto casi alcanzado',
      vs_last_month: 'vs mes anterior',
      last_3_months: 'Últimos 3 meses',
      details: 'Detalles',
      tickets: 'Tickets',
      cashback: 'Cashback',
      edit_title: 'Editar presupuesto',
      monthly_limit: 'Límite mensual',
    },
    onboarding: {
      guest: 'Invitado',
      title: 'Recash',
      subtitle: 'Escanea. Protege tu salud. Recupera tu dinero.',
      scan_instant: 'Escaneo Instantáneo y Multi-Ticket',
      scan_description: 'Foto de ticket o código de barras, IA extrae todo en 3s.',
      health_alerts: 'Alertas de Salud en Vivo',
      health_description: 'Alérgenos ocultos y retiradas de productos: mantente informado.',
      cashback: 'Cashback Automático',
      cashback_description: 'Alimentación, farmacia, electrónica, ropa... Todos los tipos de tiendas',
      start_button: 'Empieza a ahorrar',
      legal_text: 'Al continuar, aceptas nuestros',
      terms: 'Términos',
      and: 'y',
      privacy: 'Política de privacidad',
      slide1_title: 'Bienvenido a Recash',
      slide1_desc: 'La app que escanea tus tickets, protege tu salud y te hace ganar dinero en cada compra.',
      slide2_title: 'Lista de Compras',
      slide2_desc: 'Guarda y gestiona fácilmente tu lista de compras.',
      slide3_title: 'Notificaciones Instantáneas',
      slide3_desc: 'Recibe una alerta cuando tu cashback sea acreditado, cuando tu presupuesto se acerque al límite, o en caso de retiro de producto.',
      slide4_title: 'Comparte tus listas',
      slide4_desc: 'Envía tu lista de la compra a tu familia o amigos con un toque. Ideal para compras en grupo.',
      slide5_title: 'Protección Doble Precio & Especiales',
      slide5_desc: 'Recash detecta automáticamente un doble precio en tu ticket.',
      skip: 'Omitir',
      next: 'Siguiente',
      get_started: '¡Empecemos!',
      or_guest: 'Continuar sin cuenta',
      all_stores: 'Todos los tipos de tienda',
      referral_code_label: 'Código de referido (opcional)',
      referral_code_placeholder: 'Ingresa el código…',
      health_title: 'Salud',
      health_desc: 'Alérgenos, aditivos, retiradas de productos',
      regions: 'Recash en América del Norte, América Latina y Europa'
    },
    home: {
      greeting: '¡Hola!',
      hero_title: 'Tus ahorros<br>en un escaneo',
      monthly_savings: 'Ahorrado este mes',
      total_retrieved: 'Ganancias totales',
      scan_ticket: 'Escanear<br>un ticket',
      scan_product: 'Escanear<br>un producto',
      my_wallet: 'Mi<br>cartera',
      guide: 'Guía<br>de uso',
      wallet_balance: 'Saldo disponible',
      view_wallet: 'Ver cartera',
      critical_alerts: 'Alertas críticas',
      recent_receipts: 'Tickets recientes',
      no_alerts: 'Sin alertas',
      no_tickets: 'Sin tickets escaneados',
      scan_first: '¡Escanea tu primer ticket!',
      wallet_available: 'Cartera disponible',
      active_alerts: 'Alertas activas',
      cta_subtitle: 'Recupera tu dinero en segundos',
      recall_product: 'Recall de producto',
      warranty: 'Garantía',
      cashback: 'cashback',
      allergen: 'alérgeno',
      health_score_title: 'Puntuación de salud del mes',
      health_good: 'Bueno',
      health_improve: 'A mejorar',
      critical: 'crítico',
      product: 'producto',
      ultra_processed: 'ultraprocesado',
      see_all: 'Ver todo',
      details: 'Detalles',
      health_score: 'Puntuación de Salud',
      out_of: 'Sobre 100',
      score_good: '👍 Bueno',
      score_improve: '👎 A mejorar',
      allergens: 'Alérgenos',
      ultra_processed_plural: 'Ultraprocesados',
      alerts: 'Alertas',
      recall: 'Recall',
      warranty_label: 'Garantía',
      available_in: 'Disponible en',
      store: 'Tienda',
      pending_cashbacks: 'Cashbacks pendientes',
      no_pending: 'Sin cashbacks pendientes',
      recent_transactions: 'Transacciones recientes',
      no_transactions: 'Sin transacciones',
      withdraw: 'Retirar',
      add: 'Agregar',
      scan: 'Escanear',
      tickets: 'Tickets',
      active: 'Activo',
      currency: 'Moneda',
      total_earnings: 'Ganancias totales',
      account_required: 'Cuenta requerida',
      account_desc: 'Crea una cuenta gratuita para acceder a tu cartera y seguir tus cashbacks.',
      create_account: 'Crear cuenta',
      view_offers: 'Ver ofertas',
      loading_wallet: 'Cargando tu cartera...',
      error: 'Error',
      retry: 'Reintentar',
      profile_title: 'Perfil',
      guest_message: 'Crea una cuenta gratuita para personalizar tu perfil y acceder a todas las funciones.',
      user: 'Usuario',
      stats_tickets: 'Tickets',
      stats_savings: 'Ahorros',
      stats_alerts: 'Alertas resueltas',
      ethical_score: 'Puntuación ética',
      savings: 'Ahorros',
      alerts_resolved: 'Alertas resueltas',
      preferences: 'Preferencias',
      notifications: 'Notificaciones',
      language: 'Idioma',
      ethical_points: 'Puntos Éticos',
      currency_label: 'Moneda',
      allergens_title: 'Alérgenos',
      allergens_desc: 'Declara tus alérgenos o los de tu familia para recibir alertas al escanear productos.',
      save_allergens: 'Guardar mis alérgenos',
      allergen_gluten: 'Gluten (trigo, centeno, cebada)',
      allergen_lactose: 'Lactosa / Leche',
      allergen_eggs: 'Huevos',
      allergen_peanuts: 'Cacahuetes',
      allergen_nuts: 'Frutos secos (almendras, nueces, avellanas)',
      allergen_soy: 'Soja',
      allergen_fish: 'Pescado',
      allergen_shellfish: 'Crustáceos / Moluscos',
      allergen_sesame: 'Sésamo',
      allergen_sulfites: 'Sulfitos',
      allergen_mustard: 'Mostaza',
      allergen_celery: 'Apio',
      allergen_lupin: 'Altramuz',
      allergen_molluscs: 'Moluscos',
      subscription: 'Suscripción',
      free_plan: 'Acceso a funciones básicas',
      premium_plan: 'Cashback ilimitado, alertas prioritarias',
      pro_plan: 'Todo Premium + API, soporte prioritario',
      view_offers_btn: 'Ver ofertas',
      manage: 'Gestionar',
      actions: 'Acciones',
      support: 'Soporte',
      legal: 'Aviso legal',
      delete_account: 'Eliminar mi cuenta',
      logout: 'Cerrar sesión',
      logout_confirm: '¿Estás seguro de que quieres cerrar sesión?',
      cancel: 'Cancelar',
      logout_btn: 'Cerrar sesión',
      delete_confirm_title: '⚠️ Eliminación de cuenta',
      delete_confirm_msg: 'Esta acción es irreversible. Todos tus datos serán eliminados.',
      delete_btn: 'Eliminar',
      delete_error: 'Error al eliminar',
      upload_error: 'Error al subir',
      save_success: 'Alérgenos guardados',
      save_error: 'Error al guardar',
      family_members: 'Miembros de la familia',
      family_desc: 'Añade miembros de la familia con sus alérgenos.',
      add_member: 'Añadir miembro',
      member_name: 'Nombre',
      member_age: 'Edad',
      member_allergens: 'Alérgenos',
      remove_member: 'Eliminar',
      save_family: 'Guardar familia',
      all_stores: 'Todos los tipos de tienda'
    },
    scan: {
      title: 'Escanear',
      ticket_tab: 'Ticket',
      product_tab: 'Producto',
      take_photo: 'Tomar una foto',
      import_gallery: 'Importar desde galería',
      upload_pdf: 'Subir PDF',
      scan_barcode: 'Toca para escanear un producto',
      scan_ticket: 'Escanear un ticket',
      scan_product: 'Escanear un producto',
      scan_btn: 'Escanear',
      processing: 'Procesando...',
      analyzing: 'Analizando...',
      success: 'Éxito',
      error: 'Error',
      retry: 'Reintentar',
      capture_ticket: 'Captura un ticket o importa un archivo',
      searching_barcode: 'Buscando código de barras...',
      scanning_hint: '🔍 Detección automática… apunta la cámara al código de barras',
      stop_scanner: 'Detener',
      enter_barcode: 'Ingresa el código de barras',
      uploading: 'Subiendo...',
      analyzing_ai: 'Análisis IA en curso...',
      searching_product: 'Buscando producto...',
      products_detected: 'Productos detectados',
      validate_save: 'Validar y guardar',
      score_excellent: 'Excelente',
      score_good: 'Bueno',
      score_average: 'Promedio',
      score_avoid: 'Evitar',
      camera_access_denied: 'Acceso a cámara denegado',
      analysis_failed: 'El análisis falló.',
      analysis_timeout: 'Análisis expirado, por favor intenta de nuevo.',
      unknown_product: 'Producto desconocido',
      ticket_saved: 'Ticket guardado',
      ticket_saved_desc: 'Su ticket ha sido analizado y guardado.',
      view_ticket: 'Ver ticket',
      scan_another: 'Escanear otro ticket',
      session_title: 'Sesión en curso',
      session_count: '{n} ticket(s) escaneado(s)',
      view_all_tickets: 'Ver todos mis tickets',
      session_store: 'Tienda desconocida',
      end_session: 'Terminar sesión',
      flipp_local_deals: 'Ofertas en tienda',
      flipp_valid_until: 'Hasta el',
      flipp_no_deals: 'No se encontraron ofertas cerca de ti',
      flipp_location_label: 'Ofertas locales en',
      upload_failed: 'Error al subir',
      permission_denied: 'Permiso denegado',
      barcode_unavailable: 'Escaneo de código de barras no disponible en PC. Usa entrada manual.',
      product_found: 'Producto encontrado',
      product_not_found: 'No se pudo encontrar este producto',
      all_stores: 'Todos los tipos de tienda',
      location_banner: '📍 Para ofrecerle las mejores ofertas de su región, usamos su ubicación GPS. Sus datos permanecen en su dispositivo y nunca se comparten con terceros.',
      location_banner_dismiss: 'Entendido'
    },
    tickets: {
      title: 'Mis tickets',
      no_tickets: 'Sin tickets escaneados',
      scan_first: 'Escanea tu primer ticket para comenzar',
      date: 'Fecha',
      store: 'Tienda',
      amount: 'Monto',
      status: 'Estado',
      cashback: 'Cashback',
      pending: 'Pendiente',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      unknown_store: 'Tienda desconocida',
      history: 'Historial',
      history_desc: 'Consulta todos tus tickets escaneados',
      filter_all: 'Todos',
      filter_active: 'Activos',
      filter_refunded: 'Reembolsados',
      filter_review: 'Revisión',
      filter_alerts: 'Alertas',
      scan_ticket: 'Escanear un ticket',
      expires: 'Expira el',
      no_warranty: 'Sin garantía',
      alert: 'alerta',
      alerts: 'alertas',
      status_processed: 'Procesado',
      status_processing: 'Procesando',
      status_failed: 'Fallido',
      status_pending: 'Pendiente',
      status_review: 'Revisión',
      default_category: 'Abarrotes',
      search_placeholder: 'Buscar un producto...',
      all_stores: 'Todos los tipos de tienda'
    },
    referral: {
      title: 'Referidos',
      hero_title: 'Invita amigos, gana recompensas',
      hero_subtitle: 'Comparte tu código y recibe cashback cuando tu amigo escanee sus primeros tickets',
      you_earn: 'Tú ganas',
      friend_gets: 'Tu amigo recibe',
      trigger_note: 'Recompensa activada después de {n} tickets escaneados por tu referido',
      your_code: 'Tu código de referido',
      copied: '¡Código copiado!',
      share: 'Compartir mi código',
      share_msg: 'Únete a Recash con mi código {code} y obtén {days} días Premium gratis. Escanea tickets y gana cashback.',
      stats_title: 'Mis referidos',
      total_referrals: 'Invitados',
      credited: 'Validados',
      total_earned: 'Ganado',
      have_code: '¿Tienes un código amigo?',
      enter_code: 'Ingresa el código…',
      apply: 'Aplicar',
      apply_success: '✅ ¡Código aplicado! {days} días Premium desbloqueados.',
      apply_error: 'Código inválido o ya utilizado',
      load_error: 'No se pueden cargar los datos de referido',
      retry: 'Intentar de nuevo'
    },
    shopping_list: {
      title: 'Lista de compras',
      add_placeholder: 'Agregar un artículo...',
      add: 'Agregar',
      empty_title: 'Tu lista está vacía',
      empty_subtitle: 'Empieza por agregar artículos',
      scan_to_add: 'Escanear un producto',
      import_from_ticket: 'Importar desde ticket',
      search_placeholder: 'Buscar un producto...',
      clear_checked: 'Eliminar marcados',
      share: 'Compartir lista',
      items_count: 'artículo(s)',
      checked_count: 'marcado(s)',
      estimated_cashback: 'Cashback estimado',
      delete: 'Eliminar',
      item_added: 'Artículo agregado',
      list_cleared: 'Lista limpiada',
      imported: 'Artículos importados desde el último ticket',
      no_recent_ticket: 'Sin ticket reciente para importar',
      qty: 'Cant.',
      summary_title: 'Resumen',
      total_items: 'Total artículos',
      total_cashback: 'Cashback potencial',
      quick_action: 'Mi lista 🛒',
      section_title: '🛒 Mi lista de compras',
      view_list: 'Ver lista',
      pending_items: 'artículo(s) restante(s)',
      all_done: '¡Todo listo!',
      confirm_clear: '¿Eliminar artículos marcados?',
      confirm_clear_all: '¿Estás seguro de que quieres vaciar toda tu lista de compras?',
      search_products_title: 'Buscar productos',
      select_products: 'Selecciona productos',
      import_selected: 'Importar productos seleccionados',
      no_results: 'Sin resultados',
      enter_search_terms: 'Ingresa al menos 2 caracteres',
      yes: 'Sí',
      no: 'No',
      quantity_label: 'Cantidad'
    },
    profile: {
      title: 'Perfil',
      guest_message: 'Crea una cuenta gratuita para personalizar tu perfil y acceder a todas las funcionalidades.',
      user: 'Usuario',
      stats_tickets: 'Tickets',
      stats_savings: 'Ahorros',
      stats_alerts: 'Alertas Resueltas',
      my_info: 'Mi Información',
      first_name: 'Nombre',
      last_name: 'Apellido',
      email: 'Email',
      email_readonly_note: 'El email no puede ser modificado',
      phone: 'Teléfono',
      phone_placeholder: '+1 514 555-1234',
      save_info: 'Guardar',
      preferences: 'Preferencias',
      notifications: 'Notificaciones',
      language: 'Idioma',
      ethical_points: 'Puntos Éticos',
      monthly_budget: 'Presupuesto Mensual',
      currency: 'Moneda',
      allergens: 'Alérgenos',
      allergens_desc: 'Declara tus alérgenos o los de tu familia para recibir alertas al escanear productos.',
      manage_allergens: 'Gestionar Alérgenos',
      no_allergies_registered: 'Sin alérgenos registrados',
      member_allergens_of: 'Alérgenos de',
      add_member: 'Añadir Miembro',
      modal_close: 'Cerrar',
      save_allergens: 'Guardar Alérgenos',
      subscription: 'Suscripción',
      plan_free: 'Gratuito',
      plan_premium: 'Premium',
      plan_pro: 'Pro',
      plan_business: 'Business',
      plan_free_desc: 'Acceso a funcionalidades básicas',
      plan_premium_desc: '50 tickets cashback / mes, alertas prioritarias',
      plan_pro_desc: 'Funcionalidades avanzadas para profesionales',
      plan_business_desc: 'Tickets cashback ilimitados, solución completa para empresas',
      view_offers: 'Ver Ofertas',
      manage: 'Gestionar',
      ethical_score: 'Puntuación Ética',
      local_purchases: 'Compras Locales',
      eco_friendly: 'Ecológico',
      fair_trade: 'Comercio Justo',
      actions: 'Acciones',
      referral_badge: 'Nuevo',
      guide: 'Guía',
      support: 'Soporte',
      legal: 'Legal',
      delete_account: 'Eliminar Cuenta',
      logout: 'Cerrar Sesión',
      allergen_gluten: 'Gluten (trigo, centeno, cebada)',
      allergen_lactose: 'Lactosa / Leche',
      allergen_eggs: 'Huevos',
      allergen_peanuts: 'Cacahuetes',
      allergen_nuts: 'Frutos secos (almendras, nueces, avellanas)',
      allergen_soy: 'Soja',
      allergen_fish: 'Pescado',
      allergen_shellfish: 'Mariscos',
      allergen_sesame: 'Sésamo',
      allergen_sulfites: 'Sulfitos',
      allergen_mustard: 'Mostaza',
      allergen_celery: 'Apio',
      allergen_lupin: 'Altramuz',
      allergen_molluscs: 'Moluscos',
      allergens_saved: 'Alérgenos guardados',
      allergens_error: 'Error al guardar alérgenos',
      member_added: 'Miembro añadido',
      member_add_error: 'Error al añadir miembro',
      profile_saved: 'Perfil guardado',
      save_error: 'Error al guardar',
      notifications_enabled: 'Notificaciones activadas ✅',
      notifications_disabled: 'Notificaciones desactivadas',
      notifications_denied: 'Permiso denegado. Active las notificaciones en la configuración del navegador.',
      logout_title: 'Cerrar Sesión',
      logout_confirm: '¿Estás seguro de que quieres cerrar sesión?',
      delete_title: 'Eliminar Cuenta',
      delete_confirm: 'Esta acción es irreversible. Todos tus datos serán eliminados.',
      delete_confirm_btn: 'Eliminar',
      delete_error: 'Error al eliminar cuenta',
      upload_error: 'Error al subir'
    },
    ticket_detail: {
      ticket_of: 'Ticket del',
      loading: 'Cargando ticket...',
      error: 'Error',
      retry: 'Reintentar',
      no_photo: 'Sin foto disponible',
      total: 'Total',
      status: 'Estado',
      products: 'Productos',
      alerts_section: 'Alertas',
      request_refund: 'Solicitar Reembolso',
      ticket_photo: 'Foto del Ticket',
      close: 'Cerrar',
      id_missing: 'ID del ticket faltante',
      cannot_load: 'No se puede cargar el ticket',
      claim_sent: 'Reclamación enviada',
      claim_error: 'Error al enviar reclamación',
      status_completed: 'Reembolsado',
      status_processed: 'Procesado',
      status_processing: 'Procesando',
      status_failed: 'Fallido',
      status_pending: 'Pendiente',
      cashback_pending: 'Pendiente',
      cashback_approved: 'Aprobado',
      cashback_paid: 'Pagado',
      allergen: 'Alérgeno',
      recall: 'Retirada'
    },
    wallet: {
      title: 'Cartera',
      balance: 'Saldo',
      available: 'Disponible',
      pending: 'Pendiente',
      withdrawn: 'Retirado',
      withdraw: 'Retirar',
      withdraw_btn: 'Retirar dinero',
      withdraw_success: 'Retiro exitoso',
      withdraw_error: 'Error durante el retiro',
      no_transactions: 'Sin transacciones',
      payment_methods: 'Métodos de pago',
      add_payment: 'Añadir método de pago',
      paypal: 'PayPal',
      bank_account: 'Cuenta bancaria',
      reserved: 'Reservado para miembros',
      guest_message: 'Cartera, retiros y cashback están reservados para miembros Recash. Crea una cuenta gratuita para empezar.',
      guest_banner_title: 'Ver cashback de invitado',
      guest_banner_desc: 'Regístrate para retirar tus ganancias y acceder a todas las funcionalidades.',
      loading: 'Cargando...',
      error_title: 'Error',
      pending_cashbacks: 'Cashbacks pendientes',
      no_cashback: 'Sin cashback pendiente',
      transactions: 'Transacciones',
      withdraw_modal_title: 'Retirar a cuenta bancaria',
      amount: 'Cantidad',
      transfer_method: 'Método de transferencia',
      status_completed: 'Completado',
      status_pending: 'Pendiente',
      status_failed: 'Fallido',
      type: 'Tipo',
      tickets: 'Tickets',
      add: 'Añadir',
      scan: 'Escanear',
      no_pending: 'Sin pagos pendientes',
      recent_transactions: 'Transacciones recientes',
      scan_ticket: 'Escanear un ticket',
      withdraw_title: 'Retiro',
      max: 'Máximo',
      withdraw_method: 'Método de retiro',
      bank_transfer: 'Transferencia bancaria',
      iban: 'IBAN',
      add_payment_title: 'Añadir método de pago',
      paypal_email: 'Email PayPal',
      load_error: 'No se pudieron cargar los datos de la cartera',
      invalid_amount: 'Cantidad inválida',
      insufficient_balance: 'Saldo insuficiente',
      fill_destination: 'Por favor rellena el campo de destino',
      withdrawal_requested: 'Retiro solicitado exitosamente',
      confirm_withdraw: 'Confirmar retiro',
      bank_card: 'Tarjeta bancaria'
    },
    health_dashboard: {
      title: 'Panel de Salud',
      monthly_score: 'Puntuación mensual',
      base_score: 'Puntuación base',
      personalized_score: 'Puntuación personalizada',
      cumulative_stats: 'Estadísticas acumuladas',
      health_points: 'Puntos de salud',
      co2_saved: 'CO2 ahorrado',
      water_saved: 'Agua ahorrada',
      products_scanned: 'Productos escaneados',
      trends: 'Tendencias',
      score_trend: 'Tendencia del score',
      co2_trend: 'Tendencia CO2',
      recent_products: 'Productos recientes',
      no_products: 'Ningún producto escaneado este mes'
    },
    ethical: {
      title: 'Puntos Éticos',
      ineligible_msg: 'Los puntos éticos solo están disponibles en Canadá.',
      your_location: 'Tu ubicación',
      unknown: 'Desconocido',
      this_month: 'Este mes',
      points: 'Puntos',
      value: 'Valor',
      choices: 'Elecciones',
      points_remaining: 'puntos restantes / 100 max',
      total_cumulative: 'Total acumulado',
      earned: 'ganados',
      double_bonus: 'Doble bono',
      points_per_choice: 'Puntos/elección',
      recent_activity: 'Actividad reciente',
      no_activity: 'Sin actividad reciente',
      start_scanning: '¡Escanea productos para acumular puntos éticos!',
      monthly_history: 'Historial mensual',
      alternative: 'Alternativa'
    },
    common: {
      loading: 'Cargando...',
      error: 'Ocurrió un error',
      retry: 'Reintentar',
      view_details: 'Ver detalles',
      see_all: 'Ver todo',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Guardar',
      delete: 'Eliminar',
      close: 'Cerrar',
      back: 'Volver',
      yes: 'Sí',
      no: 'No',
      ok: 'OK',
      search: 'Buscar',
      selected: 'Seleccionado',
      continue: 'Continuar',
      continue_with: 'Continuar con {plan}'
    },
    pricing: {
      offers: 'Nuestras ofertas', choose_plan: 'Elige tu plan',
      choose_plan_subtitle: 'Planes para cada necesidad',
      redirect_payment: 'Redirigiendo...', free: 'Gratis', per_month: '/ mes', per_year: '/ año', save_2_months: '2 meses gratis',
      ten_tickets_month: '10 tickets cashback / mes', product_scan: 'Escaneo productos',
      basic_alerts: 'Alertas básicas', manufacturer_warranties: 'Garantías',
      unlimited_cashback: 'Cashback ilimitado', priority_support: 'Soporte prioritario',
      start_free: 'Empezar gratis', popular: 'Popular', premium: 'Premium',
      unlimited_tickets: 'Tickets ilimitados', tickets_cashback_month: 'tickets cashback / mes', unlimited_tickets_cashback: 'Tickets cashback ilimitados', advanced_alerts: 'Alertas avanzadas',
      extended_warranties: 'Garantías ampliadas', choose_premium: 'Elegir Premium',
      pro: 'Pro', choose_pro: 'Elegir Pro', faq_title: 'FAQ',
      faq_q1: '¿Cancelar?', faq_a1: 'Sí, sin compromiso.',
      faq_q2: '¿Es gratuito el registro?', faq_a2: 'Sí, el registro es gratuito en el plan gratuito y obtienes 10 cashbacks gratuitos.',
      faq_q3: '¿Cashback?', faq_a3: 'Acreditado automáticamente.',
      faq_q4: '¿Datos seguros?', faq_a4: 'Sí, cifrados.',
      payment_url_missing: 'URL faltante', payment_error: 'Error de pago',
      pay_with: 'Pagar con',
      pay_card: 'Tarjeta bancaria',
      pay_interac: 'Interac e-Transfer',
      interac_title: 'Pago por Interac e-Transfer',
      interac_subtitle: 'Envía una transferencia Interac desde tu aplicación bancaria',
      interac_step1: '1. Abre tu aplicación bancaria',
      interac_step2: '2. Envía el importe exacto a la dirección indicada',
      interac_step3: '3. Escribe este código en el mensaje',
      interac_step4: '4. Tu suscripción se activará en 24 h hábiles',
      interac_email_label: 'Dirección e-Transfer',
      interac_amount_label: 'Importe a enviar',
      interac_code_label: 'Código de referencia (obligatorio en el mensaje)',
      interac_expiry: 'Este código expira en 72 horas',
      interac_copy: 'Copiar',
      interac_copied: '¡Copiado!',
      interac_confirm: 'He enviado la transferencia',
      interac_pending: 'Esperando confirmación',
      interac_pending_desc: 'En cuanto recibamos tu pago, tu suscripción se activará automáticamente.',
      interac_error: 'Error al crear la solicitud Interac',
      paypal_subtitle: 'Pago seguro con tu cuenta PayPal',
      stripe_subtitle: 'Visa, Mastercard, Amex — pago seguro',
      pay_wire: 'Transferencia bancaria',
      wire_subtitle: 'Transferencia desde tu banco — activación en 24 h',
      wire_title: 'Pago por transferencia bancaria',
      wire_bank: 'Banco',
      wire_holder: 'Titular de la cuenta',
      wire_institution: 'Institución / Tránsito',
      wire_account: 'Número de cuenta',
      wire_step1: '1. Inicia sesión en tu banca en línea',
      wire_step2: '2. Envía el importe exacto con este código como referencia',
      wire_step3: '3. Tu suscripción se activará en 24 horas hábiles',
      wire_error: 'Error al crear la solicitud de transferencia'
    },
    anti_waste: {
      title: 'Anti-Desperdicio',
      subtitle: 'Reduce tu impacto ambiental',
      better_packaging: 'Mejor embalaje',
      less_plastic: 'Menos plástico',
      better_eco_score: 'Mejor Eco-Score',
      local_product: 'Producto local',
      seasonal_product: 'Producto de temporada',
      no_suggestions: 'No hay sugerencias disponibles para este producto',
      packaging_preferred: 'Embalaje preferido',
      packaging_preferred_desc: 'Elija productos con embalaje reciclable (cartón, vidrio) cuando sea posible.',
      less_plastic_alt: 'Alternativa con menos plástico',
      less_plastic_desc: 'Este producto contiene plástico. Aquí hay una alternativa con mejor embalaje.',
      better_eco_alt: 'Alternativa con mejor Eco-Score',
      better_eco_alt_desc: 'Pruebe esta alternativa con un mejor impacto ambiental.',
      prefer_local: 'Prefiera productos locales',
      prefer_local_desc: 'Este producto viene de lejos. Para frutas, verduras y productos frescos, elegir local reduce la huella de carbono y apoya la economía regional.',
      seasonal_tip: 'Producto de temporada',
      seasonal_tip_desc: 'Prefiera frutas y verduras de temporada para un mejor impacto ambiental y gustativo.',
      responsible_consumption: 'Consumo responsable',
      responsible_consumption_desc: 'Compre solo lo que necesita y prefiera productos con buen Nutri-Score y Eco-Score.'
    },
    scan_result: {
      price_paid: 'Precio pagado:',
      nutri_score: 'Nutri-Score =',
      personalized_score: 'Puntuación personalizada',
      base_score: 'Puntuación base',
      personalized_score_label: 'Puntuación personalizada',
      nutrition_title: 'Información nutricional (por 100g)',
      sugars: 'Azúcares',
      saturated_fat: 'Grasas saturadas',
      calories: 'Calorías',
      fiber: 'Fibra',
      proteins: 'Proteínas',
      sodium: 'Sodio',
      country: 'País',
      category: 'Categoría',
      defects: 'Defectos',
      qualities: 'Cualidades',
      additives: 'Aditivos',
      palm_oil_detected: '⚠️ Aceite de palma detectado',
      contains_additives: 'Este producto contiene {count} aditivos',
      allergens: 'Alérgenos',
      ingredients: 'Ingredientes',
      comparison_title: 'Comparación de precios',
      no_market_data: '📊 Datos de mercado insuficientes para este producto.',
      avg_market: 'Promedio del mercado',
      cheapest: 'Más barato',
      stores_compared: 'tienda(s) comparada(s)',
      where_cheaper: '📉 Dónde es más barato',
      best_price_market: '✅ ¡Compraste este producto al mejor precio del mercado!',
      same_product_cheaper: 'Mismo producto más barato',
      savings: 'Ahorro:',
      healthier_alternatives: 'Alternativas más saludables',
      best_health_score: 'Mejor puntuación de salud',
      eco_alternatives: 'Alternativas más ecológicas',
      less_co2_impact: 'Menos impacto CO2',
      ethical_points: 'Puntos éticos',
      ethical_description: 'Gana puntos éticos por tus elecciones saludables y ecológicas',
      ethical_value: '💰 100 puntos = $1 CAD',
      points_available: 'Puntos disponibles',
      grocery_offers: 'Ofertas de supermercado',
      offers_count: 'oferta(s)',
      no_offers: 'Sin ofertas',
      no_offers_for: 'No se encontraron ofertas para',
      in_region: 'en los folletos de',
      no_promotion: 'Este producto no está actualmente en oferta en ningún supermercado local.',
      compare_online: '🔍 Comparar precios en línea',
      cashback_available: 'Cashback disponible',
      disclaimer: 'Sugerencias solo informativas (Open Food Facts & socios). Ninguna marca paga a Recash. Los precios y la disponibilidad pueden variar.',
      score_excellent: 'Excelente',
      score_good: 'Bueno',
      score_mediocre: 'Mediocre',
      score_avoid: 'A evitar',
      score_explanation: 'Puntuación de salud sobre 100: cuanto mayor, mejor para la salud.',
      defect_too_fat: 'Demasiado graso',
      defect_moderate_fat: 'Grasa moderada',
      defect_very_caloric: 'Muy calórico',
      defect_moderate_caloric: 'Calorías moderadas',
      defect_too_salty: 'Demasiado salado',
      defect_too_sugary: 'Demasiado azucarado',
      defect_moderate_sugars: 'Azúcares moderados',
      quality_excellent_amount: 'Cantidad excelente',
      quality_good_amount: 'Buena cantidad',
      quality_excellent_intake: 'Aporte excelente',
      quality_correct_intake: 'Aporte adecuado',
      quality_low_sodium: 'Bajo en sodio',
      error_rate_limit: 'OpenFoodFacts está limitando las solicitudes — espere unos segundos e inténtelo de nuevo.'
    },
    product: {
      eco_score: 'Eco-Score',
      price_position_best: 'Mejor precio',
      price_position_competitive: 'Precio competitivo',
      price_position_expensive: 'Precio elevado',
      price_position_overpriced: 'Precio excesivo',
      price_position_unknown: 'Precio desconocido'
    },
    guide: {
      title: 'Guía de uso',
      complete_guide: 'Guía completa',
      subtitle: 'Todo lo que necesitas saber para usar Recash',
      section_scan_ticket_title: 'Escanear un ticket',
      section_scan_ticket_desc: 'Cómo escanear tus tickets para obtener cashback y seguir tus gastos.',
      section_scan_product_title: 'Escanear un producto',
      section_scan_product_desc: 'Analiza cualquier producto por su código de barras para conocer su composición y puntuaciones.',
      section_scores_title: 'Entender las puntuaciones',
      section_scores_desc: 'Nutri-Score, NOVA, Eco-Score… todo sobre los indicadores de calidad.',
      section_cashback_title: 'Cashback',
      section_cashback_desc: 'Funcionamiento del cashback, plazos de procesamiento y retiros.',
      section_wallet_title: 'Cartera y Retiros',
      section_wallet_desc: 'Gestiona tu saldo y retira dinero mediante PayPal o transferencia bancaria.',
      section_shopping_title: 'Lista de compras',
      section_shopping_desc: 'Crea, gestiona y comparte tu lista de compras inteligente.',
      section_budget_title: 'Presupuesto mensual',
      section_budget_desc: 'Sigue tus gastos por categoría y define límites de presupuesto.',
      section_antiwaste_title: 'Anti-desperdicio',
      section_antiwaste_desc: 'Reduce tu impacto ambiental con sugerencias de alternativas.',
      section_ethical_title: 'Puntos Éticos',
      section_ethical_desc: 'Gana puntos eligiendo alternativas eco-responsables.',
      section_alerts_title: 'Alertas y Avisos',
      section_alerts_desc: 'Mantente informado sobre avisos de productos, garantías y alertas personalizadas.',
      section_faq_title: 'FAQ',
      section_faq_desc: 'Las preguntas más frecuentes sobre Recash.',
      scan_ticket_step1_title: 'Toma una foto',
      scan_ticket_step1_desc: 'Coloca tu ticket plano sobre un fondo liso. Asegúrate de que la foto sea nítida, bien iluminada y sin reflejos.',
      scan_ticket_step2_title: 'Importa la imagen',
      scan_ticket_step2_desc: 'Toma una foto directamente desde la app o importa una imagen de tu galería. Los PDFs también se aceptan.',
      scan_ticket_step3_title: 'Análisis automático',
      scan_ticket_step3_desc: 'Nuestra IA analiza tu ticket en segundos: tienda, fecha, importe total y cada artículo con su precio.',
      scan_ticket_step4_title: 'Descubre tus ganancias',
      scan_ticket_step4_desc: 'Recash busca automáticamente las ofertas de cashback disponibles para tus compras. Ves inmediatamente el importe que puedes recuperar.',
      scan_ticket_step5_title: 'Confirma y sigue',
      scan_ticket_step5_desc: 'Confirma los datos y sigue la evolución de tus cashbacks en tu cartera. Los fondos se acreditan en 48h.',
      scan_product_step1_title: 'Escanea el código de barras',
      scan_product_step1_desc: 'Usa la cámara de tu teléfono para escanear el código de barras de un producto. También puedes introducir el código manualmente.',
      scan_product_step2_title: 'Análisis instantáneo',
      scan_product_step2_desc: 'Recash consulta la base de datos Open Food Facts y muestra: Nutri-Score, NOVA, Eco-Score, ingredientes, alérgenos, aditivos.',
      scan_product_step3_title: 'Comprueba las alertas',
      scan_product_step3_desc: 'Si el producto contiene un alérgeno declarado en tu perfil, aparece inmediatamente una alerta roja.',
      scan_product_step4_title: 'Compara alternativas',
      scan_product_step4_desc: 'Descubre productos alternativos mejor valorados, más baratos o más saludables disponibles en tu región.',
      score_nutri_name: 'Nutri-Score',
      score_nutri_desc: 'Evalúa la calidad nutricional global de un producto de A (mejor) a E (peor). Basado en nutrientes y alimentos a favorecer/limitar.',
      score_nova_name: 'NOVA',
      score_nova_desc: 'Clasifica los alimentos según su grado de procesamiento: 1 (crudo) a 4 (ultraprocesado). Prefiere las puntuaciones 1 y 2.',
      score_eco_name: 'Eco-Score',
      score_eco_desc: 'Evalúa el impacto ambiental del producto de A (impacto muy bajo) a E (impacto muy alto). Considera el embalaje, el transporte, la producción.',
      score_health_name: 'Puntuación Salud',
      score_health_desc: 'Nuestra puntuación personalizada que combina Nutri-Score, NOVA, Eco-Score y tus preferencias de salud/alergias para darte una nota sobre 100.',
      cashback_how_title: '¿Cómo funciona?',
      cashback_how_desc: 'Al escanear un ticket, Recash identifica los productos elegibles para cashback — alimentación, electrónica, ropa, farmacia, hogar y más — entre nuestras marcas asociadas. La solicitud se envía automáticamente.',
      cashback_delays_title: 'Plazos de procesamiento',
      cashback_delays_desc: 'Los cashbacks se acreditan generalmente en 48h tras la validación del ticket. Los plazos pueden variar según los socios.',
      cashback_commission_title: 'Comisión de Recash',
      cashback_commission_desc: 'Recash cobra una comisión (configurable por el administrador, actualmente 20%) para cubrir costes de desarrollo, APIs y soporte. Siempre recibes la mayoría del importe.',
      cashback_withdrawal_title: 'Retirada de fondos',
      cashback_withdrawal_desc: 'Puedes retirar tu dinero en cualquier momento mediante transferencia bancaria, PayPal o Stripe. El importe mínimo de retiro es de 5€/5$/5£.',
      cashback_tracking_title: 'Seguimiento en tiempo real',
      cashback_tracking_desc: 'Consulta tu historial de cashback, los importes pendientes y las ganancias totales desde la página Cartera.',
      wallet_balance_title: 'Tu saldo',
      wallet_balance_desc: 'Tu saldo disponible corresponde a los cashbacks validados. Los importes "pendientes" se acreditarán cuando nuestros socios los validen.',
      wallet_paypal_title: 'Retiro vía PayPal',
      wallet_paypal_desc: 'Introduce tu email PayPal y el importe deseado. La transferencia es automática y llega en 24h a tu cuenta PayPal.',
      wallet_bank_title: 'Transferencia bancaria',
      wallet_bank_desc: 'Proporciona tu IBAN para una transferencia directa a tu cuenta bancaria. Plazo: 1 a 3 días hábiles.',
      wallet_delay_title: 'Plazos de retiro',
      wallet_delay_desc: 'PayPal: en 24h. Transferencia bancaria: 1 a 3 días hábiles. Importe mínimo: 5€/5$/5£.',
      wallet_tracking_title: 'Historial completo',
      wallet_tracking_desc: 'Consulta todas tus transacciones (cashbacks recibidos, retiros realizados) con su estado en tiempo real.',
      shopping_step1_title: 'Crea tu lista',
      shopping_step1_desc: 'Añade artículos manualmente escribiendo su nombre, o importa los productos de tu último ticket escaneado con un toque.',
      shopping_step2_title: 'Escanea para añadir',
      shopping_step2_desc: 'Escanea el código de barras de un producto en la tienda para añadirlo directamente a tu lista con su información nutricional.',
      shopping_step3_title: 'Gestiona sobre la marcha',
      shopping_step3_desc: 'Marca los artículos mientras compras. Ajusta las cantidades, elimina los artículos no deseados.',
      shopping_step4_title: 'Comparte tu lista',
      shopping_step4_desc: 'Envía tu lista de compras a tu familia o amigos con un toque. Ideal para compras compartidas.',
      budget_set_title: 'Define tu presupuesto',
      budget_set_desc: 'Fija un presupuesto mensual global en Perfil → Presupuesto. Recash calcula automáticamente tus gastos a partir de los tickets escaneados.',
      budget_categories_title: 'Categorías',
      budget_categories_desc: 'Tus gastos se clasifican automáticamente por categoría (alimentación, farmacia, electrónica…) para un seguimiento preciso.',
      budget_alert_title: 'Alertas de presupuesto',
      budget_alert_desc: 'Recibe una notificación cuando te acercas a tu límite mensual, para mantener el control de tus gastos.',
      budget_monthly_title: 'Balance mensual',
      budget_monthly_desc: 'Consulta tu balance mensual con comparativa respecto al mes anterior y visualización gráfica de tus gastos.',
      antiwaste_packaging_title: 'Embalaje responsable',
      antiwaste_packaging_desc: 'Recash sugiere alternativas con mejor embalaje (cartón, vidrio, sin embalaje) para reducir tus residuos plásticos.',
      antiwaste_local_title: 'Prefiere lo local',
      antiwaste_local_desc: 'Para frutas, verduras y productos frescos, elegir local reduce tu huella de carbono y apoya la economía regional.',
      antiwaste_seasonal_title: 'Productos de temporada',
      antiwaste_seasonal_desc: 'Recash identifica los productos fuera de temporada y sugiere alternativas de temporada, mejores para el medio ambiente y el sabor.',
      antiwaste_alternatives_title: 'Alternativas eco',
      antiwaste_alternatives_desc: 'Descubre productos similares con mejor Eco-Score o menor impacto ambiental en tu región.',
      ethical_what_title: '¿Qué son los Puntos Éticos?',
      ethical_what_desc: 'Los Puntos Éticos recompensan tus decisiones de consumo responsable. Cuando escaneas un producto y existe una alternativa más ecológica, ganas puntos.',
      ethical_how_title: '¿Cómo ganarlos?',
      ethical_how_desc: 'Escanea productos y elige las alternativas recomendadas. Cuanto más virtuosa sea la alternativa (bio, local, sin embalaje, comercio justo), más puntos ganas.',
      ethical_value_title: 'Valor de los puntos',
      ethical_value_desc: 'Cada punto ético tiene un valor monetario. Puedes acumularlos y convertirlos. El máximo es de 100 puntos al mes.',
      ethical_availability_title: 'Disponibilidad',
      ethical_availability_desc: 'Los Puntos Éticos están actualmente disponibles solo en Canadá. Estamos trabajando para extender este programa a otros países.',
      coming_next_version: 'Disponible en la próxima versión',
      ethical_coming_soon_desc: 'Los Puntos Éticos se introducirán en la próxima actualización de Recash. ¡Permanece atento!',
      alert_recalls_title: 'Avisos de productos',
      alert_recalls_desc: 'Recibe una notificación inmediata si un producto que has comprado está sujeto a un aviso sanitario (listeria, salmonela, cuerpo extraño, etc.).',
      alert_warranty_title: 'Garantías',
      alert_warranty_desc: 'Sigue las fechas de garantía de tus compras. Recibe una alerta antes de la expiración para no perder tus derechos.',
      alert_allergens_title: 'Alérgenos',
      alert_allergens_desc: 'Declara tus alergias en tu perfil. Recash te avisa automáticamente si un producto escaneado contiene un alérgeno peligroso para ti o tu familia.',
      alert_price_title: 'Anomalías de precio',
      alert_price_desc: 'Si el precio escaneado en tu ticket difiere significativamente del precio habitual o del precio mostrado en la tienda, se genera una alerta.',
      guide_faq_q1: '¿El escaneo de productos es gratuito?',
      guide_faq_a1: 'Sí, completamente gratuito e ilimitado. Puedes escanear todos los productos en la tienda para verificar su calidad sin suscripción.',
      guide_faq_q2: '¿Cuántos tickets puedo escanear gratis?',
      guide_faq_a2: '10 tickets cashback al mes con el plan Gratuito. 50 tickets cashback al mes con el plan Premium.',
      guide_faq_q3: '¿Cómo se detectan los alérgenos?',
      guide_faq_a3: 'Recash compara la composición del producto (vía Open Food Facts) con tu perfil de salud y el de tu familia. En caso de coincidencia, aparece inmediatamente una alerta roja.',
      guide_faq_q4: '¿Puedo usar Recash sin cuenta?',
      guide_faq_a4: 'Sí, solo para el escaneo de productos. Para guardar tickets, recibir cashbacks y usar la cartera, se necesita una cuenta (gratuita).',
      guide_faq_q5: '¿Cómo cambio mi plan de suscripción?',
      guide_faq_a5: 'Ve a Perfil → Suscripción → Cambiar plan. La actualización es inmediata. La cancelación se hace efectiva al final del período de facturación.',
      guide_faq_q6: 'Mi ticket no se reconoce correctamente',
      guide_faq_a6: 'Comprueba que la imagen sea nítida, bien iluminada y que el ticket esté plano. Evita los reflejos. Intenta recortar manualmente o volver a escanear.',
      guide_faq_q7: 'La app no detecta mi alérgeno',
      guide_faq_a7: 'Comprueba que el alérgeno esté declarado en tu perfil (Perfil → Alérgenos). Si el producto no está en Open Food Facts, no puede analizarse.',
      cta_title: '¿Listo para empezar?',
      cta_desc: 'Escanea ahora tu primer ticket o producto',
      cta_scan_ticket: 'Escanear un ticket',
      cta_scan_product: 'Escanear un producto'
    },
    app: {
      offline_mode: 'Modo sin conexión',
      offline_cached_data: 'Mostrando datos en caché',
      back_online: 'Conexión restablecida',
      cookie_msg: 'Usamos cookies esenciales para el funcionamiento de la aplicación. Al continuar, aceptas nuestra política de privacidad.',
      cookie_accept: 'Aceptar',
      cookie_decline: 'Rechazar',
      download_data: 'Descargar mis datos',
      delete_account: 'Eliminar mi cuenta'
    },
    payment: {
      success_title: '¡Pago exitoso!',
      success_msg: 'Gracias por tu suscripción. Tu cuenta ha sido actualizada.',
      success_detail: 'Ya puedes disfrutar de todas las funcionalidades.',
      back_home: 'Volver al inicio',
      cancel_title: 'Pago cancelado',
      cancel_msg: 'Has cancelado el proceso de pago.',
      cancel_detail: 'No se ha cobrado ningún importe. Puedes intentarlo de nuevo en cualquier momento.',
      retry: 'Intentar de nuevo',
      paypal_processing: 'Procesando pago PayPal…',
      paypal_wait: 'Por favor espera mientras confirmamos tu pago.',
      paypal_error_title: 'Error de PayPal',
      paypal_error_generic: 'Ocurrió un error al procesar tu pago de PayPal.',
      paypal_cancelled_title: 'Pago cancelado',
      paypal_cancelled_msg: 'Cancelaste el pago de PayPal. No se ha cobrado ningún importe.',
      try_again: 'Intentar de nuevo'
    },
    support: {
      nav_title: 'Cómo navegar en la app',
      nav_step_1_title: 'Barra de navegación (abajo)',
      nav_step_1_desc: 'Usa la barra de pestañas en la parte inferior de la pantalla para navegar entre las secciones principales:',
      nav_home: 'Inicio: Vista general de tus ahorros y alertas',
      nav_scan: 'Escanear: Escanear tickets o productos',
      nav_tickets: 'Tickets: Historial de tus tickets escaneados',
      nav_wallet: 'Cartera: Saldo y transacciones cashback',
      nav_alerts: 'Alertas: Retiros de productos y alérgenos',
      nav_profile: 'Perfil: Configuración y suscripción',
      nav_step_2_title: 'Flujo de uso típico',
      nav_step_2_1: 'Escanea un ticket vía la pestaña Escanear',
      nav_step_2_2: 'Visualiza el resultado y productos detectados',
      nav_step_2_3: 'Confirma para guardar en Tickets',
      nav_step_2_4: 'Los cashbacks se añaden automáticamente a tu cartera',
      nav_step_2_5: 'Las alertas aparecen en Alertas',
      nav_step_3_title: 'Acceso a la ayuda',
      nav_step_3_desc: 'Puedes acceder a esta página de ayuda desde:',
      nav_step_3_1: 'La pantalla de inicio (Onboarding)',
      nav_step_3_2: 'La página "Acerca de" en el Perfil',
      page_title: 'Ayuda y Soporte',
      hero_title: '¿Cómo podemos ayudarte?',
      faq_label: 'Preguntas frecuentes',
      contact_label: 'Contacto directo',
      email_support: 'Soporte por email',
      response_time: 'Respuesta dentro de 48h (días laborables)',
      premium_priority: 'Suscriptores Premium/Business: respuesta prioritaria',
      send_msg_label: 'Enviar mensaje',
      your_email: 'Tu email',
      subject: 'Asunto',
      message_label: 'Mensaje',
      send_msg: 'Enviar mensaje',
      useful_links: 'Enlaces útiles',
      documentation: 'Documentación',
      legal_cgu_link: 'Menciones legales y CGU',
      fill_required: 'Por favor rellena el email y el mensaje.',
      msg_sent: '¡Mensaje enviado! Responderemos dentro de 48h.'
    },
    faq: {
      category_scan_product: 'Escaneo de producto',
      category_scan_ticket: 'Escaneo de ticket',
      category_accounts: 'Cuentas y Suscripciones',
      category_technical: 'Problemas técnicos',
      scan_product_q1: '¿El escaneo de productos es gratuito?',
      scan_product_a1: 'Sí, completamente gratuito e ilimitado. Puedes escanear todos los productos en la tienda para verificar su calidad (alérgenos, aditivos, Nutri-Score, NOVA) sin suscripción.',
      scan_product_q2: '¿Cómo se detectan los alérgenos?',
      scan_product_a2: 'Recash compara la composición del producto (vía Open Food Facts y etiquetas) con tu perfil de salud y el de tu familia. En caso de coincidencia, aparece inmediatamente una alerta roja.',
      scan_ticket_q1: '¿Cuántos tickets puedo escanear gratis?',
      scan_ticket_a1: '10 tickets cashback al mes con el plan Gratuito. 50 tickets cashback al mes con el plan Premium.',
      scan_ticket_q2: '¿Cómo funciona el cashback?',
      scan_ticket_a2: 'Recash escanea tu ticket, busca ofertas activas de marcas asociadas (Pampers, Danone, etc.) y envía la solicitud automáticamente. Recibes el dinero en tu cartera Recash dentro de 48h.',
      scan_ticket_q3: '¿Por qué hay una comisión en el cashback?',
      scan_ticket_a3: 'Recash toma una comisión (configurable por el administrador, actualmente 20%) para: desarrollo y mantenimiento de la aplicación, pago de APIs de terceros (Open Food Facts, Google Vision, etc.) y soporte rápido. Siempre recibes la mayoría del cashback (generalmente 80%).',
      accounts_q1: '¿Puedo usar Recash sin cuenta?',
      accounts_a1: 'Sí, solo para el escaneo de productos. Para guardar tickets, recibir cashbacks y usar la cartera, se necesita una cuenta (gratuita).',
      accounts_q2: '¿Cómo cambio mi plan de suscripción?',
      accounts_a2: 'Ve a Perfil → Suscripción → Cambiar plan. La actualización es inmediata. La cancelación se hace efectiva al final del período de facturación.',
      technical_q1: 'Mi ticket no se reconoce correctamente',
      technical_a1: 'Comprueba que la imagen sea nítida, bien iluminada y que el ticket esté plano. Evita los reflejos. Intenta recortar manualmente o volver a escanear. Si el problema persiste, contacta el soporte con una captura de pantalla.',
      technical_q2: 'La app no detecta mi alérgeno',
      technical_a2: 'Comprueba que el alérgeno esté declarado en tu perfil (Perfil → Alérgenos). Si el producto no está en Open Food Facts, no puede analizarse. Puedes reportar el producto vía la app para enriquecer la base de datos.'
    },
    legal: {
      title: 'Información legal',
      cgu: 'Términos',
      privacy: 'Privacidad',
      mentions: 'Aviso legal',
      cgu_title: 'Condiciones Generales de Uso',
      privacy_title: 'Política de privacidad',
      mentions_title: 'Aviso legal',
      cgu_article1_title: 'Artículo 1 – Objeto',
      cgu_article1_text: 'Recash es una aplicación móvil que permite escanear tickets y productos para:',
      cgu_article1_item1: 'Detectar alérgenos, aditivos, Nutri-Score, NOVA',
      cgu_article1_item2: 'Obtener cashbacks automáticos',
      cgu_article1_item3: 'Ser alertado en caso de recall de producto o garantía a expirar',
      cgu_article1_item4: 'Comparar precios con otras tiendas',
      cgu_article2_title: 'Artículo 2 – Acceso a la aplicación',
      cgu_article2_text: 'El acceso al servicio requiere la creación de una cuenta. El uso es gratuito con límites (10 tickets/mes). Las funcionalidades avanzadas requieren una suscripción de pago.',
      cgu_article2_item1: 'Edad mínima: 13 años (o 16 años dependiendo del país)',
      cgu_article2_item2: 'Cuenta necesaria para cashback y wallet',
      cgu_article3_title: 'Artículo 3 – Escaneo de producto',
      cgu_article3_text: 'El escaneo de producto es gratuito e ilimitado, incluso sin suscripción. Los datos se comparan con Open Food Facts y bases gubernamentales (Santé Canada, FDA, DGCCRF).',
      cgu_article4_title: 'Artículo 4 – Comisión Recash',
      cgu_article4_text: 'Recash devuelve a los usuarios una parte del cashback generado por las marcas partners. Una comisión es cobrada por Recash para financiar la aplicación, tarifas de plataforma e integraciones técnicas.',
      cgu_article4_item1: 'Tasa de comisión: La tasa de comisión actual es de 20% (configurable por el administrador)',
      cgu_article4_item2: 'Transparencia: El monto bruto, la comisión y el monto neto se muestran en la interfaz de la aplicación para cada cashback',
      cgu_article4_item3: 'Cálculo: Monto neto = Monto bruto - (Monto bruto × Tasa de comisión)',
      cgu_article4_item4: 'Modificación: Esta tasa es visible y modificable por el administrador. Cualquier cambio será comunicado por email o notificación en la aplicación',
      cgu_article4_item5: 'Retiros: Los retiros son posibles a cuenta bancaria o PayPal (monto mínimo aplicable)',
      cgu_article4_item6: 'Expiración: Los cashbacks no reclamados después de 12 meses de inactividad son cancelados',
      cgu_article5_title: 'Artículo 5 – Responsabilidades',
      cgu_article5_text: 'Recash proporciona información solo a título indicativo. La información nutricional y de salud no constituye consejo médico. En caso de recall de producto, Recash no es responsable por la contaminación ni daños resultantes.',
      cgu_article6_title: 'Artículo 6 – Modificación de los Términos',
      cgu_article6_text: 'Recash se reserva el derecho de modificar los presentes Términos en cualquier momento. Los usuarios serán informados por email o notificación push. La continuación del uso después de notificación constituye aceptación de los nuevos Términos.',
      cgu_article7_title: 'Artículo 7 – Terminación',
      cgu_article7_text: 'El usuario puede eliminar su cuenta en cualquier momento desde Perfil → Zona de peligro. Los datos son eliminados en 30 días. Recash puede suspender cualquier cuenta en caso de fraude o violación de los Términos.',
      cgu_article8_title: 'Artículo 8 – Derecho aplicable',
      cgu_article8_text: 'Los presentes Términos se rigen por el derecho canadiense (provincia de Quebec). Cualquier litigio será sometido a los tribunales competentes de Montreal, Canadá.',
      cgu_updated: 'Última actualización: 1 de enero de 2025',
      privacy_updated: 'Última actualización: 1 de enero de 2025',
      privacy_section1_title: '1. Datos recopilados',
      privacy_section1_item1: 'Tickets escaneados: productos, precios, fechas, tiendas (conservados 3 años)',
      privacy_section1_item2: 'Perfil de salud: alérgenos, dietas (almacenados de forma cifrada)',
      privacy_section1_item3: 'Geolocalización: para detectar el país y tiendas cercanas (opcional)',
      privacy_section1_item4: 'Datos de pago: Stripe (no almacenados por Recash)',
      privacy_section1_item5: 'Datos de navegación: logs de uso anonimizados',
      privacy_section2_title: '2. Finalidades del tratamiento',
      privacy_section2_item1: 'Optimización de cashbacks y matching con ofertas partners',
      privacy_section2_item2: 'Detección de alérgenos y recalls de productos personalizados',
      privacy_section2_item3: 'Mejora de los algoritmos IA de la aplicación',
      privacy_section2_item4: 'Envío de notificaciones y alertas de seguridad',
      privacy_section3_title: '3. Sus derechos (RGPD / PIPEDA)',
      privacy_section3_text: 'Conforme al RGPD (UE) y PIPEDA (Canadá), tiene:',
      privacy_section3_item1: 'Derecho de acceso a sus datos',
      privacy_section3_item2: 'Derecho de rectificación',
      privacy_section3_item3: 'Derecho de supresión (« derecho al olvido »)',
      privacy_section3_item4: 'Derecho de portabilidad (exportación JSON)',
      privacy_section3_item5: 'Derecho de oposición al tratamiento',
      privacy_section3_contact: 'Contacto: support@recash.shop',
      privacy_section4_title: '4. Almacenamiento de datos',
      privacy_section4_text: 'Datos almacenados máximo 3 años después de su último inicio de sesión. Eliminación definitiva dentro de los 30 días siguientes a la solicitud. Datos contables almacenados 7 años (obligación legal).',
      privacy_section5_title: '5. Cookies y APIs de terceros',
      privacy_section5_item1: 'Open Food Facts (base de datos productos, licencia ODbL)',
      privacy_section5_item2: 'SerpApi (comparación de precios)',
      privacy_section5_item3: 'APIs gubernamentales: Santé Canada, FDA, DGCCRF',
      privacy_section5_item4: 'OpenAI (OCR y análisis IA – datos anonimizados)',
      privacy_section5_item5: 'Stripe (pagos – PCI-DSS Level 1)',
      privacy_section6_title: '6. Seguridad',
      privacy_section6_text: 'Datos cifrados durante la transferencia (TLS 1.3) y en reposo (AES-256). Acceso restringido al personal autorizado. Auditorías de seguridad regulares. Ninguna venta de datos personales a terceros.',
      mentions_editor_title: 'Editor de la aplicación',
      mentions_editor_name: 'Recash, 1522 Rue Ottawa #B701, Montreal, Quebec, Email: support@recash.shop',
      mentions_hosting_title: 'Hospedaje',
      mentions_hosting_item1: 'Base de datos: Supabase (supabase.io) – AWS us-east-1',
      mentions_hosting_item2: 'Frontend: Vercel (vercel.com)',
      mentions_hosting_item3: 'API Backend: Railway.app',
      mentions_hosting_item4: 'Almacenamiento de archivos: Supabase Storage (AWS S3)',
      mentions_payment_title: 'Proveedor de pago',
      mentions_payment_text: 'Stripe Inc. – 510 Townsend Street, San Francisco, CA 94103, USA - Certificado PCI-DSS Level 1. Recash no almacena datos de tarjeta bancaria.',
      mentions_ip_title: 'Propiedad intelectual',
      mentions_ip_text: 'La aplicación Recash, su logo, textos y funcionalidades son propiedad exclusiva de Recash Inc. Cualquier reproducción sin autorización escrita previa está prohibida.'
    }
  },

  /* ─────────────────── DEUTSCH ─────────────────── */
  de: {
    auth: {
      login: 'Anmelden',
      create: 'Konto erstellen',
      email: 'E-Mail',
      password: 'Passwort',
      confirm_password: 'Passwort bestätigen',
      email_placeholder: 'deine@email.com',
      password_placeholder: '••••••••',
      signin: 'Anmelden',
      forgot_password: 'Passwort vergessen?',
      no_account: 'Kein Konto? Konto erstellen',
      have_account: 'Bereits ein Konto? Anmelden',
      google: 'Mit Google fortfahren',
      apple: 'Mit Apple fortfahren',
      fill_all_fields: 'Bitte fülle alle Felder aus',
      passwords_not_match: 'Passwörter stimmen nicht überein',
      auth_error: 'Authentifizierungsfehler',
      login_success: 'Anmeldung erfolgreich',
      account_created: 'Konto erfolgreich erstellt',
      enter_email_reset: 'Gib deine E-Mail ein, um das Passwort zurückzusetzen',
      reset_email_sent: 'Wenn dieses Konto existiert, wurde eine Reset-E-Mail gesendet.',
      google_dev: '🚧 Google-Anmeldung in Entwicklung',
      apple_dev: '🚧 Apple-Anmeldung in Entwicklung',
      or: 'oder',
      oder: 'oder',
      legal_text: 'Durch Fortsetzen akzeptierst du unsere AGB und Datenschutzrichtlinie.',
      cgu: 'AGB',
      privacy_policy: 'Datenschutzrichtlinie',
      subtitle: 'Deine Ersparnisse, vereinfacht',
      register_tab: 'Registrieren',
      display_name: 'Anzeigename',
      display_name_placeholder: 'Dein Name',
      password_min_placeholder: 'Mindestens 8 Zeichen',
      confirm_password_placeholder: 'Passwort wiederholen',
      creating: 'Registrieren...',
      signing_in: 'Anmelden...',
      switch_to_register: 'Noch kein Konto? Registrieren',
      switch_to_login: 'Bereits ein Konto? Anmelden',
      create_my_account: 'Mein Konto erstellen',
      continue_as_guest: 'Als Gast fortfahren',
      password_min_error: 'Passwort muss mindestens 8 Zeichen lang sein',
      login_error_msg: 'Anmeldefehler',
      email_not_confirmed: 'Bitte bestätige deine E-Mail, bevor du dich anmeldest. Prüfe deinen Spam-Ordner.',
      register_error_msg: 'Registrierungsfehler',
      social_dev_msg: '🚧 {provider}-Anmeldung in Entwicklung',
      show_password: 'Passwort anzeigen',
      hide_password: 'Passwort verbergen',
      forgot_password_success: 'E-Mail gesendet! Überprüfe deinen Posteingang.',
      country: 'Land',
      country_placeholder: 'Wähle dein Land',
      age_warning: 'Diese Anwendung ist für Personen ab 16 Jahren bestimmt.',
      age_consent: 'Ich bestätige, dass ich mindestens 16 Jahre alt bin',
      terms_consent: 'Ich akzeptiere die Nutzungsbedingungen und Datenschutzerklärung',
      consent_required: 'Du musst dein Alter bestätigen und die Bedingungen akzeptieren',
      rgpd_consent: 'Ich stimme zu, dass meine personenbezogenen Daten gemäß DSGVO / PIPEDA verarbeitet werden',
      all_stores: 'Alle Geschäftstypen',
      email_confirm_title: 'E-Mail bestätigen',
      email_confirm_sent: 'Eine Bestätigungs-E-Mail wurde gesendet an:',
      email_confirm_spam: '⚠️ Prüfe deinen Spam-Ordner, falls du sie nicht innerhalb von 2 Minuten erhältst.',
      email_confirm_hint: 'Klicke auf den Link in der E-Mail, um dein Konto zu aktivieren, dann melde dich an.'
    },
    export: {
      title: 'Meine Daten exportieren',
      period: 'Zeitraum',
      period_7d: '7 Tage',
      period_30d: '30 Tage',
      period_90d: '3 Monate',
      period_all: 'Alle',
      format: 'Format',
      preview: 'Vorschau',
      col_date: 'Datum',
      col_type: 'Typ',
      col_amount: 'Betrag',
      col_currency: 'Währung',
      col_status: 'Status',
      col_desc: 'Beschreibung',
      transactions: 'Transaktionen',
      total: 'Gesamt',
      loading: 'Laden...',
      error: 'Ladefehler',
      download: 'Herunterladen'
    },
    budget: {
      title: 'Monatsbudget',
      monthly_budget: 'Monatsbudget',
      used: 'verwendet',
      remaining: 'Übrig',
      alert: 'Budget fast erreicht',
      vs_last_month: 'vs letzten Monat',
      last_3_months: 'Letzte 3 Monate',
      details: 'Details',
      tickets: 'Belege',
      cashback: 'Cashback',
      edit_title: 'Budget bearbeiten',
      monthly_limit: 'Monatliches Limit',
    },
    onboarding: {
      guest: 'Gast',
      title: 'Recash',
      subtitle: 'Scannen. Gesundheit schützen. Geld zurückholen.',
      scan_instant: 'Sofort-Scan & Multi-Beleg-Scan',
      scan_description: 'Belegfoto oder Barcode, KI extrahiert alles in 3s.',
      health_alerts: 'Live-Gesundheitswarnungen',
      health_description: 'Versteckte Allergene & Produktrückrufe: informiert bleiben.',
      cashback: 'Automatisches Cashback',
      cashback_description: 'Lebensmittel, Apotheke, Elektronik, Kleidung... Alle Geschäftstypen',
      start_button: 'Sparen beginnen',
      legal_text: 'Durch Fortsetzen stimmen Sie unseren',
      terms: 'AGB',
      and: '&',
      privacy: 'Datenschutzerklärung',
      slide1_title: 'Willkommen bei Recash',
      slide1_desc: 'Die App, die deine Belege scannt, deine Gesundheit schützt und dir bei jedem Einkauf Geld einbringt.',
      slide2_title: 'Einkaufsliste',
      slide2_desc: 'Speichere und verwalte deine Einkaufsliste einfach.',
      slide3_title: 'Sofortbenachrichtigungen',
      slide3_desc: 'Erhalte eine Benachrichtigung, sobald dein Cashback gutgeschrieben wird, dein Budget sich dem Limit nähert oder bei einem Produktrückruf.',
      slide4_title: 'Listen teilen',
      slide4_desc: 'Sende deine Einkaufsliste mit einem Tap an Familie oder Freunde. Ideal für gemeinsame Einkäufe.',
      slide5_title: 'Doppelpreis- & Sonderangebots-Schutz',
      slide5_desc: 'Recash erkennt automatisch einen Doppelpreis auf deinem Beleg.',
      skip: 'Überspringen',
      next: 'Weiter',
      get_started: 'Loslegen!',
      or_guest: 'Ohne Konto fortfahren',
      all_stores: 'Alle Geschäftstypen',
      referral_code_label: 'Empfehlungscode (optional)',
      referral_code_placeholder: 'Code eingeben…',
      health_title: 'Gesundheit',
      health_desc: 'Allergene, Zusatzstoffe, Produktrückrufe',
      regions: 'Recash in Nordamerika, Lateinamerika und Europa'
    },
    home: {
      greeting: 'Hallo!',
      hero_title: 'Deine Ersparnisse<br>in einem Scan',
      monthly_savings: 'Diesen Monat gespart',
      total_retrieved: 'Gesamteinnahmen',
      scan_ticket: 'Beleg<br>scannen',
      scan_product: 'Produkt<br>scannen',
      my_wallet: 'Mein<br>Wallet',
      guide: 'Benutzer<br>handbuch',
      wallet_balance: 'Verfügbares Guthaben',
      view_wallet: 'Wallet anzeigen',
      critical_alerts: 'Kritische Warnungen',
      recent_receipts: 'Letzte Belege',
      no_alerts: 'Keine Warnungen',
      no_tickets: 'Keine gescannten Belege',
      scan_first: 'Scanne deinen ersten Beleg!',
      wallet_available: 'Verfügbares Wallet',
      active_alerts: 'Aktive Warnungen',
      cta_subtitle: 'Hol dir dein Geld in Sekunden zurück',
      recall_product: 'Produktrückruf',
      warranty: 'Garantie',
      cashback: 'cashback',
      allergen: 'Allergen',
      health_score_title: 'Gesundheitsscore des Monats',
      health_good: 'Gut',
      health_improve: 'Zu verbessern',
      critical: 'kritisch',
      product: 'Produkt',
      ultra_processed: 'ultra-verarbeitet',
      see_all: 'Alle anzeigen',
      details: 'Details',
      health_score: 'Gesundheitsscore',
      out_of: 'Von 100',
      score_good: '👍 Gut',
      score_improve: '👎 Zu verbessern',
      allergens: 'Allergene',
      ultra_processed_plural: 'Ultra-verarbeitet',
      alerts: 'Warnungen',
      recall: 'Rückruf',
      warranty_label: 'Garantie',
      available_in: 'Verfügbar in',
      store: 'Geschäft',
      pending_cashbacks: 'Ausstehende Cashbacks',
      no_pending: 'Keine ausstehenden Cashbacks',
      recent_transactions: 'Letzte Transaktionen',
      no_transactions: 'Keine Transaktionen',
      withdraw: 'Abheben',
      add: 'Hinzufügen',
      scan: 'Scannen',
      tickets: 'Belege',
      active: 'Aktiv',
      currency: 'Währung',
      total_earnings: 'Gesamteinnahmen',
      account_required: 'Konto erforderlich',
      account_desc: 'Erstelle ein kostenloses Konto, um auf dein Wallet zuzugreifen und deine Cashbacks zu verfolgen.',
      create_account: 'Konto erstellen',
      view_offers: 'Angebote anzeigen',
      loading_wallet: 'Wallet wird geladen...',
      error: 'Fehler',
      retry: 'Wiederholen',
      profile_title: 'Profil',
      guest_message: 'Erstellen Sie ein kostenloses Konto, um Ihr Profil anzupassen und auf alle Funktionen zuzugreifen.',
      user: 'Benutzer',
      stats_tickets: 'Belege',
      stats_savings: 'Ersparnisse',
      stats_alerts: 'Gelöste Warnungen',
      ethical_score: 'Ethischer Score',
      savings: 'Ersparnisse',
      alerts_resolved: 'Warnungen gelöst',
      preferences: 'Einstellungen',
      notifications: 'Benachrichtigungen',
      language: 'Sprache',
      ethical_points: 'Ethische Punkte',
      currency_label: 'Währung',
      allergens_title: 'Allergene',
      allergens_desc: 'Gib deine Allergene oder die deiner Familie an, um beim Scannen von Produkten Warnungen zu erhalten.',
      save_allergens: 'Allergene speichern',
      allergen_gluten: 'Gluten (Weizen, Roggen, Gerste)',
      allergen_lactose: 'Laktose / Milch',
      allergen_eggs: 'Eier',
      allergen_peanuts: 'Erdnüsse',
      allergen_nuts: 'Baumnüsse (Mandeln, Walnüsse, Haselnüsse)',
      allergen_soy: 'Soja',
      allergen_fish: 'Fisch',
      allergen_shellfish: 'Krebstiere / Weichtiere',
      allergen_sesame: 'Sesam',
      allergen_sulfites: 'Sulfite',
      allergen_mustard: 'Senf',
      allergen_celery: 'Sellerie',
      allergen_lupin: 'Lupine',
      allergen_molluscs: 'Weichtiere',
      subscription: 'Abonnement',
      free_plan: 'Zugang zu Basis-Funktionen',
      premium_plan: 'Unbegrenztes Cashback, Prioritätswarnungen',
      pro_plan: 'Alles Premium + API, Prioritäts-Support',
      view_offers_btn: 'Angebote anzeigen',
      manage: 'Verwalten',
      actions: 'Aktionen',
      support: 'Support',
      legal: 'Impressum',
      delete_account: 'Konto löschen',
      logout: 'Abmelden',
      logout_confirm: 'Bist du sicher, dass du dich abmelden möchtest?',
      cancel: 'Abbrechen',
      logout_btn: 'Abmelden',
      delete_confirm_title: '⚠️ Kontolöschung',
      delete_confirm_msg: 'Diese Aktion ist unwiderruflich. Alle deine Daten werden gelöscht.',
      delete_btn: 'Löschen',
      delete_error: 'Fehler beim Löschen',
      upload_error: 'Upload fehlgeschlagen',
      save_success: 'Allergene gespeichert',
      save_error: 'Fehler beim Speichern',
      family_members: 'Familienmitglieder',
      family_desc: 'Füge Familienmitglieder mit ihren Allergenen hinzu.',
      add_member: 'Mitglied hinzufügen',
      member_name: 'Vorname',
      member_age: 'Alter',
      member_allergens: 'Allergene',
      remove_member: 'Entfernen',
      save_family: 'Familie speichern'
    },
    scan: {
      title: 'Scannen',
      ticket_tab: 'Beleg',
      product_tab: 'Produkt',
      take_photo: 'Foto aufnehmen',
      import_gallery: 'Aus Galerie importieren',
      upload_pdf: 'PDF hochladen',
      scan_barcode: 'Tippen um ein Produkt zu scannen',
      scan_ticket: 'Beleg scannen',
      scan_product: 'Produkt scannen',
      scan_btn: 'Scannen',
      processing: 'Verarbeitung...',
      analyzing: 'Analyse...',
      success: 'Erfolg',
      error: 'Fehler',
      retry: 'Wiederholen',
      capture_ticket: 'Beleg erfassen oder Datei importieren',
      searching_barcode: 'Barcode wird gesucht...',
      scanning_hint: '🔍 Automatische Erkennung… Kamera auf Barcode richten',
      stop_scanner: 'Stoppen',
      enter_barcode: 'Barcode eingeben',
      uploading: 'Hochladen...',
      analyzing_ai: 'KI-Analyse läuft...',
      searching_product: 'Produkt wird gesucht...',
      products_detected: 'Produkte erkannt',
      validate_save: 'Validieren und speichern',
      score_excellent: 'Ausgezeichnet',
      score_good: 'Gut',
      score_average: 'Mittel',
      score_avoid: 'Vermeiden',
      camera_access_denied: 'Kamerazugriff verweigert',
      analysis_failed: 'Analyse fehlgeschlagen.',
      analysis_timeout: 'Analyse abgelaufen, bitte erneut versuchen.',
      unknown_product: 'Unbekanntes Produkt',
      ticket_saved: 'Beleg gespeichert',
      ticket_saved_desc: 'Ihr Beleg wurde analysiert und gespeichert.',
      view_ticket: 'Beleg anzeigen',
      scan_another: 'Weiteren Beleg scannen',
      session_title: 'Aktuelle Sitzung',
      session_count: '{n} Beleg(e) gescannt',
      view_all_tickets: 'Alle Belege anzeigen',
      session_store: 'Unbekanntes Geschäft',
      end_session: 'Sitzung beenden',
      flipp_local_deals: 'Angebote im Supermarkt',
      flipp_valid_until: 'Bis',
      flipp_no_deals: 'Keine Angebote in Ihrer Nähe gefunden',
      flipp_location_label: 'Lokale Angebote in',
      upload_failed: 'Upload fehlgeschlagen',
      permission_denied: 'Berechtigung verweigert',
      barcode_unavailable: 'Barcode-Scan auf PC nicht verfügbar. Verwenden Sie die manuelle Eingabe.',
      product_found: 'Produkt gefunden',
      product_not_found: 'Produkt konnte nicht gefunden werden',
      location_banner: '📍 Um Ihnen die besten Angebote in Ihrer Region zu bieten, verwenden wir Ihren GPS-Standort. Ihre Daten bleiben auf Ihrem Gerät und werden nie an Dritte weitergegeben.',
      location_banner_dismiss: 'Verstanden'
    },
    tickets: {
      title: 'Meine Belege',
      no_tickets: 'Keine gescannten Belege',
      scan_first: 'Scanne deinen ersten Beleg um zu beginnen',
      date: 'Datum',
      store: 'Geschäft',
      amount: 'Betrag',
      status: 'Status',
      cashback: 'Cashback',
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      rejected: 'Abgelehnt',
      unknown_store: 'Unbekanntes Geschäft',
      history: 'Verlauf',
      history_desc: 'Alle gescannten Belege anzeigen',
      filter_all: 'Alle',
      filter_active: 'Aktiv',
      filter_refunded: 'Erstattet',
      filter_review: 'Prüfung',
      filter_alerts: 'Warnungen',
      scan_ticket: 'Beleg scannen',
      expires: 'Läuft ab am',
      no_warranty: 'Keine Garantie',
      alert: 'Warnung',
      alerts: 'Warnungen',
      status_processed: 'Verarbeitet',
      status_processing: 'Verarbeitung',
      status_failed: 'Fehlgeschlagen',
      status_pending: 'Ausstehend',
      status_review: 'Prüfung',
      default_category: 'Lebensmittel',
      search_placeholder: 'Nach einem Produkt suchen...'
    },
    alerts: {
      title: 'Warnungen',
      no_alerts: 'Keine Warnungen',
      all_alerts: 'Alle Warnungen',
      critical: 'Kritisch',
      moderate: 'Mäßig',
      mild: 'Leicht',
      type: 'Typ',
      date: 'Datum',
      severity: 'Schwere',
      mark_read: 'Als gelesen markieren',
      delete: 'Löschen',
      recall: 'Produktrückruf',
      allergen: 'Allergen',
      warranty: 'Garantie',
      filter_all: 'Alle',
      filter_recall: 'Rückrufe',
      filter_warranty: 'Garantien',
      filter_price: 'Preis',
      filter_cashback: 'Cashback',
      filter_ticket: 'Belege',
      filter_budget: 'Budget',
      loading: 'Laden...',
      view_ticket: 'Beleg anzeigen',
      type_recall: 'Rückruf',
      type_warranty: 'Garantie',
      type_price: 'Preis',
      type_cashback: 'Cashback',
      type_ticket: 'Beleg gescannt',
      type_cashback_credited: 'Cashback gutgeschrieben',
      type_budget_warning: 'Budget-Warnung',
      type_budget_exceeded: 'Budget überschritten',
      severity_critical: 'Kritisch',
      severity_warning: 'Warnung',
      severity_info: 'Info',
      product_label: 'Produkt: ',
      less_than_hour: 'Vor weniger als einer Stunde',
      hours_ago: 'Vor {h}h',
      yesterday: 'Gestern',
      days_ago: 'Vor {d} Tagen',
      load_error: 'Warnungen konnten nicht geladen werden'
    },
    wallet: {
      title: 'Wallet',
      balance: 'Guthaben',
      available: 'Verfügbar',
      pending: 'Ausstehend',
      withdrawn: 'Abgehoben',
      withdraw: 'Abheben',
      withdraw_btn: 'Abheben',
      withdraw_success: 'Abhebung erfolgreich',
      withdraw_error: 'Abhebungsfehler',
      no_transactions: 'Keine Transaktionen',
      payment_methods: 'Zahlungsmethoden',
      add_payment: 'Zahlungsmethode hinzufügen',
      paypal: 'PayPal',
      bank_account: 'Bankkonto',
      reserved: 'Für Mitglieder reserviert',
      guest_message: 'Wallet, Abhebungen und Cashback sind für Recash-Mitglieder reserviert. Erstelle ein kostenloses Konto um heute zu starten.',
      guest_banner_title: 'Cashback als Gast anzeigen',
      guest_banner_desc: 'Registriere dich, um deine Gewinne abzuheben und alle Funktionen zu nutzen.',
      loading: 'Laden...',
      error_title: 'Fehler',
      pending_cashbacks: 'Ausstehende Cashbacks',
      no_cashback: 'Keine ausstehenden Cashbacks',
      transactions: 'Transaktionen',
      withdraw_modal_title: 'Auf Bankkonto überweisen',
      amount: 'Betrag',
      transfer_method: 'Überweisungsmethode',
      select: 'Auswählen',
      email_paypal: 'PayPal-E-Mail',
      iban_rib: 'IBAN/RIB',
      confirm_transfer: 'Überweisung bestätigen',
      add_payment_method: 'Zahlungsmethode hinzufügen',
      type: 'Typ',
      card: 'Bankkarte',
      card_number: 'Kartennummer',
      card_placeholder: '1234 5678 9012 3456',
      expiry: 'Ablaufdatum',
      expiry_placeholder: 'MM/YY',
      paypal_email: 'PayPal-E-Mail',
      email_placeholder: 'beispiel@email.com',
      iban: 'IBAN',
      iban_placeholder: 'FR76....',
      add: 'Hinzufügen',
      status_completed: 'Abgeschlossen',
      status_pending: 'Ausstehend',
      status_failed: 'Fehlgeschlagen',
      load_error: 'Wallet-Daten konnten nicht geladen werden',
      invalid_amount: 'Ungültiger Betrag',
      insufficient_balance: 'Unzureichendes Guthaben',
      fill_destination: 'Bitte fülle das Zielfeld aus',
      withdrawal_requested: 'Abhebung erfolgreich angefordert',
      withdrawal_error: 'Fehler bei der Abhebung',
      gross_amount: 'Bruttobetrag',
      commission_rate: 'Kommissionsrate',
      commission_amount: 'Kommission',
      net_amount: 'Nettobetrag',
      commission_included: '(einschließlich Kommission)',
      feature_coming_soon: 'Funktion bald verfügbar'
    },
    profile: {
      title: 'Profil',
      my_info: 'Meine Informationen',
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'E-Mail',
      birth_year: 'Geburtsjahr',
      language: 'Sprache',
      allergens: 'Allergene',
      allergen: 'Allergen',
      add_allergen: 'Allergen hinzufügen',
      add_allergy: 'Allergie hinzufügen',
      no_allergens: 'Keine Allergene konfiguriert',
      family_mode: 'Familienmodus',
      family_members: 'Familienmitglieder',
      add_member: 'Mitglied hinzufügen',
      no_members: 'Keine Familienmitglieder',
      subscription: 'Abonnement',
      current_plan: 'Aktueller Plan',
      select_plan: 'Plan auswählen',
      change_plan: 'Plan ändern',
      payment_methods: 'Zahlungsmethoden',
      add_payment: 'Zahlungsmethode hinzufügen',
      security: 'Sicherheit',
      change_password: 'Passwort ändern',
      current_password: 'Aktuelles Passwort',
      new_password: 'Neues Passwort',
      confirm_password: 'Passwort bestätigen',
      danger_zone: 'Gefahrenzone',
      delete_account: 'Mein Konto löschen',
      delete_confirm: 'Bist du sicher, dass du dein Konto löschen möchtest?',
      cancel: 'Abbrechen',
      save: 'Speichern',
      name: 'Name',
      add: 'Hinzufügen',
      change: 'Bestätigen',
      logout: 'Abmelden',
      phone: 'Telefon',
      phone_placeholder: 'z.B.: +1 514 555-1234',
      ethical_points_title: 'Ethische Punkte',
      ethical_points_this_month: 'Diesen Monat',
      ethical_points_total: 'Gesamtkumuliert',
      ethical_points_see_all: 'Dashboard anzeigen',
      ethical_points_desc: 'Verdienen Sie Punkte durch gesunde und umweltfreundliche Alternativen',
      ethical_points_canada_only: 'Nur in Kanada verfügbar',
      ethical_points_toggle: 'Ethische Punkte aktivieren',
      country: 'Land',
      select: 'Auswählen',
      preferences: 'Einstellungen',
      currency: 'Währung',
      monthly_budget: 'Monatliches Budget',
      push_notifications: 'Push-Benachrichtigungen',
      email_notifications: 'E-Mail-Benachrichtigungen',
      no_allergies_registered: 'Keine Allergene registriert',
      no_members_registered: 'Keine Mitglieder registriert',
      born_in: 'Geboren im Jahr',
      no_allergies: 'Keine Allergien',
      current_plan_label: 'Aktueller Plan',
      expires_on: 'Läuft ab am',
      no_payment_methods: 'Keine Zahlungsmethoden registriert',
      feature_coming_soon: 'Funktion folgt bald',
      delete_warning: 'Das Löschen Ihres Kontos ist unwiderruflich und löscht alle Ihre Daten.',
      allergen_placeholder: 'z.B.: Gluten, Erdnüsse...',
      severity: 'Schwere',
      severe: 'Schwerwiegend',
      moderate: 'Mäßig',
      mild: 'Leicht',
      member_name_placeholder: 'Vorname',
      birth_year_placeholder: 'z.B.: 2010',
      allergies_placeholder: 'Gluten, Laktose...',
      per_month: '/Monat',
      error_loading: 'Ladefehler',
      profile_saved: 'Profil gespeichert',
      save_error: 'Speicherfehler',
      notifications_enabled: 'Benachrichtigungen aktiviert ✅',
      notifications_disabled: 'Benachrichtigungen deaktiviert',
      notifications_denied: 'Berechtigung verweigert. Aktivieren Sie Benachrichtigungen in den Browsereinstellungen.',
      preferences_saved: 'Einstellungen gespeichert',
      allergy_added: 'Allergen hinzugefügt',
      allergy_add_error: 'Fehler beim Hinzufügen',
      allergy_deleted: 'Allergen gelöscht',
      allergy_delete_error: 'Fehler beim Löschen',
      member_added: 'Mitglied hinzugefügt',
      member_add_error: 'Fehler beim Hinzufügen',
      member_deleted: 'Mitglied gelöscht',
      member_delete_error: 'Fehler beim Löschen',
      password_mismatch: 'Passwörter stimmen nicht überein',
      password_changed: 'Passwort geändert',
      password_change_error: 'Fehler beim Ändern des Passworts',
      delete_account_title: 'Konto löschen',
      delete_account_message: 'Diese Aktion ist unwiderruflich und löscht alle Ihre Daten.',
      delete_button: 'Löschen',
      severity_severe: 'Schwerwiegend',
      severity_moderate: 'Mäßig',
      severity_mild: 'Leicht',
      plan_business: 'Business',
      plan_premium: 'Premium',
      plan_free: 'Kostenlos',
      subscription_downgraded: 'Abonnement auf Kostenlos herabgestuft',
      redirect_stripe: 'Weiterleitung zu Stripe Checkout…',
      redirect_paypal: 'Weiterleitung zu PayPal…',
      country_ca: 'Kanada',
      country_fr: 'Frankreich',
      country_us: 'Vereinigte Staaten',
      country_br: 'Brasilien',
      country_be: 'Belgien',
      country_de: 'Deutschland',
      country_es: 'Spanien',
      country_it: 'Italien',
      country_pt: 'Portugal',
      country_nl: 'Niederlande',
      country_ch: 'Schweiz',
      country_at: 'Österreich',
      country_mx: 'Mexiko',
      country_ar: 'Argentinien',
      country_co: 'Kolumbien',
      country_pe: 'Peru',
      country_cl: 'Chile',
      country_gb: 'Vereinigtes Königreich',
      country_ie: 'Irland',
      country_pl: 'Polen',
      country_cz: 'Tschechische Republik',
      country_se: 'Schweden',
      country_no: 'Norwegen',
      country_dk: 'Dänemark',
      country_fi: 'Finnland',
      lang_de: 'Deutsch',
      lang_en: 'English',
      lang_es: 'Español',
      lang_pt: 'Português',
      currency_cad: 'CAD – Kanadischer Dollar',
      health_filters: 'Gesundheitsfilter',
      health_filters_desc: 'Passen Sie Ihren Gesundheitswert an Ihre Vorlieben an',
      avoid_fodmap: 'FODMAP vermeiden',
      no_palm_oil: 'Palmölfrei',
      no_plastic: 'Plastikfrei',
      organic_only: 'Nur Bio',
      vegetarian: 'Vegetarisch',
      vegan: 'Vegan',
      save_health_filters: 'Filter speichern',
      user: 'Benutzer', stats_tickets: 'Tickets', stats_savings: 'Ersparnisse', stats_alerts: 'Erledigte Warnungen',
      ethical_score: 'Ethik-Score', local_purchases: 'Lokale Einkäufe', eco_friendly: 'Umweltfreundlich', fair_trade: 'Fairer Handel',
      ethical_excellent: 'Ausgezeichnet', ethical_progress: 'In Fortschritt', ethical_improve: 'Zu verbessern',
      referral_badge: 'Neu', guide: 'Benutzerhandbuch', notifications: 'Benachrichtigungen', guest_message: 'Erstellen Sie ein kostenloses Konto, um Ihr Profil anzupassen.',
      allergens_desc: 'Gib deine Allergene oder die deiner Familie an, um beim Scannen von Produkten Warnungen zu erhalten.',
      save_allergens: 'Allergene speichern',
      allergen_gluten: 'Gluten (Weizen, Roggen, Gerste)', allergen_lactose: 'Laktose / Milch', allergen_eggs: 'Eier',
      allergen_peanuts: 'Erdnüsse', allergen_nuts: 'Schalenfrüchte (Mandeln, Walnüsse, Haselnüsse)', allergen_soy: 'Soja',
      allergen_fish: 'Fisch', allergen_shellfish: 'Krebstiere / Weichtiere', allergen_sesame: 'Sesam',
      allergen_sulfites: 'Sulfite', allergen_mustard: 'Senf', allergen_celery: 'Sellerie', allergen_lupin: 'Lupinen', allergen_molluscs: 'Weichtiere',
      manage: 'Verwalten', view_offers: 'Angebote anzeigen', actions: 'Aktionen', support: 'Support', legal: 'Rechtliche Hinweise',
      logout_title: 'Abmelden', logout_confirm: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
      delete_title: '⚠️ Konto löschen', delete_confirm_btn: 'Löschen',
      delete_error: 'Fehler beim Löschen', upload_error: 'Upload fehlgeschlagen',
      allergens_saved: 'Allergene gespeichert', allergens_error: 'Fehler beim Speichern',
      plan_pro: 'Pro', plan_free_desc: 'Zugang zu Grundfunktionen', plan_premium_desc: '50 Cashback-Tickets / Monat, Prioritätswarnungen', plan_pro_desc: 'Alles Premium + API, Prioritätssupport', plan_business_desc: 'Unbegrenzte Cashback-Tickets, alles Pro + Teamverwaltung',
      member_first_name: 'Vorname des Mitglieds', member_last_name: 'Nachname des Mitglieds',
      manage_allergens: 'Meine Allergene verwalten', member_allergens_of: 'Allergene von', modal_close: 'Schließen', allergen_alert_family: 'ist allergisch gegen',
      member_name: 'Vorname', save_info: 'Meine Informationen speichern',
      email_readonly_note: 'Login-E-Mail — kann hier nicht geändert werden.'
    },
    health_dashboard: {
      title: 'Gesundheits-Dashboard',
      monthly_score: 'Monatlicher Score',
      base_score: 'Basis-Score',
      personalized_score: 'Personalisierter Score',
      cumulative_stats: 'Kumulative Statistiken',
      health_points: 'Gesundheitspunkte',
      co2_saved: 'CO2 eingespart',
      water_saved: 'Wasser eingespart',
      products_scanned: 'Produkte gescannt',
      trends: 'Trends',
      score_trend: 'Score-Trend',
      co2_trend: 'CO2-Trend',
      recent_products: 'Kürzliche Produkte',
      no_products: 'Keine Produkte diesen Monat gescannt'
    },
    anti_waste: {
      title: 'Anti-Verschwendung',
      subtitle: 'Reduzieren Sie Ihre Umweltauswirkungen',
      better_packaging: 'Bessere Verpackung',
      less_plastic: 'Weniger Plastik',
      better_eco_score: 'Besserer Eco-Score',
      local_product: 'Lokales Produkt',
      seasonal_product: 'Saisonales Produkt',
      no_suggestions: 'Keine Vorschläge für dieses Produkt verfügbar',
      packaging_preferred: 'Bevorzugte Verpackung',
      packaging_preferred_desc: 'Wählen Sie Produkte mit recycelbarer Verpackung (Karton, Glas) wenn möglich.',
      less_plastic_alt: 'Alternative mit weniger Plastik',
      less_plastic_desc: 'Dieses Produkt enthält Plastik. Hier ist eine Alternative mit besserer Verpackung.',
      better_eco_alt: 'Alternative mit besserem Eco-Score',
      better_eco_alt_desc: 'Versuchen Sie diese Alternative mit besserem Umwelteinfluss.',
      prefer_local: 'Lokale Produkte bevorzugen',
      prefer_local_desc: 'Dieses Produkt kommt von weit weg. Für Obst, Gemüse und frische Produkte reduziert lokales Kaufen den CO2-Fußabdruck.',
      seasonal_tip: 'Saisonales Produkt',
      seasonal_tip_desc: 'Bevorzugen Sie saisonales Obst und Gemüse für besseren Umwelt- und Geschmackseinfluss.',
      responsible_consumption: 'Verantwortungsvoller Konsum',
      responsible_consumption_desc: 'Kaufen Sie nur was Sie brauchen und bevorzugen Sie Produkte mit gutem Nutri-Score und Eco-Score.'
    },
    pricing: {
      title: 'Abonnements',
      payment_title: 'Zahlung',
      select_plan: 'Plan auswählen',
      free: 'Kostenlos',
      premium: 'Premium',
      business: 'Business',
      unlimited_scans: 'Unbegrenzte Scans',
      tickets_per_month: 'Belege pro Monat',
      reminders: 'Erinnerungen',
      unlimited_tickets: 'Unbegrenzte Belege', tickets_cashback_month: 'Cashback-Tickets / Monat', unlimited_tickets_cashback: 'Unbegrenzte Cashback-Tickets',
      full_cashback: 'Voller Cashback',
      family_mode: 'Familienmodus',
      unlimited_wallet: 'Unbegrenztes Wallet',
      priority_support: 'Prioritäts-Support',
      all_premium: 'Alle Premium-Funktionen',
      accounting_export: 'Buchhaltungs-Export',
      collaborators: 'Mitarbeiter',
      api_access: 'API-Zugang',
      select_payment: 'Zahlungsmethode auswählen',
      stripe: 'Stripe',
      secure_card: 'Sichere Karte',
      paypal: 'PayPal',
      secure_payment: 'Sichere Zahlung',
      paypal_account: 'PayPal-Konto',
      or_credit_card: 'oder Kreditkarte',
      limit_reached: 'Monatliches Limit erreicht',
      limit_message: 'Sie haben Ihr Limit von 10 kostenlosen Tickets diesen Monat erreicht. Upgrade auf Premium für unbegrenzte Scans.',
      tickets_remaining: 'Verbleibende Tickets diesen Monat',
      of_10: 'von 10',
      offers: 'Angebote',
      choose_plan: 'Wähle deinen Plan',
      choose_plan_subtitle: 'Genieße Funktionen, die auf deine Bedürfnisse zugeschnitten sind',
      redirect_payment: 'Weiterleitung zur sicheren Zahlung...',
      per_month: '/Monat', per_year: '/Jahr', save_2_months: '2 Monate gratis',
      pro: 'Pro',
      popular: 'Beliebt',
      start_free: 'Kostenlos starten',
      choose_premium: 'Premium wählen',
      choose_pro: 'Pro wählen',
      ten_tickets_month: '10 Cashback-Tickets / Monat',
      product_scan: 'Produktscan',
      basic_alerts: 'Basiswarnungen',
      manufacturer_warranties: 'Herstellergarantien',
      unlimited_cashback: 'Unbegrenztes Cashback',
      advanced_alerts: 'Erweiterte Warnungen',
      extended_warranties: 'Erweiterte Garantien',
      faq_title: 'Häufig gestellte Fragen',
      faq_q1: 'Kann ich meinen Plan jederzeit ändern?',
      faq_a1: 'Ja, du kannst jederzeit aus deinem Profil heraus auf einen höheren oder niedrigeren Plan wechseln.',
      faq_q2: 'Ist die Registrierung kostenlos?',
      faq_a2: 'Ja, die Registrierung ist kostenlos im Gratis-Plan und Sie erhalten 10 kostenlose Cashbacks.',
      faq_q3: 'Sind meine Daten sicher?',
      faq_a3: 'Absolut. Wir verwenden Ende-zu-Ende-Verschlüsselung und teilen deine Daten niemals mit Dritten.',
      faq_q4: 'Kann ich jederzeit kündigen?',
      faq_a4: 'Ja, du kannst dein Abonnement jederzeit kündigen. Du behältst den Zugriff bis zum Ende der bezahlten Periode.',
      not_logged_in: 'Bitte melde dich an, um ein Abo abzuschließen',
      payment_url_missing: 'Zahlungs-URL fehlt',
      payment_error: 'Fehler beim Erstellen der Zahlung',
      pay_with: 'Bezahlen mit',
      pay_card: 'Bankkarte',
      pay_interac: 'Interac e-Transfer',
      interac_title: 'Zahlung per Interac e-Transfer',
      interac_subtitle: 'Sende einen Interac e-Transfer über deine Banking-App',
      interac_step1: '1. Öffne deine Banking-App',
      interac_step2: '2. Sende den genauen Betrag an die unten stehende Adresse',
      interac_step3: '3. Trage diesen Code in das Nachrichtenfeld ein',
      interac_step4: '4. Dein Abonnement wird innerhalb von 24 Werktagen aktiviert',
      interac_email_label: 'e-Transfer-Adresse',
      interac_amount_label: 'Zu sendender Betrag',
      interac_code_label: 'Referenzcode (Pflichtfeld in der Nachricht)',
      interac_expiry: 'Dieser Code läuft in 72 Stunden ab',
      interac_copy: 'Kopieren',
      interac_copied: 'Kopiert!',
      interac_confirm: 'Ich habe die Überweisung gesendet',
      interac_pending: 'Warte auf Bestätigung',
      interac_pending_desc: 'Sobald wir deine Zahlung erhalten haben, wird dein Abonnement automatisch aktiviert.',
      interac_error: 'Fehler beim Erstellen der Interac-Anfrage',
      paypal_subtitle: 'Sichere Zahlung über dein PayPal-Konto',
      stripe_subtitle: 'Visa, Mastercard, Amex — sichere Zahlung',
      pay_wire: 'Banküberweisung',
      wire_subtitle: 'Überweisung von deiner Bank — Aktivierung innerhalb 24 h',
      wire_title: 'Zahlung per Banküberweisung',
      wire_bank: 'Bank',
      wire_holder: 'Kontoinhaber',
      wire_institution: 'Institut / Transit',
      wire_account: 'Kontonummer',
      wire_step1: '1. Melde dich bei deinem Online-Banking an',
      wire_step2: '2. Sende den genauen Betrag mit diesem Code als Verwendungszweck',
      wire_step3: '3. Dein Abonnement wird innerhalb von 24 Werktagen aktiviert',
      wire_error: 'Fehler beim Erstellen der Überweisungsanfrage'
    },
    guest: {
      reserved_title: 'Für Mitglieder reserviert',
      create_account: 'Mein Konto erstellen',
      view_plans: 'Abonnements anzeigen',
      wallet_desc: 'Wallet, Abhebungen und Cashback sind für Recash-Mitglieder reserviert. Erstelle ein kostenloses Konto um heute zu starten.',
      tickets_desc: 'Ticket-Historie, Rückerstattungen und Preisbenachrichtigungen sind für Recash-Mitglieder reserviert.',
      alerts_desc: 'Gesundheitswarnungen, Produktrückrufe und Cashback-Benachrichtigungen sind für Recash-Mitglieder reserviert.',
      profile_desc: 'Verwalten Sie Ihr Profil, Ihre Allergene und Ihr Abonnement, indem Sie ein Recash-Konto erstellen.',
      close: 'Schließen',
      back: 'Zurück',
      yes: 'Ja',
      no: 'Nein',
      ok: 'OK',
      search: 'Suchen',
      selected: 'Ausgewählt',
      continue: 'Weiter',
      continue_with: 'Weiter mit {plan}'
    },
    common: {
      loading: 'Laden...',
      error: 'Ein Fehler ist aufgetreten',
      retry: 'Wiederholen',
      view_details: 'Details anzeigen',
      see_all: 'Alle anzeigen',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      save: 'Speichern',
      delete: 'Löschen',
      close: 'Schließen',
      back: 'Zurück',
      yes: 'Ja',
      no: 'Nein',
      ok: 'OK',
      search: 'Suchen',
      selected: 'Ausgewählt',
      continue: 'Weiter',
      continue_with: 'Weiter mit {plan}'
    },
    product: {
      allergen_warning: 'Enthält ein Allergen für dein Profil',
      additives: 'Zusatzstoffe erkannt',
      cashback: 'cashback',
      nutriscore: 'Nutri-Score',
      nova: 'NOVA-Index',
      ingredients: 'Zutaten',
      alternatives: 'Alternativen gleicher Kategorie',
      alternatives_subtitle: 'Ähnliche Produkte von anderen Marken mit gutem Gesundheits-Score',
      price_comparison: 'Preisvergleich',
      no_alternatives: 'Keine Alternative für diese Kategorie gefunden',
      price_paid: 'Bezahlter Preis',
      market_avg: 'Markt-Durchschnitt',
      cheapest: 'Günstigster',
      stores_compared: 'Geschäft(e) verglichen',
      cheaper_stores: '📉 Wo es günstiger ist',
      best_price: '✅ Du hast dieses Produkt zum besten auf dem Markt gefundenen Preis gekauft!',
      no_market_data: 'Unzureichende Marktdaten für dieses Produkt.',
      eco_score: 'Eco-Score',
      price_position_best: 'Bester Preis',
      price_position_competitive: 'Wettbewerbsfähiger Preis',
      price_position_expensive: 'Hoher Preis',
      price_position_overpriced: 'Überteuert',
      price_position_unknown: 'Unbekannter Preis'
    },
    price_comparison: {
      title: '💡 Beste Preise & Prospekt',
      save_up_to: 'Spare bis zu',
      flyer_active: 'Aktiver Prospekt',
      valid_until: 'Gültig bis',
      best_price_badge: 'BESTER PREIS',
      see_badge: 'SEHEN'
    },
    scan_result: {
      price_paid: 'Bezahlter Preis:',
      nutri_score: 'Nutri-Score =',
      personalized_score: 'Personalisierter Score',
      base_score: 'Basis-Score',
      personalized_score_label: 'Personalisierter Score',
      nutrition_title: 'Nährwertangaben (pro 100g)',
      sugars: 'Zucker',
      saturated_fat: 'Gesättigte Fettsäuren',
      calories: 'Kalorien',
      fiber: 'Ballaststoffe',
      proteins: 'Proteine',
      sodium: 'Natrium',
      country: 'Land',
      category: 'Kategorie',
      defects: 'Mängel',
      qualities: 'Qualitäten',
      additives: 'Zusatzstoffe',
      palm_oil_detected: '⚠️ Palmöl erkannt',
      contains_additives: 'Dieses Produkt enthält {count} Zusatzstoffe',
      allergens: 'Allergene',
      ingredients: 'Zutaten',
      comparison_title: 'Preisvergleich',
      no_market_data: '📊 Unzureichende Marktdaten für dieses Produkt.',
      avg_market: 'Markt-Durchschnitt',
      stores_compared: 'Geschäft(e) verglichen',
      where_cheaper: '📉 Wo es günstiger ist',
      best_price_market: '✅ Du hast dieses Produkt zum besten auf dem Markt gefundenen Preis gekauft!',
      same_product_cheaper: 'Gleiches Produkt günstiger',
      savings: 'Ersparnis:',
      healthier_alternatives: 'Gesündere Alternativen',
      best_health_score: 'Bester Gesundheits-Score',
      eco_alternatives: 'Umweltfreundlichere Alternativen',
      less_co2_impact: 'Weniger CO2-Impact',
      ethical_points: 'Ethische Punkte',
      ethical_description: 'Verdiene Ethische Punkte für deine gesunden und umweltfreundlichen Entscheidungen',
      ethical_value: '💰 100 Punkte = $1 CAD',
      points_available: 'Punkte verfügbar',
      grocery_offers: 'Supermarkt-Angebote',
      offers_count: 'Angebot(e)',
      no_offers: 'Keine Angebote',
      no_offers_for: 'Keine Angebote gefunden für',
      in_region: 'in den Prospekten von',
      no_promotion: 'Dieses Produkt ist derzeit in keinem lokalen Supermarkt im Angebot.',
      compare_online: '🔍 Preise online vergleichen',
      cashback_available: 'Cashback verfügbar',
      disclaimer: 'Vorschläge nur zur Information (Open Food Facts & Partner). Keine Marke zahlt Recash. Preise und Verfügbarkeit können variieren.',
      score_excellent: 'Ausgezeichnet',
      score_good: 'Gut',
      score_mediocre: 'Mittelmäßig',
      score_avoid: 'Zu vermeiden',
      score_explanation: 'Gesundheitsscore von 100: je höher, desto besser.',
      defect_too_fat: 'Zu fettig',
      defect_moderate_fat: 'Moderates Fett',
      defect_very_caloric: 'Sehr kalorienreich',
      defect_moderate_caloric: 'Moderate Kalorien',
      defect_too_salty: 'Zu salzig',
      defect_too_sugary: 'Zu zuckerhaltig',
      defect_moderate_sugars: 'Moderater Zucker',
      quality_excellent_amount: 'Ausgezeichnete Menge',
      quality_good_amount: 'Gute Menge',
      quality_excellent_intake: 'Ausgezeichnete Zufuhr',
      quality_correct_intake: 'Ausreichende Zufuhr',
      quality_low_sodium: 'Natriumarm',
      error_rate_limit: 'OpenFoodFacts begrenzt die Anfragen — bitte warten Sie einige Sekunden und versuchen Sie es erneut.'
    },
    about: {
      title: 'Über Recash',
      description: 'Recash verwandelt deine Belege in Spar- und Gesundheitsmöglichkeiten. Dank KI wird jeder Einkauf analysiert, um Cashbacks, Allergene, Produktrückrufe und Preisanomalien zu erkennen. Entwickelt für Familien, kluge Verbraucher und Profis.',
      features_label: 'Detaillierte Funktionen',
      free_feat_1: 'Unbegrenzter Produktscan',
      free_feat_2: '10 Tickets / Monat',
      free_feat_3: 'Produktrückruf-Warnungen',
      free_feat_4: 'Wallet 20 max',
      premium_feat_3: 'Familienmodus (5 Mitglieder)',
      premium_feat_4: 'Unbegrenztes Wallet + PayPal-Auszahlungen',
      business_feat_3: '20 Mitarbeiter',
      see_pricing: 'Preise ansehen',
      subscribe: 'Abonnieren',
      key_figures: 'Schlüsselzahlen',
      partners: 'Technologien & Partner',
      privacy: 'Datenschutz',
      help: 'Hilfe',
      feat_scan_title: 'Intelligenter Scan',
      feat_scan_1_label: 'Beleg-Scan', feat_scan_1_desc: 'Foto, Galerie oder PDF',
      feat_scan_2_label: 'Produkt-Barcode-Scan', feat_scan_2_desc: 'Verifizierung im Geschäft',
      feat_scan_3_label: 'Automatische Erkennung', feat_scan_3_desc: 'Land und Sprache erkannt',
      feat_safety_title: 'Gesundheitssicherheit',
      feat_safety_1_label: 'Allergene erkannt', feat_safety_1_desc: 'verglichen mit deinem Familienprofil',
      feat_safety_2_label: 'Gefährliche Zusatzstoffe', feat_safety_2_desc: 'E250, E150d, Palmöl...',
      feat_safety_3_label: 'Produktrückrufe', feat_safety_3_desc: 'Health Canada, FDA, DGCCRF APIs',
      feat_safety_4_label: 'Nutri-Score & NOVA', feat_safety_4_desc: 'Nährwertqualität und Verarbeitung',
      feat_savings_title: 'Automatische Einsparungen',
      feat_savings_1_label: 'Cashback', feat_savings_1_desc: 'automatische Rückerstattung (Pampers, Danone...)',
      feat_savings_2_label: 'Garantien', feat_savings_2_desc: 'Warnungen vor Ablauf (2 Jahre Europa)',
      feat_savings_3_label: 'Preisvergleich', feat_savings_3_desc: 'Walmart, Amazon, Carrefour...',
      feat_savings_4_label: 'Preisanomalien', feat_savings_4_desc: 'Erkennung von Kassierfehlern',
      feat_family_title: 'Familienmodus',
      feat_family_1_label: 'Individuelle Gesundheitsprofile', feat_family_1_desc: 'Allergien und Diäten pro Mitglied',
      feat_family_2_label: 'Gemeinsames Wallet', feat_family_2_desc: 'Saldo zwischen Mitgliedern geteilt',
      feat_family_3_label: 'Personalisierte Warnungen', feat_family_3_desc: 'pro Mitgliedsprofil',
      feat_wallet_title: 'Integriertes Wallet',
      feat_wallet_1_label: 'Verfügbares Guthaben', feat_wallet_1_desc: 'in Echtzeit',
      feat_wallet_2_label: 'Bank- / PayPal-Überweisungen', feat_wallet_2_desc: 'jederzeit abheben',
      feat_wallet_3_label: 'Ausstehende Cashbacks', feat_wallet_3_desc: 'Statusverfolgung',
      stat_users: 'Benutzer',
      stat_tickets: 'gescannte Belege',
      stat_savings: 'erzielte Einsparungen'
    },
    payment: {
      success_title: 'Zahlung erfolgreich!',
      success_msg: 'Vielen Dank für dein Abonnement. Dein Konto wurde aktualisiert.',
      success_detail: 'Du kannst jetzt alle Funktionen nutzen.',
      back_home: 'Zurück zur Startseite',
      cancel_title: 'Zahlung abgebrochen',
      cancel_msg: 'Du hast den Zahlungsvorgang abgebrochen.',
      cancel_detail: 'Es wurde kein Betrag belastet. Du kannst es jederzeit erneut versuchen.',
      retry: 'Erneut versuchen',
      paypal_processing: 'PayPal-Zahlung wird verarbeitet…',
      paypal_wait: 'Bitte warte, während wir deine Zahlung bestätigen.',
      paypal_error_title: 'PayPal-Fehler',
      paypal_error_generic: 'Bei der Verarbeitung deiner PayPal-Zahlung ist ein Fehler aufgetreten.',
      paypal_cancelled_title: 'Zahlung abgebrochen',
      paypal_cancelled_msg: 'Du hast die PayPal-Zahlung abgebrochen. Es wurde kein Betrag belastet.',
      try_again: 'Erneut versuchen'
    },
    family: {
      title: 'Familie',
      shared_account: 'Gemeinsames Konto',
      shared_desc: 'Teile Warnungen und Cashback mit deinem Haushalt.',
      code_label: 'Code',
      members: 'Mitglieder',
      head: 'Inhaber',
      no_members: 'Kein Mitglied hinzugefügt',
      invite_member: 'Mitglied einladen',
      cancel: 'Abbrechen',
      send_invite: 'Einladung senden',
      invite_sent: 'Einladung gesendet!',
      invite_error: 'Fehler beim Senden'
    },
    ticket_detail: {
      ticket_of: 'Beleg vom',
      loading: 'Beleg wird geladen...',
      error: 'Fehler',
      retry: 'Erneut versuchen',
      no_photo: 'Kein Foto verfügbar',
      total: 'Gesamt',
      status: 'Status',
      products: 'Produkte',
      alerts_section: 'Warnungen',
      request_refund: 'Rückerstattung anfordern',
      ticket_photo: 'Beleg-Foto',
      close: 'Schließen',
      id_missing: 'Beleg-ID fehlt',
      cannot_load: 'Beleg kann nicht geladen werden',
      claim_sent: 'Rückerstattungsanfrage gesendet',
      claim_error: 'Fehler bei der Anfrage',
      status_completed: 'Erstattet',
      status_processed: 'Verarbeitet',
      status_processing: 'In Bearbeitung',
      status_failed: 'Fehlgeschlagen',
      status_pending: 'Ausstehend',
      cashback_pending: 'Ausstehend',
      cashback_approved: 'Genehmigt',
      cashback_paid: 'Bezahlt',
      allergen: 'Allergen',
      recall: 'Rückruf'
    },
    support: {
      nav_title: 'Wie man in der App navigiert',
      nav_step_1_title: 'Navigationsleiste (unten)',
      nav_step_1_desc: 'Verwenden Sie die Tab-Leiste am unteren Bildschirmrand, um zwischen den Hauptbereichen zu navigieren:',
      nav_home: 'Startseite: Übersicht Ihrer Ersparnisse und Warnungen',
      nav_scan: 'Scannen: Belege oder Produkte scannen',
      nav_tickets: 'Belege: Verlauf Ihrer gescannten Belege',
      nav_wallet: 'Wallet: Guthaben und Cashback-Transaktionen',
      nav_alerts: 'Warnungen: Produktrückrufe und Allergene',
      nav_profile: 'Profil: Einstellungen und Abonnement',
      nav_step_2_title: 'Typischer Anwendungsablauf',
      nav_step_2_1: 'Scannen Sie einen Beleg über die Registerkarte Scannen',
      nav_step_2_2: 'Zeigen Sie das Ergebnis und die erkannten Produkte an',
      nav_step_2_3: 'Bestätigen Sie, um in Belege zu speichern',
      nav_step_2_4: 'Cashbacks werden automatisch zu Ihrer Wallet hinzugefügt',
      nav_step_2_5: 'Warnungen erscheinen in Warnungen',
      nav_step_3_title: 'Zugriff auf Hilfe',
      nav_step_3_desc: 'Sie können auf diese Hilfeseite zugreifen von:',
      nav_step_3_1: 'Der Startbildschirm (Onboarding)',
      nav_step_3_2: 'Die Seite "Über" im Profil',
      page_title: 'Hilfe & Support',
      hero_title: 'Wie können wir dir helfen?',
      faq_label: 'Häufig gestellte Fragen',
      contact_label: 'Direktkontakt',
      email_support: 'E-Mail-Support',
      response_time: 'Antwort innerhalb von 48h (Werktage)',
      premium_priority: 'Premium/Business-Abonnenten: prioritäre Antwort',
      send_msg_label: 'Nachricht senden',
      your_email: 'Deine E-Mail',
      subject: 'Betreff',
      subject_placeholder: 'Beschreibe dein Problem in einer Zeile',
      message_label: 'Nachricht',
      message_placeholder: 'Beschreibe dein Problem im Detail…',
      send_msg: 'Nachricht senden',
      useful_links: 'Nützliche Links',
      documentation: 'Dokumentation',
      legal_cgu_link: 'Impressum & AGB',
      fill_required: 'Bitte E-Mail und Nachricht ausfüllen.',
      msg_sent: 'Nachricht gesendet! Wir antworten innerhalb von 48h.'
    },
    legal: {
      title: 'Rechtliche Informationen',
      cgu: 'AGB',
      privacy: 'Datenschutz',
      mentions: 'Rechtliche Hinweise',
      cgu_title: 'Allgemeine Geschäftsbedingungen',
      privacy_title: 'Datenschutzrichtlinie',
      mentions_title: 'Rechtliche Hinweise',
      cgu_article1_title: 'Artikel 1 – Zweck',
      cgu_article1_text: 'Recash ist eine mobile Anwendung, die das Scannen von Kassenbons und Produkten ermöglicht, um:',
      cgu_article1_item1: 'Allergene, Zusatzstoffe, Nutri-Score, NOVA zu erkennen',
      cgu_article1_item2: 'Automatische Cashbacks zu erhalten',
      cgu_article1_item3: 'Bei Produktrückrufen oder ablaufenden Garantien benachrichtigt zu werden',
      cgu_article1_item4: 'Preise mit anderen Geschäften zu vergleichen',
      cgu_article2_title: 'Artikel 2 – Zugang zur Anwendung',
      cgu_article2_text: 'Der Zugang zum Service erfordert die Erstellung eines Kontos. Die Nutzung ist kostenlos mit Einschränkungen (10 Tickets/Monat). Erweiterte Funktionen erfordern eine kostenpflichtige Abonnement.',
      cgu_article2_item1: 'Mindestalter: 13 Jahre (oder 16 Jahre je nach Land)',
      cgu_article2_item2: 'Konto erforderlich für Cashback und Wallet',
      cgu_article3_title: 'Artikel 3 – Produkt-Scan',
      cgu_article3_text: 'Der Produkt-Scan ist kostenlos und unbegrenzt, auch ohne Abonnement. Daten werden mit Open Food Facts und Regierungsdatenbanken verglichen (Health Canada, FDA, DGCCRF).',
      cgu_article4_title: 'Artikel 4 – Recash-Kommission',
      cgu_article4_text: 'Recash gibt den Benutzern einen Teil des Cashbacks zurück, der von Partnermarken generiert wird. Eine Kommission wird von Recash zur Finanzierung der Anwendung, Plattformgebühren und technischen Integrationen erhoben.',
      cgu_article4_item1: 'Kommissionssatz: Der aktuelle Kommissionssatz beträgt 20% (vom Administrator konfigurierbar)',
      cgu_article4_item2: 'Transparenz: Der Bruttobetrag, die Kommission und der Nettobetrag werden in der Anwendungsoberfläche für jeden Cashback angezeigt',
      cgu_article4_item3: 'Berechnung: Nettobetrag = Bruttobetrag - (Bruttobetrag × Kommissionssatz)',
      cgu_article4_item4: 'Änderung: Dieser Satz ist sichtbar und vom Administrator änderbar. Jede Änderung wird per E-Mail oder Benachrichtigung in der Anwendung mitgeteilt',
      cgu_article4_item5: 'Abhebungen: Abhebungen sind auf Bankkonto oder PayPal möglich (Mindestbetrag anwendbar)',
      cgu_article4_item6: 'Ablauf: Nicht beanspruchte Cashbacks nach 12 Monaten Inaktivität werden storniert',
      cgu_article5_title: 'Artikel 5 – Verantwortlichkeiten',
      cgu_article5_text: 'Recash stellt Informationen nur zu Informationszwecken bereit. Ernährungs- und Gesundheitsinformationen stellen keine medizinische Beratung dar. Im Falle eines Produktrückrufs ist Recash nicht verantwortlich für Kontamination oder resultierende Schäden.',
      cgu_article6_title: 'Artikel 6 – Änderung der AGB',
      cgu_article6_text: 'Recash behält sich das Recht vor, diese AGB jederzeit zu ändern. Benutzer werden per E-Mail oder Push-Benachrichtigung informiert. Die fortgesetzte Nutzung nach Benachrichtigung gilt als Annahme der neuen AGB.',
      cgu_article7_title: 'Artikel 7 – Kündigung',
      cgu_article7_text: 'Der Benutzer kann sein Konto jederzeit über Profil → Gefahrenzone löschen. Daten werden innerhalb von 30 Tagen gelöscht. Recash kann jedes Konto im Falle von Betrug oder Verletzung der AGB sperren.',
      cgu_article8_title: 'Artikel 8 – Geltendes Recht',
      cgu_article8_text: 'Diese AGB unterliegen kanadischem Recht (Provinz Québec). Streitigkeiten werden den zuständigen Gerichten von Montreal, Kanada, vorgelegt.',
      cgu_updated: 'Zuletzt aktualisiert: 1. Januar 2025',
      privacy_updated: 'Zuletzt aktualisiert: 1. Januar 2025',
      privacy_section1_title: '1. Gesammelte Daten',
      privacy_section1_item1: 'Gescannte Tickets: Produkte, Preise, Daten, Geschäfte (3 Jahre gespeichert)',
      privacy_section1_item2: 'Gesundheitsprofil: Allergien, Diäten (verschlüsselt gespeichert)',
      privacy_section1_item3: 'Geolokalisierung: um Land und nahegelegene Geschäfte zu erkennen (optional)',
      privacy_section1_item4: 'Zahlungsdaten: Stripe (nicht von Recash gespeichert)',
      privacy_section1_item5: 'Navigationsdaten: anonymisierte Nutzungsprotokolle',
      privacy_section2_title: '2. Verarbeitungszwecke',
      privacy_section2_item1: 'Optimierung von Cashbacks und Matching mit Partnerangeboten',
      privacy_section2_item2: 'Erkennung von Allergenen und personalisierten Produktrückrufen',
      privacy_section2_item3: 'Verbesserung der KI-Algorithmen der Anwendung',
      privacy_section2_item4: 'Senden von Benachrichtigungen und Sicherheitswarnungen',
      privacy_section3_title: '3. Ihre Rechte (DSGVO / PIPEDA)',
      privacy_section3_text: 'Gemäß DSGVO (EU) und PIPEDA (Kanada) haben Sie:',
      privacy_section3_item1: 'Recht auf Zugriff auf Ihre Daten',
      privacy_section3_item2: 'Recht auf Berichtigung',
      privacy_section3_item3: 'Recht auf Löschung (« Recht auf Vergessenwerden »)',
      privacy_section3_item4: 'Recht auf Übertragbarkeit (JSON-Export)',
      privacy_section3_item5: 'Recht auf Widerspruch gegen die Verarbeitung',
      privacy_section3_contact: 'Kontakt: support@recash.shop',
      privacy_section4_title: '4. Datenspeicherung',
      privacy_section4_text: 'Daten maximal 3 Jahre nach Ihrer letzten Anmeldung gespeichert. Endgültige Löschung innerhalb von 30 Tagen nach Anfrage. Buchhaltungsdaten 7 Jahre gespeichert (gesetzliche Verpflichtung).',
      privacy_section5_title: '5. Cookies und Drittanbieter-APIs',
      privacy_section5_item1: 'Open Food Facts (Produktdatenbank, ODbL-Lizenz)',
      privacy_section5_item2: 'SerpApi (Preisvergleich)',
      privacy_section5_item3: 'Regierungs-APIs: Health Canada, FDA, DGCCRF',
      privacy_section5_item4: 'OpenAI (OCR- und KI-Analyse – anonymisierte Daten)',
      privacy_section5_item5: 'Stripe (Zahlungen – PCI-DSS Level 1)',
      privacy_section6_title: '6. Sicherheit',
      privacy_section6_text: 'Daten verschlüsselt während der Übertragung (TLS 1.3) und im Ruhezustand (AES-256). Eingeschränkter Zugriff auf autorisiertes Personal. Regelmäßige Sicherheitsaudits. Kein Verkauf von persönlichen Daten an Dritte.',
      mentions_editor_title: 'Herausgeber der Anwendung',
      mentions_editor_name: 'Recash, 1522 Rue Ottawa #B701, Montreal, Quebec, Email: support@recash.shop',
      mentions_hosting_title: 'Hosting',
      mentions_hosting_item1: 'Datenbank: Supabase (supabase.io) – AWS us-east-1',
      mentions_hosting_item2: 'Frontend: Vercel (vercel.com)',
      mentions_hosting_item3: 'Backend-API: Railway.app',
      mentions_hosting_item4: 'Dateispeicherung: Supabase Storage (AWS S3)',
      mentions_payment_title: 'Zahlungsanbieter',
      mentions_payment_text: 'Stripe Inc. – 510 Townsend Street, San Francisco, CA 94103, USA - Zertifiziert PCI-DSS Level 1. Recash speichert keine Bankkartendaten.',
      mentions_ip_title: 'Geistiges Eigentum',
      mentions_ip_text: 'Die Recash-Anwendung, ihr Logo, Texte und Funktionen sind das ausschließliche Eigentum von Recash Inc. Jede Vervielfältigung ohne vorherige schriftliche Genehmigung ist verboten.'
    },
    faq: {
      category_scan_product: 'Produkt-Scan',
      category_scan_ticket: 'Kassenbon-Scan',
      category_accounts: 'Konten & Abonnements',
      category_technical: 'Technische Probleme',
      scan_product_q1: 'Ist der Produkt-Scan kostenlos?',
      scan_product_a1: 'Ja, vollständig kostenlos und unbegrenzt. Sie können alle Produkte im Laden scannen, um ihre Qualität zu überprüfen (Allergene, Zusatzstoffe, Nutri-Score, NOVA) ohne Abonnement.',
      scan_product_q2: 'Wie werden Allergene erkannt?',
      scan_product_a2: 'Recash vergleicht die Produktzusammensetzung (via Open Food Facts und Etiketten) mit Ihrem Gesundheitsprofil und dem Ihrer Familie. Bei Übereinstimmung erscheint sofort eine rote Warnung.',
      scan_ticket_q1: 'Wie viele Kassenbons kann ich kostenlos scannen?',
      scan_ticket_a1: '10 Cashback-Tickets pro Monat mit dem Gratis-Plan. 50 Cashback-Tickets pro Monat mit dem Premium-Plan.',
      scan_ticket_q2: 'Wie funktioniert Cashback?',
      scan_ticket_a2: 'Recash scannt Ihren Kassenbon, sucht nach aktiven Angeboten unter Partnermarken (Pampers, Danone, etc.) und sendet die Anfrage automatisch. Sie erhalten das Geld in Ihrer Recash-Wallet innerhalb von 48h.',
      scan_ticket_q3: 'Warum gibt es eine Kommission auf Cashback?',
      scan_ticket_a3: 'Recash nimmt eine Kommission (vom Administrator konfigurierbar, derzeit 20%) für: Entwicklung und Wartung der Anwendung, Zahlung für Drittanbieter-APIs (Open Food Facts, Google Vision, etc.) und schnellen Support. Sie erhalten immer die Mehrheit des Cashbacks (normalerweise 80%).',
      accounts_q1: 'Kann ich Recash ohne Konto verwenden?',
      accounts_a1: 'Ja, nur für Produkt-Scan. Um Ihre Kassenbons zu speichern, Cashbacks zu erhalten und die Wallet zu nutzen, ist ein Konto erforderlich (kostenlos).',
      accounts_q2: 'Wie ändere ich meinen Abonnementplan?',
      accounts_a2: 'Gehen Sie zu Profil → Abonnement → Plan ändern. Das Upgrade ist sofort wirksam. Die Kündigung wird am Ende der Abrechnungsperiode wirksam.',
      technical_q1: 'Mein Kassenbon wird nicht korrekt erkannt',
      technical_a1: 'Überprüfen Sie, ob das Bild klar, gut beleuchtet und der Kassenbon flach ist. Vermeiden Sie Reflexionen. Versuchen Sie, manuell zuzuschneiden oder den Scan erneut zu versuchen. Wenn das Problem besteht, kontaktieren Sie den Support mit einem Screenshot.',
      technical_q2: 'Die App erkennt mein Allergen nicht',
      technical_a2: 'Überprüfen Sie, ob das Allergen in Ihrem Profil deklariert ist (Profil → Allergien). Wenn das Produkt nicht in Open Food Facts ist, kann es nicht analysiert werden. Sie können das Produkt über die App melden, um die Datenbank zu erweitern.'
    },
    guide: {
      title: 'Benutzerhandbuch',
      complete_guide: 'Vollständiger Leitfaden',
      subtitle: 'Alles, was Sie wissen müssen, um Recash zu nutzen',
      section_scan_ticket_title: 'Kassenbon scannen',
      section_scan_ticket_desc: 'Wie Sie Ihre Kassenbons scannen, um Cashback zu erhalten und Ihre Ausgaben zu verfolgen.',
      section_scan_product_title: 'Produkt scannen',
      section_scan_product_desc: 'Analysieren Sie jedes Produkt per Barcode, um seine Zusammensetzung und Scores zu kennen.',
      section_scores_title: 'Scores verstehen',
      section_scores_desc: 'Nutri-Score, NOVA, Eco-Score... alles über Qualitätsindikatoren.',
      section_cashback_title: 'Cashback',
      section_cashback_desc: 'Wie Cashback funktioniert, Bearbeitungszeiten und Abhebungen.',
      section_ethical_title: 'Ethische Punkte',
      section_ethical_desc: 'Verdienen Sie Punkte durch die Wahl von ökoverantwortlichen Alternativen.',
      section_alerts_title: 'Alarme & Rückrufe',
      section_alerts_desc: 'Bleiben Sie über Produktrückrufe, Garantien und personalisierte Alarme informiert.',
      section_faq_title: 'FAQ',
      section_faq_desc: 'Die häufigsten Fragen zu Recash.',
      scan_ticket_step1_title: 'Foto machen',
      scan_ticket_step1_desc: 'Legen Sie Ihren Kassenbon flach auf einen einfarbigen Hintergrund. Stellen Sie sicher, dass das Foto klar und gut beleuchtet ist, ohne Reflexionen.',
      scan_ticket_step2_title: 'Bild importieren',
      scan_ticket_step2_desc: 'Sie können direkt aus der App ein Foto machen oder ein Bild aus Ihrer Galerie importieren. PDFs werden ebenfalls akzeptiert.',
      scan_ticket_step3_title: 'Automatische Analyse',
      scan_ticket_step3_desc: 'Unsere KI analysiert Ihren Kassenbon in Sekunden: Geschäft, Datum, Gesamtbetrag und jeden Artikel mit seinem Preis.',
      scan_ticket_step4_title: 'Entdecken Sie Ihre Gewinne',
      scan_ticket_step4_desc: 'Recash sucht automatisch nach verfügbaren Cashback-Angeboten für Ihre Einkäufe. Sie sehen sofort den Betrag, den Sie zurückholen können.',
      scan_ticket_step5_title: 'Bestätigen und verfolgen',
      scan_ticket_step5_desc: 'Bestätigen Sie die Informationen und verfolgen Sie die Entwicklung Ihrer Cashbacks in Ihrer Wallet. Die Gelder werden innerhalb von 48h gutgeschrieben.',
      scan_product_step1_title: 'Barcode scannen',
      scan_product_step1_desc: 'Verwenden Sie die Kamera Ihres Telefons, um den Barcode eines Produkts zu scannen. Sie können den Code auch manuell eingeben.',
      scan_product_step2_title: 'Sofortige Analyse',
      scan_product_step2_desc: 'Recash konsultiert die Open Food Facts Datenbank und zeigt: Nutri-Score, NOVA, Eco-Score, Inhaltsstoffe, Allergene, Zusatzstoffe.',
      scan_product_step3_title: 'Alarme überprüfen',
      scan_product_step3_desc: 'Wenn das Produkt ein in Ihrem Profil deklariertes Allergen enthält, erscheint sofort ein roter Alarm.',
      scan_product_step4_title: 'Alternativen vergleichen',
      scan_product_step4_desc: 'Entdecken Sie besser bewertete, billigere oder gesündere Alternativprodukte, die in Ihrer Region verfügbar sind.',
      score_nutri_name: 'Nutri-Score',
      score_nutri_desc: 'Bewertet die gesamte Nährwertqualität eines Produkts von A (am besten) bis E (am schlechtesten). Basierend auf Nährstoffen und Lebensmitteln, die zu bevorzugen/zu begrenzen sind.',
      score_nova_name: 'NOVA',
      score_nova_desc: 'Klassifiziert Lebensmittel nach ihrem Verarbeitungsgrad: 1 (roh) bis 4 (ultra-verarbeitet). Bevorzugen Sie die Scores 1 und 2.',
      score_eco_name: 'Eco-Score',
      score_eco_desc: 'Bewertet die Umweltbelastung des Produkts von A (sehr geringe Auswirkung) bis E (sehr hohe Auswirkung). Berücksichtigt Verpackung, Transport, Produktion.',
      score_health_name: 'Gesundheitsscore',
      score_health_desc: 'Unser personalisierter Score, der Nutri-Score, NOVA, Eco-Score und Ihre Gesundheits-/Allergiepräferenzen kombiniert, um Ihnen eine Punktzahl von 100 zu geben.',
      cashback_how_title: 'Wie funktioniert es?',
      cashback_how_desc: 'Wenn Sie einen Kassenbon scannen, identifiziert Recash cashback-berechtigte Produkte — 🍎️‍♂️‍♂️‍♂️ Lebensmittel, 💻 Elektronik, 👕 Kleidung, 💊 Apotheke, 🏠 Haushalt und mehr — aus unseren Partnermarken. Die Anfrage wird automatisch übermittelt, unabhängig vom Geschäftstyp.',
      cashback_delays_title: 'Bearbeitungszeiten',
      cashback_delays_desc: 'Cashbacks werden in der Regel innerhalb von 48h nach Validierung des Kassenbons gutgeschrieben. Die Zeiten können je nach Partner variieren.',
      cashback_commission_title: 'Recash-Kommission',
      cashback_commission_desc: 'Recash nimmt eine Kommission (vom Administrator konfigurierbar, derzeit 20%), um Entwicklungskosten, APIs und Support zu decken. Sie erhalten immer die Mehrheit des Betrags.',
      cashback_withdrawal_title: 'Geldabhebung',
      cashback_withdrawal_desc: 'Sie können Ihr Geld jederzeit per Banküberweisung, PayPal oder Stripe abheben. Der Mindestabhebungsbetrag beträgt 5€/5$/5£.',
      cashback_tracking_title: 'Echtzeit-Tracking',
      cashback_tracking_desc: 'Zeigen Sie Ihren Cashback-Verlauf, ausstehende Beträge und Gesamteinnahmen auf der Wallet-Seite an.',
      section_wallet_title: 'Wallet & Abhebungen',
      section_wallet_desc: 'Verwalten Sie Ihr Guthaben und heben Sie Geld über PayPal oder Banküberweisung ab.',
      section_shopping_title: 'Einkaufsliste',
      section_shopping_desc: 'Erstellen, verwalten und teilen Sie Ihre intelligente Einkaufsliste.',
      section_budget_title: 'Monatsbudget',
      section_budget_desc: 'Verfolgen Sie Ihre Ausgaben nach Kategorie und legen Sie Budgetgrenzen fest.',
      section_antiwaste_title: 'Anti-Verschwendung',
      section_antiwaste_desc: 'Reduzieren Sie Ihren Umwelteinfluss mit Alternativvorschlägen.',
      wallet_balance_title: 'Ihr Guthaben',
      wallet_balance_desc: 'Ihr verfügbares Guthaben entspricht validierten Cashbacks. "Ausstehende" Beträge werden gutgeschrieben, sobald unsere Partner sie validieren.',
      wallet_paypal_title: 'Abhebung via PayPal',
      wallet_paypal_desc: 'Geben Sie Ihre PayPal-E-Mail und den gewünschten Betrag ein. Die Überweisung ist automatisch und kommt innerhalb von 24h auf Ihrem PayPal-Konto an.',
      wallet_bank_title: 'Banküberweisung',
      wallet_bank_desc: 'Geben Sie Ihre IBAN für eine direkte Überweisung auf Ihr Bankkonto an. Bearbeitungszeit: 1 bis 3 Werktage.',
      wallet_delay_title: 'Abhebungszeiten',
      wallet_delay_desc: 'PayPal: innerhalb von 24h. Banküberweisung: 1 bis 3 Werktage. Mindestbetrag: 5€/5$/5£.',
      wallet_tracking_title: 'Vollständiger Verlauf',
      wallet_tracking_desc: 'Zeigen Sie alle Ihre Transaktionen (erhaltene Cashbacks, getätigte Abhebungen) mit ihrem Echtzeit-Status an.',
      shopping_step1_title: 'Liste erstellen',
      shopping_step1_desc: 'Fügen Sie Artikel manuell hinzu oder importieren Sie Produkte aus Ihrem letzten gescannten Kassenbon mit einem Tippen.',
      shopping_step2_title: 'Scannen zum Hinzufügen',
      shopping_step2_desc: 'Scannen Sie den Barcode eines Produkts im Geschäft, um es direkt mit seinen Nährwertinformationen zu Ihrer Liste hinzuzufügen.',
      shopping_step3_title: 'Unterwegs verwalten',
      shopping_step3_desc: 'Haken Sie Artikel beim Einkaufen ab. Passen Sie Mengen an, entfernen Sie unerwünschte Artikel.',
      shopping_step4_title: 'Liste teilen',
      shopping_step4_desc: 'Senden Sie Ihre Einkaufsliste mit einem Tippen an Ihre Familie oder Freunde. Ideal für gemeinsames Einkaufen.',
      budget_set_title: 'Budget festlegen',
      budget_set_desc: 'Legen Sie in Profil → Budget ein globales Monatsbudget fest. Recash berechnet Ihre Ausgaben automatisch aus gescannten Belegen.',
      budget_categories_title: 'Kategorien',
      budget_categories_desc: 'Ihre Ausgaben werden automatisch kategorisiert (Lebensmittel, Apotheke, Elektronik…) für eine genaue Verfolgung.',
      budget_alert_title: 'Budget-Warnungen',
      budget_alert_desc: 'Erhalten Sie eine Benachrichtigung, wenn Sie sich Ihrem Monatslimit nähern, damit Sie Ihre Ausgaben im Griff behalten.',
      budget_monthly_title: 'Monatliche Übersicht',
      budget_monthly_desc: 'Sehen Sie Ihre monatliche Übersicht mit Vergleich zum Vormonat und grafischer Darstellung Ihrer Ausgaben.',
      antiwaste_packaging_title: 'Verantwortungsvolle Verpackung',
      antiwaste_packaging_desc: 'Recash schlägt Alternativen mit besserer Verpackung (Karton, Glas, unverpackt) vor, um Ihren Plastikmüll zu reduzieren.',
      antiwaste_local_title: 'Regional bevorzugen',
      antiwaste_local_desc: 'Bei Obst, Gemüse und Frischprodukten reduziert regionale Wahl Ihren CO2-Fußabdruck und stärkt die regionale Wirtschaft.',
      antiwaste_seasonal_title: 'Saisonale Produkte',
      antiwaste_seasonal_desc: 'Recash erkennt Produkte außerhalb der Saison und schlägt saisonale Alternativen vor, die besser für Umwelt und Geschmack sind.',
      antiwaste_alternatives_title: 'Öko-Alternativen',
      antiwaste_alternatives_desc: 'Entdecken Sie ähnliche Produkte mit besserem Eco-Score oder geringerem Umwelteinfluss in Ihrer Region.',
      coming_next_version: 'Verfügbar in der nächsten Version',
      ethical_coming_soon_desc: 'Ethische Punkte werden im nächsten Recash-Update eingeführt. Bleiben Sie dran!',
      ethical_what_title: 'Was sind Ethische Punkte?',
      ethical_what_desc: 'Ethische Punkte belohnen Ihre verantwortungsvollen Verbraucherentscheidungen. Wenn Sie ein Produkt scannen und eine ökologischere oder ethischere Alternative existiert, erhalten Sie Punkte.',
      ethical_how_title: 'Wie verdienen Sie sie?',
      ethical_how_desc: 'Scannen Sie Produkte und wählen Sie empfohlene Alternativen. Je tugendhafter die Alternative (Bio, lokal, unverpackt, Fairer Handel), desto mehr Punkte erhalten Sie.',
      ethical_value_title: 'Punktwert',
      ethical_value_desc: 'Jeder ethische Punkt hat einen Geldwert. Sie können sie sammeln und umwandeln. Die maximale Anzahl an Punkten pro Monat beträgt 100.',
      ethical_availability_title: 'Verfügbarkeit',
      ethical_availability_desc: 'Ethische Punkte sind derzeit nur in Kanada verfügbar. Wir arbeiten daran, dieses Programm auf andere Länder auszuweiten.',
      alert_recalls_title: 'Produktrückrufe',
      alert_recalls_desc: 'Erhalten Sie eine sofortige Benachrichtigung, wenn ein Produkt, das Sie gekauft haben, einem Gesundheitsrückruf unterliegt (Listerie, Salmonelle, Fremdkörper, etc.).',
      alert_warranty_title: 'Garantien',
      alert_warranty_desc: 'Verfolgen Sie die Garantiedaten Ihrer Käufe. Erhalten Sie eine Warnung vor Ablauf, um Ihre Rechte nicht zu verlieren.',
      alert_allergens_title: 'Allergene',
      alert_allergens_desc: 'Deklarieren Sie Ihre Allergien in Ihrem Profil. Recash warnt Sie automatisch, wenn ein gescanntes Produkt ein für Sie oder Ihre Familie gefährliches Allergen enthält.',
      alert_price_title: 'Preisanomalien',
      alert_price_desc: 'Wenn der auf Ihrem Kassenbon gescannte Preis signifikant vom üblichen Preis oder dem im Laden angezeigten Preis abweicht, wird ein Alarm generiert.',
      guide_faq_q1: 'Ist der Produkt-Scan kostenlos?',
      guide_faq_a1: 'Ja, vollständig kostenlos und unbegrenzt. Sie können alle Produkte im Laden scannen, um ihre Qualität ohne Abonnement zu überprüfen.',
      guide_faq_q2: 'Wie viele Kassenbons kann ich kostenlos scannen?',
      guide_faq_a2: '10 Cashback-Tickets pro Monat mit dem Gratis-Plan. 50 Cashback-Tickets pro Monat mit dem Premium-Plan.',
      guide_faq_q3: 'Wie werden Allergene erkannt?',
      guide_faq_a3: 'Recash vergleicht die Produktzusammensetzung (via Open Food Facts) mit Ihrem Gesundheitsprofil und dem Ihrer Familie. Bei Übereinstimmung erscheint sofort ein roter Alarm.',
      guide_faq_q4: 'Kann ich Recash ohne Konto verwenden?',
      guide_faq_a4: 'Ja, nur für Produkt-Scan. Um Ihre Kassenbons zu speichern, Cashbacks zu erhalten und die Wallet zu nutzen, ist ein Konto erforderlich (kostenlos).',
      guide_faq_q5: 'Wie ändere ich meinen Abonnementplan?',
      guide_faq_a5: 'Gehen Sie zu Profil → Abonnement → Plan ändern. Das Upgrade ist sofort wirksam. Die Kündigung wird am Ende der Abrechnungsperiode wirksam.',
      guide_faq_q6: 'Mein Kassenbon wird nicht korrekt erkannt',
      guide_faq_a6: 'Überprüfen Sie, ob das Bild klar, gut beleuchtet und der Kassenbon flach ist. Vermeiden Sie Reflexionen. Versuchen Sie, manuell zuzuschneiden oder den Scan erneut zu versuchen.',
      guide_faq_q7: 'Die App erkennt mein Allergen nicht',
      guide_faq_a7: 'Überprüfen Sie, ob das Allergen in Ihrem Profil deklariert ist (Profil → Allergien). Wenn das Produkt nicht in Open Food Facts ist, kann es nicht analysiert werden.',
      cta_title: 'Bereit zum Starten?',
      cta_desc: 'Scannen Sie jetzt Ihren ersten Kassenbon oder Ihr erstes Produkt',
      cta_scan_ticket: 'Kassenbon scannen',
      cta_scan_product: 'Produkt scannen'
    },
    ethical: {
      title: 'Ethische Punkte',
      ineligible_msg: 'Ethische Punkte sind nur in Kanada verfügbar.',
      your_location: 'Dein Standort',
      unknown: 'Unbekannt',
      this_month: 'Diesen Monat',
      points: 'Punkte',
      value: 'Wert',
      choices: 'Entscheidungen',
      points_remaining: 'Punkte verbleibend / 100 max',
      total_cumulative: 'Gesamtsumme',
      earned: 'verdient',
      double_bonus: 'Doppelter Bonus',
      points_per_choice: 'Punkte/Wahl',
      recent_activity: 'Kürzliche Aktivität',
      no_activity: 'Keine kürzliche Aktivität',
      start_scanning: 'Scanne Produkte, um Ethische Punkte zu sammeln!',
      monthly_history: 'Monatlicher Verlauf',
      alternative: 'Alternative'
    },
    referral: {
      title: 'Empfehlung',
      hero_title: 'Freunde einladen, Belohnungen erhalten',
      hero_subtitle: 'Teile deinen Code und erhalte Cashback, sobald dein Freund seine ersten Belege scannt',
      you_earn: 'Du erhältst',
      friend_gets: 'Dein Freund erhält',
      trigger_note: 'Belohnung wird ausgelöst, nachdem dein Freund {n} Belege gescannt hat',
      your_code: 'Dein Empfehlungscode',
      copied: 'Code kopiert!',
      share: 'Meinen Code teilen',
      share_msg: 'Tritt Recash mit meinem Code {code} bei und erhalte {days} Tage Premium kostenlos! Scanne Belege und verdiene Cashback.',
      stats_title: 'Meine Empfehlungen',
      total_referrals: 'Eingeladen',
      credited: 'Bestätigt',
      total_earned: 'Verdient',
      have_code: 'Hast du einen Freundescode?',
      enter_code: 'Code eingeben…',
      apply: 'Anwenden',
      apply_success: '✅ Code angewendet! {days} Tage Premium freigeschaltet.',
      apply_error: 'Ungültiger oder bereits verwendeter Code',
      load_error: 'Empfehlungsdaten konnten nicht geladen werden',
      retry: 'Erneut versuchen'
    },
    shopping_list: {
      title: 'Einkaufsliste',
      add_placeholder: 'Artikel hinzufügen...',
      add: 'Hinzufügen',
      empty_title: 'Ihre Liste ist leer',
      empty_subtitle: 'Fügen Sie Artikel hinzu, um zu beginnen',
      scan_to_add: 'Produkt scannen',
      import_from_ticket: 'Aus Kassenbon importieren',
      search_placeholder: 'Nach einem Produkt suchen...',
      clear_checked: 'Markierte entfernen',
      share: 'Liste teilen',
      items_count: 'Artikel',
      checked_count: 'markiert',
      estimated_cashback: 'Geschätzter Cashback',
      delete: 'Löschen',
      item_added: 'Artikel hinzugefügt',
      list_cleared: 'Liste geleert',
      imported: 'Artikel aus dem letzten Kassenbon importiert',
      no_recent_ticket: 'Kein aktueller Kassenbon zum Importieren',
      qty: 'Menge',
      summary_title: 'Zusammenfassung',
      total_items: 'Gesamt Artikel',
      total_cashback: 'Möglicher Cashback',
      quick_action: 'Meine Liste 🛒',
      section_title: '🛒 Meine Einkaufsliste',
      view_list: 'Liste anzeigen',
      pending_items: 'verbleibende Artikel',
      all_done: 'Alles erledigt!',
      confirm_clear: 'Alle markierten Artikel entfernen?',
      confirm_clear_all: 'Gesamte Liste löschen?',
      yes: 'Ja',
      no: 'Nein',
      quantity_label: 'Menge',
      search_products_title: 'Produkte suchen',
      select_products: 'Produkte auswählen',
      import_selected: 'Ausgewählte Produkte importieren',
      no_results: 'Keine Ergebnisse',
      enter_search_terms: 'Geben Sie mindestens 2 Zeichen ein'
    },
    app: {
      offline_mode: 'Offline-Modus',
      offline_cached_data: 'Gecachte Daten werden angezeigt',
      back_online: 'Verbindung wiederhergestellt',
      cookie_msg: 'Wir verwenden essentielle Cookies für die Funktion der Anwendung. Durch Fortfahren akzeptierst du unsere Datenschutzerklärung.',
      cookie_accept: 'Akzeptieren',
      cookie_decline: 'Ablehnen',
      download_data: 'Meine Daten herunterladen',
      delete_account: 'Mein Konto löschen'
    }
  },

  /* ───────────── PORTUGUÊS ───────────── */
  pt: {
    nav: {
      home: 'Início',
      scan: 'Digitalizar',
      tickets: 'Talões',
      wallet: 'Carteira',
      alerts: 'Alertas',
      profile: 'Perfil'
    },
    auth: {
      login: 'Entrar',
      create: 'Criar conta',
      email: 'Email',
      password: 'Palavra-passe',
      confirm_password: 'Confirmar palavra-passe',
      email_placeholder: 'teu@email.com',
      password_placeholder: '••••••••',
      signin: 'Entrar',
      forgot_password: 'Esqueceste a palavra-passe?',
      no_account: 'Sem conta? Criar conta',
      have_account: 'Já tens conta? Entrar',
      google: 'Continuar com Google',
      apple: 'Continuar com Apple',
      fill_all_fields: 'Por favor preenche todos os campos',
      passwords_not_match: 'As palavras-passe não coincidem',
      auth_error: 'Erro de autenticação',
      login_success: 'Login com sucesso',
      account_created: 'Conta criada com sucesso',
      enter_email_reset: 'Introduz o teu email para redefinir a palavra-passe',
      reset_email_sent: 'Se esta conta existe, foi enviado um email de redefinição.',
      google_dev: '🚧 Login Google em desenvolvimento',
      apple_dev: '🚧 Login Apple em desenvolvimento',
      or: 'ou',
      ou: 'ou',
      legal_text: 'Ao continuares, aceitas os nossos T&C e Política de privacidade.',
      cgu: 'T&C',
      privacy_policy: 'Política de privacidade',
      subtitle: 'As tuas poupanças, simplificadas',
      register_tab: 'Registo',
      display_name: 'Nome a apresentar',
      display_name_placeholder: 'O teu nome',
      password_min_placeholder: 'Mínimo 8 caracteres',
      confirm_password_placeholder: 'Repete a palavra-passe',
      creating: 'A registar...',
      signing_in: 'A entrar...',
      switch_to_register: 'Ainda não tens conta? Regista-te',
      switch_to_login: 'Já tens conta? Entra',
      create_my_account: 'Criar a minha conta',
      continue_as_guest: 'Continuar como convidado',
      password_min_error: 'A palavra-passe deve ter pelo menos 8 caracteres',
      login_error_msg: 'Erro de início de sessão',
      email_not_confirmed: 'Confirme o seu email antes de iniciar sessão. Verifique o spam.',
      register_error_msg: 'Erro de registo',
      social_dev_msg: '🚧 Início de sessão com {provider} em desenvolvimento',
      show_password: 'Mostrar palavra-passe',
      hide_password: 'Ocultar palavra-passe',
      forgot_password_success: 'Email enviado! Verifica a tua caixa de entrada.',
      country: 'País',
      country_placeholder: 'Seleciona o teu país',
      age_warning: 'Esta aplicação é reservada a pessoas com 16 anos ou mais.',
      age_consent: 'Confirmo que tenho pelo menos 16 anos',
      terms_consent: 'Aceito os Termos de Serviço e a Política de Privacidade',
      consent_required: 'Deves confirmar a tua idade e aceitar os termos para te registares',
      rgpd_consent: 'Concordo que os meus dados pessoais sejam tratados de acordo com o RGPD / PIPEDA',
      email_confirm_title: 'Verifique o seu email',
      email_confirm_sent: 'Um email de confirmação foi enviado para:',
      email_confirm_spam: '⚠️ Verifique a sua pasta de spam se não o receber em 2 minutos.',
      email_confirm_hint: 'Clique no link do email para ativar a sua conta e depois inicie sessão.'
    },
    app: {
      offline_mode: 'Modo offline',
      offline_cached_data: 'Exibindo dados em cache',
      back_online: 'Conexão restabelecida',
      cookie_msg: 'Usamos cookies essenciais para o funcionamento da aplicação. Ao continuar, aceita a nossa política de privacidade.',
      cookie_accept: 'Aceitar',
      cookie_decline: 'Recusar',
      download_data: 'Descarregar os meus dados',
      delete_account: 'Eliminar a minha conta'
    },
    export: {
      title: 'Exportar os meus dados',
      period: 'Período',
      period_7d: '7 dias',
      period_30d: '30 dias',
      period_90d: '3 meses',
      period_all: 'Tudo',
      format: 'Formato',
      preview: 'Pré-visualização',
      col_date: 'Data',
      col_type: 'Tipo',
      col_amount: 'Montante',
      col_currency: 'Moeda',
      col_status: 'Estado',
      col_desc: 'Descrição',
      transactions: 'transações',
      total: 'Total',
      loading: 'A carregar...',
      error: 'Erro de carregamento',
      download: 'Descarregar'
    },
    budget: {
      title: 'Orçamento mensal',
      monthly_budget: 'Orçamento mensal',
      used: 'utilizado',
      remaining: 'Restante',
      alert: 'Orçamento quase atingido',
      vs_last_month: 'vs mês passado',
      last_3_months: 'Últimos 3 meses',
      details: 'Detalhes',
      tickets: 'Recibos',
      cashback: 'Cashback',
      edit_title: 'Editar orçamento',
      monthly_limit: 'Limite mensal',
    },
    onboarding: {
      guest: 'Convidado',
      title: 'Recash',
      subtitle: 'Digitalize. Proteja a sua saúde. Recupere o seu dinheiro.',
      scan_instant: 'Digitalização Instantânea e Multi-Talão',
      scan_description: 'Foto do talão ou código de barras, IA extrai tudo em 3s.',
      health_alerts: 'Alertas de Saúde ao Vivo',
      health_description: 'Alergénios ocultos e recolhas de produtos: fique informado.',
      cashback: 'Cashback Automático',
      cashback_description: 'Mercearia, farmácia, eletrónica, vestuário... Todos os tipos de lojas',
      start_button: 'Começar a poupar',
      legal_text: 'Ao continuar, você concorda com os nossos',
      terms: 'Termos',
      and: 'e',
      privacy: 'Política de Privacidade',
      slide1_title: 'Bem-vindo ao Recash',
      slide1_desc: 'A app que digitaliza os seus talões, protege a sua saúde e faz você ganhar dinheiro em cada compra.',
      slide2_title: 'Lista de Compras',
      slide2_desc: 'Guarde e gira facilmente a sua lista de compras.',
      slide3_title: 'Notificações Instantâneas',
      slide3_desc: 'Receba um alerta assim que o seu cashback for creditado, quando o seu orçamento se aproximar do limite, ou em caso de recolha de produto.',
      slide4_title: 'Partilhe as suas listas',
      slide4_desc: 'Envie a sua lista de compras para a sua família ou amigos com um toque. Ideal para compras em grupo.',
      slide5_title: 'Proteção Duplo Preço & Especiais',
      slide5_desc: 'Recash deteta automaticamente um preço duplo no seu talão.',
      skip: 'Ignorar',
      next: 'Seguinte',
      get_started: 'Vamos lá!',
      or_guest: 'Continuar sem conta',
      all_stores: 'Todos os tipos de loja',
      referral_code_label: 'Código de referência (opcional)',
      referral_code_placeholder: 'Introduza o código…',
      health_title: 'Saúde',
      health_desc: 'Alergénios, aditivos, recolhas de produtos',
      regions: 'Recash na América do Norte, América Latina e Europa'
    },
    home: {
      greeting: 'Olá!',
      hero_title: 'Suas economias<br>em um scan',
      monthly_savings: 'Economizado este mês',
      total_retrieved: 'Ganhos totais',
      scan_ticket: 'Digitalizar<br>um talão',
      scan_product: 'Digitalizar<br>um produto',
      my_wallet: 'Minha<br>carteira',
      guide: 'Guia<br>de uso',
      wallet_balance: 'Saldo disponível',
      view_wallet: 'Ver carteira',
      critical_alerts: 'Alertas críticos',
      recent_receipts: 'Talões recentes',
      no_alerts: 'Sem alertas',
      no_tickets: 'Sem talões digitalizados',
      scan_first: 'Digitaliza o teu primeiro talão!',
      wallet_available: 'Carteira disponível',
      active_alerts: 'Alertas ativos',
      cta_subtitle: 'Recupera o teu dinheiro em segundos',
      recall_product: 'Recall de produto',
      warranty: 'Garantia',
      cashback: 'cashback',
      allergen: 'alergénio',
      health_score_title: 'Pontuação de saúde do mês',
      health_good: 'Bom',
      health_improve: 'A melhorar',
      critical: 'crítico',
      product: 'produto',
      ultra_processed: 'ultra-processado',
      see_all: 'Ver tudo',
      details: 'Detalhes',
      health_score: 'Pontuação de Saúde',
      out_of: 'De 100',
      score_good: '👍 Bom',
      score_improve: '👎 A melhorar',
      allergens: 'Alergénios',
      ultra_processed_plural: 'Ultra-processados',
      alerts: 'Alertas',
      recall: 'Recall',
      warranty_label: 'Garantia',
      available_in: 'Disponível em',
      store: 'Loja',
      pending_cashbacks: 'Cashbacks pendentes',
      no_pending: 'Sem cashbacks pendentes',
      recent_transactions: 'Transações recentes',
      no_transactions: 'Sem transações',
      withdraw: 'Levantar',
      add: 'Adicionar',
      scan: 'Digitalizar',
      tickets: 'Talões',
      active: 'Ativo',
      currency: 'Moeda',
      total_earnings: 'Ganhos totais',
      account_required: 'Conta necessária',
      account_desc: 'Crie uma conta gratuita para aceder à sua carteira e acompanhar seus cashbacks.',
      create_account: 'Criar conta',
      view_offers: 'Ver ofertas',
      loading_wallet: 'A carregar sua carteira...',
      error: 'Erro',
      retry: 'Tentar novamente',
      profile_title: 'Perfil',
      guest_message: 'Crie uma conta gratuita para personalizar o seu perfil e aceder a todas as funcionalidades.',
      user: 'Utilizador',
      stats_tickets: 'Talões',
      stats_savings: 'Poupanças',
      stats_alerts: 'Alertas resolvidos',
      ethical_score: 'Pontuação ética',
      savings: 'Economias',
      alerts_resolved: 'Alertas resolvidos',
      preferences: 'Preferências',
      notifications: 'Notificações',
      language: 'Idioma',
      ethical_points: 'Pontos Éticos',
      currency_label: 'Moeda',
      allergens_title: 'Alergénios',
      allergens_desc: 'Declare seus alergénios ou os da sua família para receber alertas ao digitalizar produtos.',
      save_allergens: 'Guardar meus alergénios',
      allergen_gluten: 'Glúten (trigo, centeio, cevada)',
      allergen_lactose: 'Lactose / Leite',
      allergen_eggs: 'Ovos',
      allergen_peanuts: 'Amendoins',
      allergen_nuts: 'Frutos secos (amêndoas, nozes, avelãs)',
      allergen_soy: 'Soja',
      allergen_fish: 'Peixe',
      allergen_shellfish: 'Crustáceos / Moluscos',
      allergen_sesame: 'Sésamo',
      allergen_sulfites: 'Sulfitos',
      allergen_mustard: 'Mostarda',
      allergen_celery: 'Aipo',
      allergen_lupin: 'Tremoço',
      allergen_molluscs: 'Moluscos',
      subscription: 'Subscrição',
      free_plan: 'Acesso a funcionalidades básicas',
      premium_plan: 'Cashback ilimitado, alertas prioritárias',
      pro_plan: 'Tudo Premium + API, suporte prioritário',
      view_offers_btn: 'Ver ofertas',
      manage: 'Gerir',
      actions: 'Ações',
      support: 'Suporte',
      legal: 'Avisos legais',
      delete_account: 'Eliminar minha conta',
      logout: 'Sair',
      logout_confirm: 'Tem a certeza de que deseja sair?',
      cancel: 'Cancelar',
      logout_btn: 'Sair',
      delete_confirm_title: '⚠️ Eliminação de conta',
      delete_confirm_msg: 'Esta ação é irreversível. Todos os seus dados serão eliminados.',
      delete_btn: 'Eliminar',
      delete_error: 'Erro ao eliminar',
      upload_error: 'Falha ao carregar',
      save_success: 'Alergénios guardados',
      save_error: 'Erro ao guardar',
      family_members: 'Membros da família',
      family_desc: 'Adicione membros da família com seus alergénios.',
      add_member: 'Adicionar membro',
      member_name: 'Nome',
      member_age: 'Idade',
      member_allergens: 'Alergénios',
      remove_member: 'Remover',
      save_family: 'Guardar família'
    },
    scan: {
      title: 'Digitalizar',
      ticket_tab: 'Talão',
      product_tab: 'Produto',
      take_photo: 'Tirar fotografia',
      import_gallery: 'Importar da galeria',
      upload_pdf: 'Carregar PDF',
      scan_barcode: 'Toca para digitalizar um produto',
      scan_ticket: 'Digitalizar um talão',
      scan_product: 'Digitalizar um produto',
      scan_btn: 'Digitalizar',
      processing: 'Processando...',
      analyzing: 'Analisando...',
      success: 'Sucesso',
      error: 'Erro',
      retry: 'Tentar novamente',
      capture_ticket: 'Captura um talão ou importa um ficheiro',
      searching_barcode: 'A procurar código de barras...',
      scanning_hint: '🔍 Deteção automática… aponte a câmara para o código de barras',
      stop_scanner: 'Parar',
      enter_barcode: 'Introduzir código de barras',
      uploading: 'A carregar...',
      analyzing_ai: 'Análise IA em curso...',
      searching_product: 'A procurar produto...',
      products_detected: 'Produtos detetados',
      validate_save: 'Validar e guardar',
      score_excellent: 'Excelente',
      score_good: 'Bom',
      score_average: 'Médio',
      score_avoid: 'Evitar',
      camera_access_denied: 'Acesso à câmara negado',
      analysis_failed: 'A análise falhou.',
      analysis_timeout: 'Análise expirada, por favor tente novamente.',
      unknown_product: 'Produto desconhecido',
      ticket_saved: 'Talão guardado',
      ticket_saved_desc: 'O seu talão foi analisado e guardado.',
      view_ticket: 'Ver talão',
      scan_another: 'Digitalizar outro talão',
      session_title: 'Sessão em curso',
      session_count: '{n} talão(ões) digitalizados',
      view_all_tickets: 'Ver todos os meus talões',
      session_store: 'Loja desconhecida',
      end_session: 'Terminar sessão',
      flipp_local_deals: 'Ofertas no supermercado',
      flipp_valid_until: 'Até',
      flipp_no_deals: 'Nenhuma oferta encontrada perto de você',
      flipp_location_label: 'Ofertas locais em',
      upload_failed: 'Erro ao carregar',
      permission_denied: 'Permissão negada',
      barcode_unavailable: 'Digitalização de código de barras não disponível no PC. Usa entrada manual.',
      product_found: 'Produto encontrado',
      product_not_found: 'Não foi possível encontrar este produto',
      location_banner: '📍 Para lhe oferecer as melhores ofertas da sua região, utilizamos a sua localização GPS. Os seus dados ficam no dispositivo e nunca são partilhados com terceiros.',
      location_banner_dismiss: 'Percebido'
    },
    tickets: {
      title: 'Meus talões',
      no_tickets: 'Sem talões digitalizados',
      scan_first: 'Digitaliza o teu primeiro talão para começar',
      date: 'Data',
      store: 'Loja',
      amount: 'Montante',
      status: 'Estado',
      cashback: 'Cashback',
      pending: 'Pendente',
      approved: 'Aprovado',
      rejected: 'Rejeitado',
      unknown_store: 'Loja desconhecida',
      history: 'Histórico',
      history_desc: 'Consulta todos os teus talões digitalizados',
      filter_all: 'Todos',
      filter_active: 'Ativos',
      filter_refunded: 'Reembolsados',
      filter_review: 'Revisão',
      filter_alerts: 'Alertas',
      scan_ticket: 'Digitalizar um talão',
      expires: 'Expira em',
      no_warranty: 'Sem garantia',
      alert: 'alerta',
      alerts: 'alertas',
      status_processed: 'Processado',
      status_processing: 'Processando',
      status_failed: 'Falhado',
      status_pending: 'Pendente',
      status_review: 'Revisão',
      default_category: 'Mercearia',
      search_placeholder: 'Pesquisar um produto...'
    },
    alerts: {
      title: 'Alertas',
      no_alerts: 'Sem alertas',
      all_alerts: 'Todos os alertas',
      critical: 'Crítico',
      moderate: 'Moderado',
      mild: 'Ligeiro',
      type: 'Tipo',
      date: 'Data',
      severity: 'Gravidade',
      mark_read: 'Marcar como lido',
      delete: 'Eliminar',
      recall: 'Recall de produto',
      allergen: 'Alérgeno',
      warranty: 'Garantia',
      filter_all: 'Todos',
      filter_recall: 'Recalls',
      filter_warranty: 'Garantias',
      filter_price: 'Preço',
      filter_cashback: 'Cashback',
      filter_ticket: 'Talões',
      filter_budget: 'Orçamento',
      loading: 'A carregar...',
      view_ticket: 'Ver talão',
      type_recall: 'Recall',
      type_warranty: 'Garantia',
      type_price: 'Preço',
      type_cashback: 'Cashback',
      type_ticket: 'Talão digitalizado',
      type_cashback_credited: 'Cashback creditado',
      type_budget_warning: 'Alerta orçamento',
      type_budget_exceeded: 'Orçamento excedido',
      severity_critical: 'Crítico',
      severity_warning: 'Atenção',
      severity_info: 'Info',
      product_label: 'Produto: ',
      less_than_hour: 'Há menos de uma hora',
      hours_ago: 'Há {h}h',
      yesterday: 'Ontem',
      days_ago: 'Há {d} dias',
      load_error: 'Não foi possível carregar os alertas'
    },
    wallet: {
      title: 'Carteira',
      balance: 'Saldo',
      available: 'Disponível',
      pending: 'Pendente',
      withdrawn: 'Levantado',
      withdraw: 'Levantar',
      withdraw_btn: 'Levantar',
      withdraw_success: 'Levantamento com sucesso',
      withdraw_error: 'Erro no levantamento',
      no_transactions: 'Sem transações',
      payment_methods: 'Métodos de pagamento',
      add_payment: 'Adicionar método de pagamento',
      paypal: 'PayPal',
      bank_account: 'Conta bancária',
      reserved: 'Reservado para membros',
      guest_message: 'Carteira, levantamentos e cashback estão reservados para membros Recash. Cria uma conta gratuita para começar hoje.',
      guest_banner_title: 'Veja o seu cashback como convidado',
      guest_banner_desc: 'Registe-se para levantar os seus ganhos e aceder a todas as funcionalidades.',
      loading: 'A carregar...',
      error_title: 'Erro',
      pending_cashbacks: 'Cashbacks pendentes',
      no_cashback: 'Sem cashbacks pendentes',
      transactions: 'Transações',
      withdraw_modal_title: 'Transferir para conta bancária',
      amount: 'Montante',
      transfer_method: 'Método de transferência',
      select: 'Selecionar',
      email_paypal: 'Email PayPal',
      iban_rib: 'IBAN/RIB',
      confirm_transfer: 'Confirmar transferência',
      add_payment_method: 'Adicionar método de pagamento',
      type: 'Tipo',
      card: 'Cartão bancário',
      card_number: 'Número do cartão',
      card_placeholder: '1234 5678 9012 3456',
      expiry: 'Data de validade',
      expiry_placeholder: 'MM/YY',
      paypal_email: 'Email PayPal',
      email_placeholder: 'exemplo@email.com',
      iban: 'IBAN',
      iban_placeholder: 'FR76....',
      add: 'Adicionar',
      status_completed: 'Concluído',
      status_pending: 'Pendente',
      status_failed: 'Falhado',
      load_error: 'Não foi possível carregar os dados da carteira',
      invalid_amount: 'Montante inválido',
      insufficient_balance: 'Saldo insuficiente',
      fill_destination: 'Por favor preenche o campo destino',
      withdrawal_requested: 'Levantamento solicitado com sucesso',
      withdrawal_error: 'Erro durante o levantamento',
      gross_amount: 'Montante bruto',
      commission_rate: 'Taxa de comissão',
      commission_amount: 'Comissão',
      net_amount: 'Montante líquido',
      commission_included: '(incluindo comissão)',
      feature_coming_soon: 'Funcionalidade em breve'
    },
    profile: {
      title: 'Perfil',
      my_info: 'Minha informação',
      first_name: 'Nome próprio',
      last_name: 'Apelido',
      email: 'Email',
      birth_year: 'Ano de nascimento',
      language: 'Idioma',
      allergens: 'Alergénios',
      allergen: 'Alergénio',
      add_allergen: 'Adicionar alergénio',
      add_allergy: 'Adicionar alergia',
      no_allergens: 'Sem alergénios configurados',
      family_mode: 'Modo família',
      family_members: 'Membros da família',
      add_member: 'Adicionar membro',
      no_members: 'Sem membros de família',
      subscription: 'Subscrição',
      current_plan: 'Plano atual',
      select_plan: 'Selecionar plano',
      change_plan: 'Alterar plano',
      payment_methods: 'Métodos de pagamento',
      add_payment: 'Adicionar método de pagamento',
      security: 'Segurança',
      change_password: 'Alterar palavra-passe',
      current_password: 'Palavra-passe atual',
      new_password: 'Nova palavra-passe',
      confirm_password: 'Confirmar palavra-passe',
      danger_zone: 'Zona de perigo',
      delete_account: 'Eliminar a minha conta',
      delete_confirm: 'Tens a certeza de que queres eliminar a tua conta?',
      cancel: 'Cancelar',
      save: 'Guardar',
      name: 'Nome',
      add: 'Adicionar',
      change: 'Confirmar',
      logout: 'Terminar sessão',
      phone: 'Telefone',
      phone_placeholder: 'ex: +1 514 555-1234',
      ethical_points_title: 'Pontos Éticos',
      ethical_points_this_month: 'Este mês',
      ethical_points_total: 'Total acumulado',
      ethical_points_see_all: 'Ver painel',
      ethical_points_desc: 'Ganhe pontos escolhendo alternativas saudáveis e ecológicas',
      ethical_points_canada_only: 'Disponível apenas no Canadá',
      ethical_points_toggle: 'Ativar Pontos Éticos',
      country: 'País',
      select: 'Selecionar',
      preferences: 'Preferências',
      currency: 'Moeda',
      monthly_budget: 'Orçamento mensal',
      push_notifications: 'Notificações push',
      email_notifications: 'Notificações email',
      no_allergies_registered: 'Sem alergénios registados',
      no_members_registered: 'Sem membros registados',
      born_in: 'Nascido em',
      no_allergies: 'Sem alergias',
      current_plan_label: 'Plano atual',
      expires_on: 'Expira em',
      no_payment_methods: 'Sem métodos de pagamento registados',
      feature_coming_soon: 'Funcionalidade brevemente',
      delete_warning: 'Eliminar a tua conta é irreversível e elimina todos os teus dados.',
      allergen_placeholder: 'ex: glúten, amendoins...',
      severity: 'Gravidade',
      severe: 'Severo',
      moderate: 'Moderado',
      mild: 'Ligeiro',
      member_name_placeholder: 'Nome',
      birth_year_placeholder: 'ex: 2010',
      allergies_placeholder: 'glúten, lactose...',
      per_month: '/mês',
      error_loading: 'Erro de carregamento',
      profile_saved: 'Perfil guardado',
      save_error: 'Erro ao guardar',
      notifications_enabled: 'Notificações ativadas ✅',
      notifications_disabled: 'Notificações desativadas',
      notifications_denied: 'Permissão negada. Ative as notificações nas configurações do navegador.',
      preferences_saved: 'Preferências guardadas',
      allergy_added: 'Alergénio adicionado',
      allergy_add_error: 'Erro ao adicionar',
      allergy_deleted: 'Alergénio eliminado',
      allergy_delete_error: 'Erro ao eliminar',
      member_added: 'Membro adicionado',
      member_add_error: 'Erro ao adicionar',
      member_deleted: 'Membro eliminado',
      member_delete_error: 'Erro ao eliminar',
      password_mismatch: 'As palavras-passe não coincidem',
      password_changed: 'Palavra-passe alterada',
      password_change_error: 'Erro ao alterar palavra-passe',
      delete_account_title: 'Eliminar conta',
      delete_account_message: 'Esta ação é irreversível e elimina todos os teus dados.',
      delete_button: 'Eliminar',
      severity_severe: 'Severo',
      severity_moderate: 'Moderado',
      severity_mild: 'Ligeiro',
      plan_business: 'Business',
      plan_premium: 'Premium',
      plan_free: 'Gratuito',
      subscription_downgraded: 'Subscrição degradada para Gratuito',
      redirect_stripe: 'Redirecionando para Stripe Checkout…',
      redirect_paypal: 'Redirecionando para PayPal…',
      country_ca: 'Canadá',
      country_fr: 'França',
      country_us: 'Estados Unidos',
      country_br: 'Brasil',
      country_be: 'Bélgica',
      country_de: 'Alemanha',
      country_es: 'Espanha',
      country_it: 'Itália',
      country_pt: 'Portugal',
      country_nl: 'Países Baixos',
      country_ch: 'Suíça',
      country_at: 'Áustria',
      country_mx: 'México',
      country_ar: 'Argentina',
      country_co: 'Colômbia',
      country_pe: 'Peru',
      country_cl: 'Chile',
      country_gb: 'Reino Unido',
      country_ie: 'Irlanda',
      country_pl: 'Polônia',
      country_cz: 'República Tcheca',
      country_se: 'Suécia',
      country_no: 'Noruega',
      country_dk: 'Dinamarca',
      country_fi: 'Finlândia',
      lang_pt: 'Português',
      lang_en: 'English',
      lang_es: 'Español',
      lang_de: 'Deutsch',
      currency_cad: 'CAD – Dólar canadense',
      currency_usd: 'USD – Dólar americano',
      currency_brl: 'BRL – Real brasileiro',
      currency_gbp: 'GBP – Libra esterlina',
      health_filters: 'Filtros de Saúde',
      health_filters_desc: 'Personalize a sua pontuação de saúde de acordo com as suas preferências',
      avoid_fodmap: 'Evitar FODMAP',
      no_palm_oil: 'Sem óleo de palma',
      no_plastic: 'Sem plástico',
      organic_only: 'Apenas orgânico',
      vegetarian: 'Vegetariano',
      vegan: 'Vegano',
      save_health_filters: 'Guardar filtros',
      user: 'Utilizador', stats_tickets: 'Talões', stats_savings: 'Poupanças', stats_alerts: 'Alertas resolvidos',
      ethical_score: 'Pontuação ética', local_purchases: 'Compras locais', eco_friendly: 'Eco-friendly', fair_trade: 'Comércio justo',
      ethical_excellent: 'Excelente', ethical_progress: 'Em progresso', ethical_improve: 'A melhorar',
      referral_badge: 'Novo', guide: 'Guia de utilização', notifications: 'Notificações', guest_message: 'Crie uma conta gratuita para personalizar o seu perfil e aceder a todas as funcionalidades.',
      allergens_desc: 'Declare os seus alergénios ou os da sua família para receber alertas ao digitalizar produtos.',
      save_allergens: 'Guardar meus alergénios',
      allergen_gluten: 'Glúten (trigo, centeio, cevada)', allergen_lactose: 'Lactose / Leite', allergen_eggs: 'Ovos',
      allergen_peanuts: 'Amendoins', allergen_nuts: 'Frutos secos (amêndoas, nozes, avelãs)', allergen_soy: 'Soja',
      allergen_fish: 'Peixe', allergen_shellfish: 'Crustáceos / Moluscos', allergen_sesame: 'Sésamo',
      allergen_sulfites: 'Sulfitos', allergen_mustard: 'Mostarda', allergen_celery: 'Aipo', allergen_lupin: 'Tremoço', allergen_molluscs: 'Moluscos',
      manage: 'Gerir', view_offers: 'Ver ofertas', actions: 'Ações', support: 'Suporte', legal: 'Avisos legais',
      logout_title: 'Terminar sessão', logout_confirm: 'Tem a certeza que quer terminar sessão?',
      delete_title: '⚠️ Eliminar conta', delete_confirm_btn: 'Eliminar',
      delete_error: 'Erro ao eliminar', upload_error: 'Falha no upload',
      allergens_saved: 'Alergénios guardados', allergens_error: 'Erro ao guardar',
      plan_pro: 'Pro', plan_free_desc: 'Acesso a funcionalidades básicas', plan_premium_desc: '50 tickets cashback / mês, alertas prioritários', plan_pro_desc: 'Tudo Premium + API, suporte prioritário', plan_business_desc: 'Tickets cashback ilimitados, tudo Pro + gestão de equipa',
      member_first_name: 'Primeiro nome do membro', member_last_name: 'Apelido do membro',
      manage_allergens: 'Gerir os meus alergénios', member_allergens_of: 'Alergénios de', modal_close: 'Fechar', allergen_alert_family: 'é alérgico a',
      member_name: 'Primeiro nome', save_info: 'Guardar as minhas informações',
      email_readonly_note: 'Email de acesso — não pode ser alterado aqui.'
    },
    health_dashboard: {
      title: 'Painel de Saúde',
      monthly_score: 'Pontuação Mensal',
      base_score: 'Pontuação Base',
      personalized_score: 'Pontuação Personalizada',
      cumulative_stats: 'Estatísticas Cumulativas',
      health_points: 'Pontos de Saúde',
      co2_saved: 'CO2 Economizado',
      water_saved: 'Água Economizada',
      products_scanned: 'Produtos Digitalizados',
      trends: 'Tendências',
      score_trend: 'Tendência de Pontuação',
      co2_trend: 'Tendência de CO2',
      recent_products: 'Produtos Recentes',
      no_products: 'Nenhum produto digitalizado este mês'
    },
    anti_waste: {
      title: 'Anti-Desperdício',
      subtitle: 'Reduza o seu impacto ambiental',
      better_packaging: 'Melhor embalagem',
      less_plastic: 'Menos plástico',
      better_eco_score: 'Melhor Eco-Score',
      local_product: 'Produto local',
      seasonal_product: 'Produto sazonal',
      no_suggestions: 'Nenhuma sugestão disponível para este produto',
      packaging_preferred: 'Embalagem preferida',
      packaging_preferred_desc: 'Escolha produtos com embalagem reciclável (cartão, vidro) quando possível.',
      less_plastic_alt: 'Alternativa com menos plástico',
      less_plastic_desc: 'Este produto contém plástico. Aqui está uma alternativa com melhor embalagem.',
      better_eco_alt: 'Alternativa com melhor Eco-Score',
      better_eco_alt_desc: 'Experimente esta alternativa com melhor impacto ambiental.',
      prefer_local: 'Prefira produtos locais',
      prefer_local_desc: 'Este produto vem de longe. Para frutas, legumes e produtos frescos, escolher local reduz a pegada de carbono.',
      seasonal_tip: 'Produto sazonal',
      seasonal_tip_desc: 'Prefira frutas e legumes sazonais para melhor impacto ambiental e gustativo.',
      responsible_consumption: 'Consumo responsável',
      responsible_consumption_desc: 'Compre apenas o que precisa e prefira produtos com bom Nutri-Score e Eco-Score.'
    },
    pricing: {
      title: 'Subscrições',
      payment_title: 'Pagamento',
      select_plan: 'Selecionar plano',
      free: 'Gratuito',
      premium: 'Premium',
      business: 'Business',
      unlimited_scans: 'Digitalizações ilimitadas',
      tickets_per_month: 'Talões por mês',
      reminders: 'Lembretes',
      unlimited_tickets: 'Talões ilimitados', tickets_cashback_month: 'tickets cashback / mês', unlimited_tickets_cashback: 'Tickets cashback ilimitados',
      full_cashback: 'Cashback completo',
      family_mode: 'Modo família',
      unlimited_wallet: 'Carteira ilimitada',
      priority_support: 'Suporte prioritário',
      all_premium: 'Todas as funcionalidades Premium',
      accounting_export: 'Exportação contabilística',
      collaborators: 'Colaboradores',
      api_access: 'Acesso API',
      select_payment: 'Selecionar método de pagamento',
      stripe: 'Stripe',
      secure_card: 'Cartão seguro',
      paypal: 'PayPal',
      secure_payment: 'Pagamento seguro',
      paypal_account: 'Conta PayPal',
      or_credit_card: 'ou cartão de crédito',
      limit_reached: 'Limite mensal atingida',
      limit_message: 'Atingiu o seu limite de 10 bilhetes gratuitos este mês. Faça upgrade para Premium para digitalizações ilimitadas.',
      tickets_remaining: 'Bilhetes restantes este mês',
      of_10: 'de 10',
      offers: 'Ofertas',
      choose_plan: 'Escolha o seu plano',
      choose_plan_subtitle: 'Aproveite funcionalidades adaptadas às suas necessidades',
      redirect_payment: 'A redirecionar para o pagamento seguro...',
      per_month: '/mês', per_year: '/ano', save_2_months: '2 meses grátis',
      pro: 'Pro',
      popular: 'Popular',
      start_free: 'Começar gratuitamente',
      choose_premium: 'Escolher Premium',
      choose_pro: 'Escolher Pro',
      ten_tickets_month: '10 tickets cashback / mês',
      product_scan: 'Digitalização de produtos',
      basic_alerts: 'Alertas básicos',
      manufacturer_warranties: 'Garantias do fabricante',
      unlimited_cashback: 'Cashback ilimitado',
      advanced_alerts: 'Alertas avançados',
      extended_warranties: 'Garantias estendidas',
      faq_title: 'Perguntas frequentes',
      faq_q1: 'Posso mudar de plano a qualquer momento?',
      faq_a1: 'Sim, pode fazer upgrade ou downgrade a qualquer momento a partir do seu perfil.',
      faq_q2: 'O registo é gratuito?',
      faq_a2: 'Sim, o registo é gratuito no plano Gratuito e obtém 10 cashbacks gratuitos.',
      faq_q3: 'Os meus dados estão seguros?',
      faq_a3: 'Absolutamente. Usamos encriptação ponta-a-ponta e nunca partilhamos os seus dados com terceiros.',
      faq_q4: 'Posso cancelar a qualquer momento?',
      faq_a4: 'Sim, pode cancelar a sua assinatura a qualquer momento. Mantém o acesso até ao fim do período pago.',
      not_logged_in: 'Inicie sessão para subscrever um plano',
      payment_url_missing: 'URL de pagamento em falta',
      payment_error: 'Erro ao criar o pagamento',
      pay_with: 'Pagar com',
      pay_card: 'Cartão bancário',
      pay_interac: 'Interac e-Transfer',
      interac_title: 'Pagamento por Interac e-Transfer',
      interac_subtitle: 'Envie uma transferência Interac a partir da sua aplicação bancária',
      interac_step1: '1. Abra a sua aplicação bancária',
      interac_step2: '2. Envie o valor exato para o endereço indicado',
      interac_step3: '3. Escreva este código no campo de mensagem',
      interac_step4: '4. A sua subscrição será ativada em 24 horas úteis',
      interac_email_label: 'Endereço e-Transfer',
      interac_amount_label: 'Valor a enviar',
      interac_code_label: 'Código de referência (obrigatório na mensagem)',
      interac_expiry: 'Este código expira em 72 horas',
      interac_copy: 'Copiar',
      interac_copied: 'Copiado!',
      interac_confirm: 'Enviei a transferência',
      interac_pending: 'Aguardando confirmação',
      interac_pending_desc: 'Assim que recebermos o seu pagamento, a sua subscrição será ativada automaticamente.',
      interac_error: 'Erro ao criar o pedido Interac',
      paypal_subtitle: 'Pagamento seguro com a sua conta PayPal',
      stripe_subtitle: 'Visa, Mastercard, Amex — pagamento seguro',
      pay_wire: 'Transferência bancária',
      wire_subtitle: 'Transferência do seu banco — ativação em 24 h',
      wire_title: 'Pagamento por transferência bancária',
      wire_bank: 'Banco',
      wire_holder: 'Titular da conta',
      wire_institution: 'Instituição / Trânsito',
      wire_account: 'Número de conta',
      wire_step1: '1. Aceda à sua banca online',
      wire_step2: '2. Envie o valor exato com este código como referência',
      wire_step3: '3. A sua subscrição será ativada em 24 horas úteis',
      wire_error: 'Erro ao criar o pedido de transferência'
    },
    guest: {
      reserved_title: 'Reservado para membros',
      create_account: 'Criar a minha conta',
      view_plans: 'Ver subscrições',
      wallet_desc: 'Carteira, levantamentos e cashback estão reservados para membros Recash. Cria uma conta gratuita para começar hoje.',
      tickets_desc: 'Histórico de talões, reembolsos e alertas de preço estão reservados para membros Recash.',
      alerts_desc: 'Alertas de saúde, recalls de produtos e notificações de cashback estão reservados para membros Recash.',
      profile_desc: 'Gere o teu perfil, os teus alergénios e a tua subscrição criando uma conta Recash.',
      close: 'Fechar',
      back: 'Voltar',
      yes: 'Sim',
      no: 'Não',
      ok: 'OK',
      search: 'Pesquisar',
      selected: 'Selecionado',
      continue: 'Continuar',
      continue_with: 'Continuar com {plan}'
    },
    ethical: {
      title: 'Pontos Éticos',
      ineligible_msg: 'Os pontos éticos estão disponíveis apenas no Canadá.',
      your_location: 'A sua localização',
      unknown: 'Desconhecido',
      this_month: 'Este mês',
      points: 'Pontos',
      value: 'Valor',
      choices: 'Escolhas',
      points_remaining: 'pontos restantes / 100 max',
      total_cumulative: 'Total cumulativo',
      earned: 'ganhos',
      double_bonus: 'Bónus duplo',
      points_per_choice: 'Pontos/escolha',
      recent_activity: 'Atividade recente',
      no_activity: 'Sem atividade recente',
      start_scanning: 'Digitalize produtos para acumular pontos éticos!',
      monthly_history: 'Histórico mensal',
      alternative: 'Alternativa'
    },
    referral: {
      title: 'Referência',
      hero_title: 'Convide amigos, ganhe recompensas',
      hero_subtitle: 'Partilhe o seu código e receba cashback assim que o seu amigo digitalizar os primeiros talões',
      you_earn: 'Você recebe',
      friend_gets: 'O seu amigo recebe',
      trigger_note: 'Recompensa ativada após {n} talões digitalizados pelo seu referido',
      your_code: 'O seu código de referência',
      copied: 'Código copiado!',
      share: 'Partilhar o meu código',
      share_msg: 'Junte-se ao Recash com o meu código {code} e ganhe {days} dias Premium gratuitos! Digitalize talões e ganhe cashback.',
      stats_title: 'As minhas referências',
      total_referrals: 'Convidados',
      credited: 'Validados',
      total_earned: 'Ganho',
      have_code: 'Tem um código de amigo?',
      enter_code: 'Insira o código…',
      apply: 'Aplicar',
      apply_success: '✅ Código aplicado! {days} dias Premium ofertados.',
      apply_error: 'Código inválido ou já utilizado',
      load_error: 'Impossível carregar os dados de referência',
      retry: 'Tentar novamente'
    },
    common: {
      loading: 'A carregar...',
      error: 'Ocorreu um erro',
      retry: 'Tentar novamente',
      view_details: 'Ver detalhes',
      see_all: 'Ver tudo',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Guardar',
      delete: 'Eliminar',
      close: 'Fechar',
      back: 'Voltar',
      yes: 'Sim',
      no: 'Não',
      ok: 'OK',
      search: 'Pesquisar',
      selected: 'Selecionado',
      continue: 'Continuar',
      continue_with: 'Continuar com {plan}'
    },
    product: {
      allergen_warning: 'Contém um alergénio para o teu perfil',
      additives: 'Aditivos detetados',
      cashback: 'cashback',
      nutriscore: 'Nutri-Score',
      nova: 'Índice NOVA',
      ingredients: 'Ingredientes',
      alternatives: 'Alternativas da mesma categoria',
      alternatives_subtitle: 'Produtos similares de outras marcas com bom pontuação de saúde',
      price_comparison: 'Comparação de preços',
      no_alternatives: 'Nenhuma alternativa encontrada para esta categoria',
      price_paid: 'Preço pago',
      market_avg: 'Média mercado',
      cheapest: 'Mais barato',
      stores_compared: 'loja(s) comparada(s)',
      cheaper_stores: '📉 Onde pagar menos',
      best_price: '✅ Compraste este produto ao melhor preço encontrado no mercado!',
      no_market_data: 'Dados de mercado insuficientes para este produto.',
      eco_score: 'Eco-Score',
      price_position_best: 'Melhor preço',
      price_position_competitive: 'Preço competitivo',
      price_position_expensive: 'Preço elevado',
      price_position_overpriced: 'Sobrecarregado',
      price_position_unknown: 'Preço desconhecido'
    },
    price_comparison: {
      title: '💡 Melhores preços e folheto',
      save_up_to: 'Poupe até',
      flyer_active: 'Folheto ativo',
      valid_until: 'Válido até',
      best_price_badge: 'MELHOR PREÇO',
      see_badge: 'VER'
    },
    scan_result: {
      price_paid: 'Preço pago:',
      nutri_score: 'Nutri-Score =',
      personalized_score: 'Pontuação Personalizada',
      base_score: 'Pontuação base',
      personalized_score_label: 'Pontuação personalizada',
      nutrition_title: 'Informação nutricional (por 100g)',
      sugars: 'Açúcares',
      saturated_fat: 'Gorduras saturadas',
      calories: 'Calorias',
      fiber: 'Fibra',
      proteins: 'Proteínas',
      sodium: 'Sódio',
      country: 'País',
      category: 'Categoria',
      defects: 'Defeitos',
      qualities: 'Qualidades',
      additives: 'Aditivos',
      palm_oil_detected: '⚠️ Óleo de palma detetado',
      contains_additives: 'Este produto contém {count} aditivos',
      allergens: 'Alergénios',
      ingredients: 'Ingredientes',
      comparison_title: 'Comparação de preços',
      no_market_data: '📊 Dados de mercado insuficientes para este produto.',
      avg_market: 'Média mercado',
      stores_compared: 'loja(s) comparada(s)',
      where_cheaper: '📉 Onde pagar menos',
      best_price_market: '✅ Compraste este produto ao melhor preço encontrado no mercado!',
      same_product_cheaper: 'Mesmo produto mais barato',
      savings: 'Poupança:',
      healthier_alternatives: 'Alternativas mais saudáveis',
      best_health_score: 'Melhor pontuação de saúde',
      eco_alternatives: 'Alternativas mais ecológicas',
      less_co2_impact: 'Menor impacto CO2',
      ethical_points: 'Pontos Éticos',
      ethical_description: 'Ganhe Pontos Éticos pelas suas escolhas saudáveis e ecológicas',
      ethical_value: '💰 100 pontos = $1 CAD',
      points_available: 'pontos disponíveis',
      grocery_offers: 'Ofertas de supermercado',
      offers_count: 'oferta(s)',
      no_offers: 'Sem ofertas',
      no_offers_for: 'Nenhuma oferta encontrada para',
      in_region: 'nos folhetos de',
      no_promotion: 'Este produto não está atualmente em promoção em nenhum supermercado local.',
      compare_online: '🔍 Comparar preços online',
      cashback_available: 'Cashback disponível',
      disclaimer: 'Sugestões apenas para informação (Open Food Facts e parceiros). Nenhuma marca paga ao Recash. Preços e disponibilidade podem variar.',
      score_excellent: 'Excelente',
      score_good: 'Bom',
      score_mediocre: 'Medíocre',
      score_avoid: 'A evitar',
      score_explanation: 'Pontuação de saúde em 100: quanto maior, melhor para a saúde.',
      defect_too_fat: 'Demasiado gordo',
      defect_moderate_fat: 'Gordura moderada',
      defect_very_caloric: 'Muito calórico',
      defect_moderate_caloric: 'Calorias moderadas',
      defect_too_salty: 'Demasiado salgado',
      defect_too_sugary: 'Demasiado açucarado',
      defect_moderate_sugars: 'Açúcares moderados',
      quality_excellent_amount: 'Quantidade excelente',
      quality_good_amount: 'Boa quantidade',
      quality_excellent_intake: 'Aporte excelente',
      quality_correct_intake: 'Aporte adequado',
      quality_low_sodium: 'Baixo teor de sódio',
      error_rate_limit: 'O OpenFoodFacts está a limitar os pedidos — aguarde alguns segundos e tente novamente.'
    },
    about: {
      title: 'Sobre o Recash',
      description: 'O Recash transforma os seus talões em oportunidades de poupança e saúde. Graças à IA, cada compra é analisada para detetar cashbacks, alergénios, recalls de produtos e anomalias de preço. Concebido para famílias, consumidores informados e profissionais.',
      features_label: 'Funcionalidades detalhadas',
      free_feat_1: 'Digitalização de produtos ilimitada',
      free_feat_2: '10 talões / mês',
      free_feat_3: 'Alertas de recall de produtos',
      free_feat_4: 'Carteira 20 máx',
      premium_feat_3: 'Modo família (5 membros)',
      premium_feat_4: 'Carteira ilimitada + levantamentos PayPal',
      business_feat_3: '20 colaboradores',
      see_pricing: 'Ver preços',
      subscribe: 'Subscrever',
      key_figures: 'Números chave',
      partners: 'Tecnologias e parceiros',
      privacy: 'Privacidade',
      help: 'Ajuda',
      feat_scan_title: 'Digitalização inteligente',
      feat_scan_1_label: 'Digitalização de talões', feat_scan_1_desc: 'foto, galeria ou PDF',
      feat_scan_2_label: 'Digitalização de produto por código de barras', feat_scan_2_desc: 'verificação em loja',
      feat_scan_3_label: 'Reconhecimento automático', feat_scan_3_desc: 'país e idioma detetados',
      feat_safety_title: 'Segurança sanitária',
      feat_safety_1_label: 'Alergénios detetados', feat_safety_1_desc: 'comparados com o seu perfil familiar',
      feat_safety_2_label: 'Aditivos perigosos', feat_safety_2_desc: 'E250, E150d, óleo de palma...',
      feat_safety_3_label: 'Recalls de produtos', feat_safety_3_desc: 'APIs Health Canada, FDA, DGCCRF',
      feat_safety_4_label: 'Nutri-Score e NOVA', feat_safety_4_desc: 'qualidade nutricional e processamento',
      feat_savings_title: 'Poupanças automáticas',
      feat_savings_1_label: 'Cashback', feat_savings_1_desc: 'reembolso automático (Pampers, Danone...)',
      feat_savings_2_label: 'Garantias', feat_savings_2_desc: 'alertas antes da expiração (2 anos Europa)',
      feat_savings_3_label: 'Comparador de preços', feat_savings_3_desc: 'Walmart, Amazon, Carrefour...',
      feat_savings_4_label: 'Anomalias de preço', feat_savings_4_desc: 'deteção de erros de caixa',
      feat_family_title: 'Modo família',
      feat_family_1_label: 'Perfis de saúde individuais', feat_family_1_desc: 'alergias e dietas por membro',
      feat_family_2_label: 'Carteira partilhada', feat_family_2_desc: 'saldo partilhado entre membros',
      feat_family_3_label: 'Alertas personalizados', feat_family_3_desc: 'por perfil de membro',
      feat_wallet_title: 'Carteira integrada',
      feat_wallet_1_label: 'Saldo disponível', feat_wallet_1_desc: 'em tempo real',
      feat_wallet_2_label: 'Transferências bancárias / PayPal', feat_wallet_2_desc: 'levantar a qualquer momento',
      feat_wallet_3_label: 'Cashbacks pendentes', feat_wallet_3_desc: 'acompanhamento de estado',
      stat_users: 'utilizadores',
      stat_tickets: 'talões digitalizados',
      stat_savings: 'poupanças geradas'
    },
    payment: {
      success_title: 'Pagamento bem-sucedido!',
      success_msg: 'Obrigado pela sua subscrição. A sua conta foi atualizada.',
      success_detail: 'Pode agora desfrutar de todas as funcionalidades.',
      back_home: 'Voltar ao início',
      cancel_title: 'Pagamento cancelado',
      cancel_msg: 'Cancelou o processo de pagamento.',
      cancel_detail: 'Nenhum valor foi cobrado. Pode tentar novamente quando quiser.',
      retry: 'Tentar novamente',
      paypal_processing: 'A processar pagamento PayPal…',
      paypal_wait: 'Por favor aguarde enquanto confirmamos o seu pagamento.',
      paypal_error_title: 'Erro PayPal',
      paypal_error_generic: 'Ocorreu um erro ao processar o seu pagamento PayPal.',
      paypal_cancelled_title: 'Pagamento cancelado',
      paypal_cancelled_msg: 'Cancelou o pagamento PayPal. Nenhum valor foi cobrado.',
      try_again: 'Tentar novamente'
    },
    family: {
      title: 'Família',
      shared_account: 'Conta partilhada',
      shared_desc: 'Partilhe alertas e cashback com a sua família.',
      code_label: 'Código',
      members: 'Membros',
      head: 'Chefe',
      no_members: 'Nenhum membro adicionado',
      invite_member: 'Convidar um membro',
      cancel: 'Cancelar',
      send_invite: 'Enviar convite',
      invite_sent: 'Convite enviado!',
      invite_error: 'Erro ao enviar'
    },
    ticket_detail: {
      ticket_of: 'Talao de',
      loading: 'A carregar talao...',
      error: 'Erro',
      retry: 'Tentar novamente',
      no_photo: 'Nenhuma foto disponível',
      total: 'Total',
      status: 'Estado',
      products: 'Produtos',
      alerts_section: 'Alertas',
      request_refund: 'Pedir reembolso',
      ticket_photo: 'Foto do talao',
      close: 'Fechar',
      id_missing: 'ID do talao em falta',
      cannot_load: 'Não foi possível carregar o talao',
      claim_sent: 'Pedido de reembolso enviado',
      claim_error: 'Erro no pedido',
      status_completed: 'Reembolsado',
      status_processed: 'Processado',
      status_processing: 'A processar',
      status_failed: 'Falhou',
      status_pending: 'Pendente',
      cashback_pending: 'Pendente',
      cashback_approved: 'Aprovado',
      cashback_paid: 'Pago',
      allergen: 'Alergénio',
      recall: 'Recall'
    },
    legal: {
      title: 'Informação legal',
      cgu: 'Termos',
      privacy: 'Privacidade',
      mentions: 'Avisos legais',
      cgu_title: 'Condições Gerais de Utilização',
      privacy_title: 'Política de privacidade',
      mentions_title: 'Avisos legais',
      cgu_article1_title: 'Artigo 1 – Objeto',
      cgu_article1_text: 'Recash é uma aplicação móvel que permite digitalizar talões e produtos para:',
      cgu_article1_item1: 'Detetar alergénios, aditivos, Nutri-Score, NOVA',
      cgu_article1_item2: 'Obter cashbacks automáticos',
      cgu_article1_item3: 'Ser alertado em caso de recall de produto ou garantia a expirar',
      cgu_article1_item4: 'Comparar preços com outras lojas',
      cgu_article2_title: 'Artigo 2 – Acesso à aplicação',
      cgu_article2_text: 'O acesso ao serviço requer a criação de uma conta. A utilização é gratuita com limites (10 talões/mês). As funcionalidades avançadas requerem uma subscrição paga.',
      cgu_article2_item1: 'Idade mínima: 13 anos (ou 16 anos dependendo do país)',
      cgu_article2_item2: 'Conta necessária para cashback e wallet',
      cgu_article3_title: 'Artigo 3 – Digitalização de produto',
      cgu_article3_text: 'A digitalização de produto é gratuita e ilimitada, mesmo sem subscrição. Os dados são comparados com Open Food Facts e bases governamentais (Santé Canada, FDA, DGCCRF).',
      cgu_article4_title: 'Artigo 4 – Comissão Recash',
      cgu_article4_text: 'Recash devolve aos utilizadores uma parte do cashback gerado pelas marcas parceiras. Uma comissão é cobrada por Recash para financiar a aplicação, taxas de plataforma e integrações técnicas.',
      cgu_article4_item1: 'Taxa de comissão: A taxa de comissão atual é de 20% (configurável pelo administrador)',
      cgu_article4_item2: 'Transparência: O montante bruto, a comissão e o montante líquido são exibidos na interface da aplicação para cada cashback',
      cgu_article4_item3: 'Cálculo: Montante líquido = Montante bruto - (Montante bruto × Taxa de comissão)',
      cgu_article4_item4: 'Modificação: Esta taxa é visível e modificável pelo administrador. Qualquer alteração será comunicada por email ou notificação na aplicação',
      cgu_article4_item5: 'Levantamentos: Os levantamentos são possíveis para conta bancária ou PayPal (montante mínimo aplicável)',
      cgu_article4_item6: 'Expiração: Os cashbacks não reclamados após 12 meses de inatividade são cancelados',
      cgu_article5_title: 'Artigo 5 – Responsabilidades',
      cgu_article5_text: 'Recash fornece informações apenas a título indicativo. As informações nutricionais e de saúde não constituem aconselhamento médico. Em caso de recall de produto, Recash não é responsável pela contaminação nem danos resultantes.',
      cgu_article6_title: 'Artigo 6 – Modificação das CGU',
      cgu_article6_text: 'Recash reserva-se o direito de modificar as presentes CGU a qualquer momento. Os utilizadores serão informados por email ou notificação push. A continuação da utilização após notificação constitui aceitação das novas CGU.',
      cgu_article7_title: 'Artigo 7 – Rescisão',
      cgu_article7_text: 'O utilizador pode eliminar a sua conta a qualquer momento a partir de Perfil → Zona de perigo. Os dados são eliminados em 30 dias. Recash pode suspender qualquer conta em caso de fraude ou violação das CGU.',
      cgu_article8_title: 'Artigo 8 – Direito aplicável',
      cgu_article8_text: 'As presentes CGU são regidas pelo direito canadiano (província de Quebec). Qualquer litígio será submetido aos tribunais competentes de Montreal, Canadá.',
      cgu_updated: 'Última atualização: 1 de janeiro de 2025',
      privacy_updated: 'Última atualização: 1 de janeiro de 2025',
      privacy_section1_title: '1. Dados recolhidos',
      privacy_section1_item1: 'Talões digitalizados: produtos, preços, datas, lojas (conservados 3 anos)',
      privacy_section1_item2: 'Perfil de saúde: alergénios, dietas (armazenados de forma cifrada)',
      privacy_section1_item3: 'Geolocalização: para detetar o país e lojas próximas (opcional)',
      privacy_section1_item4: 'Dados de pagamento: Stripe (não armazenados por Recash)',
      privacy_section1_item5: 'Dados de navegação: logs de utilização anonimizados',
      privacy_section2_title: '2. Finalidades do tratamento',
      privacy_section2_item1: 'Otimização de cashbacks e matching com ofertas parceiras',
      privacy_section2_item2: 'Detecção de alergénios e recalls de produtos personalizados',
      privacy_section2_item3: 'Melhoria dos algoritmos IA da aplicação',
      privacy_section2_item4: 'Envio de notificações e alertas de segurança',
      privacy_section3_title: '3. Seus direitos (RGPD / LPRPDE)',
      privacy_section3_text: 'Em conformidade com RGPD (UE) e LPRPDE (Canadá), dispõe de:',
      privacy_section3_item1: 'Direito de acesso aos seus dados',
      privacy_section3_item2: 'Direito de retificação',
      privacy_section3_item3: 'Direito ao apagamento (« direito ao esquecimento »)',
      privacy_section3_item4: 'Direito à portabilidade (exportação JSON)',
      privacy_section3_item5: 'Direito de oposição ao tratamento',
      privacy_section3_contact: 'Contacto: support@recash.shop',
      privacy_section4_title: '4. Conservação dos dados',
      privacy_section4_text: 'Dados conservados máximo 3 anos após a sua última ligação. Eliminação definitiva em 30 dias após pedido. Dados contabilísticos conservados 7 anos (obrigação legal).',
      privacy_section5_title: '5. Cookies e APIs de terceiros',
      privacy_section5_item1: 'Open Food Facts (base produtos, licença ODbL)',
      privacy_section5_item2: 'SerpApi (comparador de preços)',
      privacy_section5_item3: 'APIs governamentais: Santé Canada, FDA, DGCCRF',
      privacy_section5_item4: 'OpenAI (análise OCR e IA – dados anonimizados)',
      privacy_section5_item5: 'Stripe (pagamentos – PCI-DSS nível 1)',
      privacy_section6_title: '6. Segurança',
      privacy_section6_text: 'Dados cifrados em trânsito (TLS 1.3) e em repouso (AES-256). Acesso restrito ao pessoal autorizado. Auditorias de segurança regulares. Nenhuma venda de dados pessoais a terceiros.',
      mentions_editor_title: 'Editor da aplicação',
      mentions_editor_name: 'Recash, 1522 Rue Ottawa #B701, Montreal, Quebec, Email: support@recash.shop',
      mentions_hosting_title: 'Hospedagem',
      mentions_hosting_item1: 'Base de dados: Supabase (supabase.io) – AWS us-east-1',
      mentions_hosting_item2: 'Frontend: Vercel (vercel.com)',
      mentions_hosting_item3: 'API backend: Railway.app',
      mentions_hosting_item4: 'Armazenamento de ficheiros: Supabase Storage (AWS S3)',
      mentions_payment_title: 'Prestador de pagamento',
      mentions_payment_text: 'Stripe Inc. – 510 Townsend Street, San Francisco, CA 94103, USA - Certificado PCI-DSS nível 1. Recash não armazena nenhum dado de cartão bancário.',
      mentions_ip_title: 'Propriedade intelectual',
      mentions_ip_text: 'A aplicação Recash, o seu logótipo, textos e funcionalidades são propriedade exclusiva da Recash Inc. Qualquer reprodução sem autorização escrita prévia é proibida.'
    },
    guide: {
      title: 'Guia de utilização',
      complete_guide: 'Guia completo',
      subtitle: 'Tudo o que precisa saber para usar o Recash',
      section_scan_ticket_title: 'Digitalizar um talão',
      section_scan_ticket_desc: 'Como digitalizar os seus talões para obter cashback e acompanhar as suas despesas.',
      section_scan_product_title: 'Digitalizar um produto',
      section_scan_product_desc: 'Analise qualquer produto por código de barras para conhecer a sua composição e pontuações.',
      section_scores_title: 'Compreender as pontuações',
      section_scores_desc: 'Nutri-Score, NOVA, Eco-Score... tudo sobre indicadores de qualidade.',
      section_cashback_title: 'O Cashback',
      section_cashback_desc: 'Como funciona o cashback, prazos e levantamentos.',
      section_ethical_title: 'Pontos Éticos',
      section_ethical_desc: 'Ganhe pontos escolhendo alternativas ecoresponsáveis.',
      section_alerts_title: 'Alertas e Recalls',
      section_alerts_desc: 'Mantenha-se informado sobre recalls de produtos, garantias e alertas personalizados.',
      section_faq_title: 'Perguntas frequentes',
      section_faq_desc: 'As perguntas mais frequentes sobre Recash.',
      scan_ticket_step1_title: 'Tirar uma foto',
      scan_ticket_step1_desc: 'Coloque o seu talão plano sobre um fundo uniforme. Certifique-se de que a foto seja nítida e bem iluminada, sem reflexos.',
      scan_ticket_step2_title: 'Importar a imagem',
      scan_ticket_step2_desc: 'Pode tirar uma foto diretamente da app ou importar uma imagem da sua galeria. Os PDF também são aceites.',
      scan_ticket_step3_title: 'Análise automática',
      scan_ticket_step3_desc: 'A nossa IA analisa o seu talão em segundos: loja, data, montante total e cada artigo com o seu preço.',
      scan_ticket_step4_title: 'Descubra os seus ganhos',
      scan_ticket_step4_desc: 'Recash procura automaticamente as ofertas de cashback disponíveis nas suas compras. Vê instantaneamente o montante que pode recuperar.',
      scan_ticket_step5_title: 'Valide e acompanhe',
      scan_ticket_step5_desc: 'Confirme as informações e acompanhe a evolução dos seus cashbacks na sua wallet. Os fundos são creditados em 48h.',
      scan_product_step1_title: 'Digitalizar o código de barras',
      scan_product_step1_desc: 'Use a câmara do seu telemóvel para digitalizar o código de barras de um produto. Também pode introduzir o código manualmente.',
      scan_product_step2_title: 'Análise instantânea',
      scan_product_step2_desc: 'Recash consulta a base Open Food Facts e mostra: Nutri-Score, NOVA, Eco-Score, ingredientes, alergénios, aditivos.',
      scan_product_step3_title: 'Verificar os alertas',
      scan_product_step3_desc: 'Se o produto contiver um alergénio declarado no seu perfil, aparece um alerta vermelho imediatamente.',
      scan_product_step4_title: 'Comparar alternativas',
      scan_product_step4_desc: 'Descubra produtos alternativos melhor pontuados, mais baratos ou mais saudáveis disponíveis na sua região.',
      score_nutri_name: 'Nutri-Score',
      score_nutri_desc: 'Avalia a qualidade nutricional global de um produto de A (melhor) a E (pior). Baseado em nutrientes e alimentos a favorecer/limitar.',
      score_nova_name: 'NOVA',
      score_nova_desc: 'Classifica os alimentos segundo o seu grau de transformação: 1 (cru) a 4 (ultra-transformado). Prefira as pontuações 1 e 2.',
      score_eco_name: 'Eco-Score',
      score_eco_desc: 'Classifica o impacto ambiental do produto de A (impacto muito baixo) a E (impacto muito elevado). Tem em conta a embalagem, o transporte, a produção.',
      score_health_name: 'Pontuação de Saúde',
      score_health_desc: 'Pontuação personalizada baseada no seu perfil de saúde (alergénios, dietas).',
      wallet_step1_title: 'Acumular cashback',
      wallet_step1_desc: 'Scaneie tickets e receba cashbacks automaticamente na sua wallet.',
      wallet_step2_title: 'Verificar o saldo',
      wallet_step2_desc: 'Consulte o seu saldo e o histórico de transações na secção Wallet.',
      wallet_step3_title: 'Levantar dinheiro',
      wallet_step3_desc: 'Levante o seu dinheiro via PayPal ou virement bancário.',
      shopping_step1_title: 'Criar lista',
      shopping_step1_desc: 'Adicione itens manualmente ou importe produtos do seu último ticket.',
      shopping_step2_title: 'Digitalizar para adicionar',
      shopping_step2_desc: 'Digitalize o código de barras de um produto para o adicionar com informações nutricionais.',
      shopping_step3_title: 'Gerir em movimento',
      shopping_step3_desc: 'Marque itens ao comprar. Ajuste quantidades, remova itens indesejados.',
      shopping_step4_title: 'Partilhar lista',
      shopping_step4_desc: 'Envie a sua lista para família ou amigos com um toque. Ideal para compras partilhadas.',
      budget_set_title: 'Definir orçamento',
      budget_set_desc: 'Defina um orçamento mensal global em Perfil → Orçamento. Recash calcula as despesas automaticamente.',
      budget_categories_title: 'Categorias',
      budget_categories_desc: 'As suas despesas são categorizadas automaticamente (alimentação, farmácia, eletrónica...) para um acompanhamento preciso.',
      budget_alert_title: 'Alertas de orçamento',
      budget_alert_desc: 'Receba uma notificação quando se aproxima do limite mensal.',
      budget_monthly_title: 'Visão mensal',
      budget_monthly_desc: 'Veja a sua visão mensal com comparação ao mês anterior e gráfico de despesas.',
      antiwaste_packaging_title: 'Embalagem responsável',
      antiwaste_packaging_desc: 'Recash sugere alternativas com melhor embalagem (cartão, vidro, sem embalagem) para reduzir o seu plástico.',
      antiwaste_local_title: 'Preferir local',
      antiwaste_local_desc: 'Para frutas, legumes e produtos frescos, escolher local reduz a pegada de carbono e apoia a economia regional.',
      antiwaste_seasonal_title: 'Produtos sazonais',
      antiwaste_seasonal_desc: 'Recash identifica produtos fora de época e sugere alternativas sazonais, melhores para o ambiente e sabor.',
      antiwaste_alternatives_title: 'Alternativas ecológicas',
      antiwaste_alternatives_desc: 'Descubra produtos similares com melhor Eco-Score ou impacto ambiental reduzido na sua região.',
      ethical_what_title: 'O que são Pontos Éticos?',
      ethical_what_desc: 'Pontos Éticos recompensam as suas escolhas de consumo responsável. Quando digitaliza um produto e existe uma alternativa mais ecológica, ganha pontos.',
      ethical_how_title: 'Como ganhar?',
      ethical_how_desc: 'Digitalize produtos e escolha as alternativas recomendadas. Quanto mais virtuosa a alternativa (bio, local, sem embalagem, comércio justo), mais pontos ganha.',
      ethical_value_title: 'Valor dos pontos',
      ethical_value_desc: 'Cada ponto ético tem um valor monetário. Pode acumulá-los e convertê-los. O máximo é de 100 pontos por mês.',
      ethical_availability_title: 'Disponibilidade',
      ethical_availability_desc: 'Pontos Éticos estão atualmente disponíveis apenas no Canadá. Estamos a trabalhar para estender a outros países.',
      coming_next_version: 'Disponível na próxima versão',
      ethical_coming_soon_desc: 'Pontos Éticos serão introduzidos na próxima atualização do Recash. Fique atento!',
      alert_recalls_title: 'Retrocessos de produtos',
      alert_recalls_desc: 'Receba uma notificação imediata se um produto que comprou estiver sujeito a um retrocesso sanitário (listeria, salmonela, corpo estranho, etc.).',
      alert_warranty_title: 'Garantias',
      alert_warranty_desc: 'Acompanhe as datas de garantia das suas compras. Receba um alerta antes da expiração.',
      alert_allergens_title: 'Alergénios',
      alert_allergens_desc: 'Declare as suas alergias no seu perfil. Recash avisa automaticamente se um produto digitalizado contiver um alergénio perigoso.',
      alert_price_title: 'Anomalias de preço',
      alert_price_desc: 'Se o preço digitalizado no seu ticket diferir significativamente do preço habitual ou do preço exibido na loja, é gerado um alerta.',
      guide_faq_q1: 'A digitalização de produto é gratuita?',
      guide_faq_a1: 'Sim, completamente gratuita e ilimitada. Pode digitalizar todos os produtos na loja para verificar a sua qualidade sem subscrição.',
      guide_faq_q2: 'Quantos tickets posso digitalizar gratuitamente?',
      guide_faq_a2: '10 talões cashback por mês com o plano Gratuito. 50 talões cashback por mês com o plano Premium.',
      guide_faq_q3: 'Como são detetados os alergénios?',
      guide_faq_a3: 'Recash compara a composição do produto (via Open Food Facts) com o seu perfil de saúde e o da sua família. Em caso de correspondência, aparece um alerta vermelho.',
      guide_faq_q4: 'Posso usar Recash sem conta?',
      guide_faq_a4: 'Sim, apenas para digitalização de produto. Para guardar os seus tickets, receber cashbacks e usar a wallet, é necessária uma conta (gratuita).',
      guide_faq_q5: 'Como altero o meu plano de subscrição?',
      guide_faq_a5: 'Vá a Perfil → Subscrição → Alterar plano. A atualização é imediata. O cancelamento tem efeito no final do período de faturação.',
      guide_faq_q6: 'O meu ticket não é reconhecido corretamente',
      guide_faq_a6: 'Verifique se a imagem é clara, bem iluminada e se o ticket está plano. Evite reflexos. Tente recortar manualmente ou tentar novamente a digitalização.',
      guide_faq_q7: 'A app não deteta o meu alergénio',
      guide_faq_a7: 'Verifique se o alergénio está declarado no seu perfil (Perfil → Alergias). Se o produto não estiver no Open Food Facts, não pode ser analisado.',
      cta_title: 'Pronto para começar?',
      cta_desc: 'Digitalize agora o seu primeiro ticket ou produto',
      cta_scan_ticket: 'Digitalizar um ticket',
      cta_scan_product: 'Digitalizar um produto'
    },
    support: {
      nav_title: 'Como navegar na app',
      nav_step_1_title: 'Barra de navegação (em baixo)',
      nav_step_1_desc: 'Use a barra de separadores na parte inferior do ecrã para navegar entre as secções principais:',
      nav_home: 'Início: Visão geral das suas poupanças e alertas',
      nav_scan: 'Digitalizar: Digitalizar talões ou produtos',
      nav_tickets: 'Talões: Histórico dos seus talões digitalizados',
      nav_wallet: 'Carteira: Saldo e transações de cashback',
      nav_alerts: 'Alertas: Retiradas de produtos e alergénios',
      nav_profile: 'Perfil: Definições e subscrição',
      nav_step_2_title: 'Fluxo de utilização típico',
      nav_step_2_1: 'Digitalize um talão via o separador Digitalizar',
      nav_step_2_2: 'Visualize o resultado e produtos detetados',
      nav_step_2_3: 'Confirme para guardar em Talões',
      nav_step_2_4: 'Os cashbacks são adicionados automaticamente à sua carteira',
      nav_step_2_5: 'Os alertas aparecem em Alertas',
      nav_step_3_title: 'Acesso à ajuda',
      nav_step_3_desc: 'Pode aceder a esta página de ajuda a partir de:',
      nav_step_3_1: 'O ecrã inicial (Onboarding)',
      nav_step_3_2: 'A página "Sobre" no Perfil',
      page_title: 'Ajuda e Suporte',
      hero_title: 'Como podemos ajudar?',
      faq_label: 'Perguntas frequentes',
      contact_label: 'Contacto direto',
      email_support: 'Suporte por email',
      response_time: 'Resposta dentro de 48h (dias úteis)',
      premium_priority: 'Subscritores Premium/Business: resposta prioritária',
      send_msg_label: 'Enviar mensagem',
      your_email: 'O seu email',
      subject: 'Assunto',
      message_label: 'Mensagem',
      send_msg: 'Enviar mensagem',
      useful_links: 'Links úteis',
      documentation: 'Documentação',
      legal_cgu_link: 'Mencões legais e CGU',
      fill_required: 'Por favor preencha o email e a mensagem.',
      msg_sent: 'Mensagem enviada! Responderemos dentro de 48h.'
    },
    faq: {
      category_scan_product: 'Digitalização de produto',
      category_scan_ticket: 'Digitalização de talão',
      category_accounts: 'Contas e subscrições',
      category_technical: 'Problemas técnicos',
      scan_product_q1: 'A digitalização de produto é gratuita?',
      scan_product_a1: 'Sim, completamente gratuita e ilimitada. Pode digitalizar todos os produtos na loja para verificar a sua qualidade (alergénios, aditivos, Nutri-Score, NOVA) sem qualquer subscrição.',
      scan_product_q2: 'Como são detetados os alergénios?',
      scan_product_a2: 'Recash compara a composição do produto (via Open Food Facts e etiquetas) com o seu perfil de saúde e o da sua família. Em caso de correspondência, aparece um alerta vermelho imediatamente.',
      scan_ticket_q1: 'Quantos talões posso digitalizar gratuitamente?',
      scan_ticket_a1: '10 talões cashback por mês com o plano Gratuito. 50 talões cashback por mês com o plano Premium.',
      scan_ticket_q2: 'Como funciona o cashback?',
      scan_ticket_a2: 'Recash digitaliza o seu talão, procura ofertas ativas entre as marcas parceiras (Pampers, Danone, etc.) e submete automaticamente o pedido. Recebe o dinheiro na sua wallet Recash em 48h.',
      scan_ticket_q3: 'Por que existe uma comissão no cashback?',
      scan_ticket_a3: 'Recash cobra uma comissão (configurável pelo administrador, atualmente 20%) para: desenvolver e manter a aplicação, pagar APIs de terceiros (Open Food Facts, Google Vision, etc.), e oferecer suporte rápido. Recebe sempre a maioria do cashback (geralmente 80%).',
      accounts_q1: 'Posso usar Recash sem conta?',
      accounts_a1: 'Sim, apenas para digitalização de produto. Para guardar os seus talões, receber cashbacks e usar a wallet, é necessária uma conta (gratuita).',
      accounts_q2: 'Como altero o meu plano de subscrição?',
      accounts_a2: 'Vá a Perfil → Subscrição → Alterar plano. A atualização é imediata. O cancelamento tem efeito no final do período de faturação.',
      technical_q1: 'O meu talão não é reconhecido corretamente',
      technical_a1: 'Verifique se a imagem é clara, bem iluminada e se o talão está plano. Evite reflexos. Tente recortar manualmente ou tentar novamente a digitalização. Se o problema persistir, contacte o suporte com uma captura de ecrã.',
      technical_q2: 'A app não deteta o meu alergénio',
      technical_a2: 'Verifique se o alergénio está declarado no seu perfil (Perfil → Alergias). Se o produto não estiver no Open Food Facts, não pode ser analisado. Pode reportar o produto via a app para enriquecer a base.'
    }
  },
}

export function useI18n() {
  const locale = ref(localStorage.getItem('receiptai_locale') || 'fr')

  const t = (key: string) => {
    const keys = key.split('.')
    let value: any = translations[locale.value as keyof typeof translations]
    for (const k of keys) {
      value = value?.[k]
    }
    return value || key
  }

  const setLocale = (lang: string) => {
    if (translations[lang as keyof typeof translations]) {
      locale.value = lang
      localStorage.setItem('receiptai_locale', lang)
      window.location.reload()
    }
  }
  
  return { t, setLocale, locale }
}
